var previewImagesData;
var views = 3;

var basePath;

var ajaxPath;
var checkChangeMaterial = true;
var actPartsColorGroup = {};
var designImageId = 0;
var defaultTrigger = false;

var siteUrl;
var siteToolUrl = "customize-tool";

var currImage = 0;
var brogue1Status = false;
var brogue2Status = false;
var RivetgoldStatus = false;
var RivetsilverStatus = false;
var perforation2status = false;
var strapStatus = false;
var activeMaterialName;

var myData = {};
var flag = true;
var loaderFlag = true;
var keepLoaderFlag = false;

//product global variable
var mainProductId;
var editFlag = false;

//end

var areaMap = {};
var allPanels = [];
var allProductData;

var currView = "1";
var size_flag;
var cartFlag = false;
var blankImg = "//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/blank.png";

var matrialDescrip = {
  matrialDescrip: {
    0: {
      name: "SOFT LEATHER",
      descrip:
        "Versatile material, suitable for all seasons, recommended for day and night looks.",
    },
    1: {
      name: "VELVET LEATHER",
      descrip:
        "Versatile material, suitable for all seasons, recommended for chic looks.",
    },
    2: {
      name: "CROC PRINT LEATHER",
      descrip:
        "Versatile material, suitable for all seasons, best choice for bold looks.",
    },
    3: {
      name: "PATENT LEATHER",
      descrip:
        "Versatile material, suitable for all seasons, recommended for statement looks.",
    },
    4: {
      name: "AGED LEATHER",
      descrip:
        "Thick and texturized material, not recommended for hot weather.",
    },
    5: {
      name: "NUBUK LEATHER",
      descrip: "Thick and smooth material, not recommended for hot weather.",
    },
    6: {
      name: "FABRIC",
      descrip: "Thin cotton based material, not recommended for winter season.",
    },
    7: { name: "LACES 1", descrip: "Primary pair of shoelaces." },
    8: { name: "LACES 2", descrip: "Secondary pair of shoelaces." },
    9: { name: "BUCKLE", descrip: "Metallic part." },
    10: { name: "BLOCK", descrip: "Block Heel Versatile and comfortable heel." },
  },
};

var prodDefaultColor = {
  prod1463683329: {
    10: { matid: "10", colorid: "433" },
    13: { matid: "13", colorid: "423" },
    17: { matid: "6", colorid: "26" },
    18: { matid: "17", colorid: "407" },
    19: { matid: "19", colorid: "419" },
  },
};

var attributeOrder = {
  10: { id: "5" },
  17: { id: "1" },
  18: { id: "2" },
  19: { id: "4" },
  13: { id: "3" },
};

//this code is for shoes decoratuion  , we have added decoration for six product now.
var decorations = {
  prod1: {
    id: "1463683329",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Boggart",
  },
  prod2: {
    id: "7632957377",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Saratoga",
  },

  prod3: {
    id: "6050500865",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "0",
    piping: "0",
    fringe: "0",
    prodName: "Nassau",
  },

  prod4: {
    id: "1465578305",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "1",
    fringe: "0",
    prodName: "Savile",
  },

  prod5: {
    id: "4221337537",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "1",
    prodName: "Oddity",
  },
  prod6: {
    id: "5419162049",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Arsenal",
  },
  prod7: {
    id: "548490182686",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Boggart Duplicate",
  },
  prod8: {
    id: "560918298654",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Sraratoga Duplicate",
  },
  prod9: {
    id: "560914563102",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Arsenal Duplicate",
  },
  prod10: {
    id: "560915906590",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "0",
    piping: "0",
    fringe: "0",
    prodName: "Nassau Duplicate",
  },
  prod11: {
    id: "560913252382",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "1",
    prodName: "Oddity Duplicate",
  },
  prod12: {
    id: "547124019230",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "1",
    fringe: "0",
    prodName: "Saville Duplicate",
  },
  prod13: {
    id: "1467857665",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Armada",
  },
  prod14: {
    id: "9977652737",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "0",
    piping: "0",
    fringe: "0",
    prodName: "Nassau Duplicate-2",
  },
  prod15: {
    id: "460972461",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "1",
    prodName: "Oddity Duplicate 2",
  },
  prod16: {
    id: "550440370206",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "1",
    fringe: "0",
    prodName: "Saville Duplicate 2",
  },
  prod17: {
    id: "5418780353",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Sraratoga Duplicate 2",
  },
  prod18: {
    id: "1267259905",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Hudson",
  },
  prod19: {
    id: "2197325185",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Saddle",
  },

  prod20: {
    id: "552167276574",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    rivet2: "1",
    piping: "0",
    fringe: "0",
    prodName: "Harlow",
  },

  prod21: {
    id: "460991377",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    rivet2: "1",
    piping: "0",
    fringe: "0",
    prodName: "Gatsby",
  },
  prod22: {
    id: "9987925889",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    rivet2: "1",
    piping: "0",
    fringe: "0",
    prodName: "Lamont",
  },

  prod23: {
    id: "9978267073",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    rivet2: "1",
    piping: "0",
    fringe: "0",
    prodName: "Gatsby Duplicate 1",
  },

  prod24: {
    id: "1466429441", //gatsby duplicate 2
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    rivet2: "1",
    piping: "0",
    fringe: "0",
    prodName: "Gatsby Duplicate 2",
  },

  prod25: {
    id: "7743501889",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Hudson", //hudson duplicate
  },

  prod26: {
    id: "1464803201",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Limehouse", //limehouse
  },

  prod27: {
    id: "4219595649",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Chelsea", //Chelsea
  },

  prod28: {
    id: "1362437832790",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Morgan", //morgan
  },

  prod29: {
    id: "6567881729",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Madeline", //Madeline
  },

  prod30: {
    id: "1358334558294",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Viennal", //Viennal
  },
  prod31: {
    id: "4219340353",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Classon", //Classon
  },
  prod32: {
    id: "1356909903958",
    noDeco: "1",
    perforation: "0",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    rivet2: "1",
    piping: "0",
    fringe: "0",
    prodName: "Lamont Duplicate", //lamont duplicate
  },

  prod33: {
    id: "1362437865558",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Viennal Duplicate", //Viennal duplicate
  },
  prod34: {
    id: "1356883951702",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Armada Duplicate", //armade duplicate
  },

  prod35: {
    id: "1357577519190",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Limehouse duplicate", //limehouse duplicate
  },

  prod36: {
    id: "460990265",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Lenox ", //lenox
  },

  astoria: {
    id: "4609724981",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Astoria", //Astoria
  },

  prod37: {
    id: "1358365491286",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Chunk Heel Holborn ", //holborn
  },

  conicHolborn: {
    id: "1358365491287",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    decorationsSource: '1358365491286',
    prodName: "Cone Heel Holborn ", //holborn
  },

  prod38: {
    id: "1357580927062",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Baron ", //baron
  },

  prod39: {
    id: "6566222337",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Duke", //Duke
  },

  prod40: {
    id: "1358467629142",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Marry", //Marry
  },

  regent: {
    id: "462675009",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Regent", //Regent
  },

  jane: {
    id: "6567772417",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Jane", //Jane
  },

  janePumps: {
    id: "461014449",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Jane Pumps", //JanePumps
  },

  burton: {
    id: "2198116929",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Burton", //Burton
  },

  aldgate: {
    id: "1464360513",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Chunk Heel Aldgate", //aldgate
  },
  conicAldgate: {
    id: "1464360529",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    decorationsSource: '1464360513',
    prodName: "Cone Heel Aldgate", //aldgate
  },

  florence: {
    id: "5418704577",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "1",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Florence",
  },

  joplin: {
    id: "5418812417",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Joplin",
  },

  joplinPumps: {
    id: "1464712769",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Joplin Pumps",
  },

  kent: {
    id: "1464581697",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    prodName: "Chunk Heel Kent",
  },

  conicKent: {
    id: "1464360553",
    noDeco: "1",
    perforation: "1",
    broguing: "1",
    broguing2: "0",
    rivet: "1",
    piping: "0",
    fringe: "0",
    decorationsSource: '1464581697',
    prodName: "Cone Heel Kent",
  }
};

var productViews = {
  views: {
    view1: {
      id: "1",
      viewimages: {
        0: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_13_Material_39_Color_423_View_1.png",
          zindex: 3,
          isicon: "",
          rel: 13,
        },
        1: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_18_Material_11_Color_336_View_1.png",
          zindex: 0,
          isicon: "",
          rel: 18,
        },
        2: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_17_Material_4_Color_4_View_1.png",
          zindex: 1,
          isicon: "",
          rel: 17,
        },
        3: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_10_Material_32_Color_432_View_1.png",
          zindex: 2,
          isicon: "",
          rel: 10,
        },
        4: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_19_Material_18_Color_419_View_1.png",
          zindex: 4,
          isicon: "",
          rel: 19,
        },
        5: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Innerlining_View_1.png",
          zindex: 4,
          isicon: "",
          rel: 0,
        },
      },
      viewicons: {
        5: {
          hover_src: "media/Locators/Locator_Material02_hover.png",
          src: "media/Locators/Locator_Material02.png",
          zindex: 0,
          isicon: "yes",
          rel: 18,
          values: [200, 173],
        },
        6: {
          hover_src: "media/Locators/Locator_Material01_hover.png",
          src: "media/Locators/Locator_Material01.png",
          zindex: 1,
          isicon: "yes",
          rel: 17,
          values: [540, 180],
        },
        7: {
          hover_src: "media/Locators/Locator_Sole_hover.png",
          src: "media/Locators/Locator_Sole.png",
          zindex: 2,
          isicon: "yes",
          rel: 10,
          values: [70, 250],
        },
        8: {
          hover_src: "media/Locators/Locator_Lace_hover.png",
          src: "media/Locators/Locator_Lace.png",
          zindex: 3,
          isicon: "yes",
          rel: 13,
          values: [354, 100],
        },
        9: {
          hover_src: "media/Locators/Locator_Eyelet_hover.png",
          src: "media/Locators/Locator_Eyelet.png",
          zindex: 4,
          isicon: "yes",
          rel: 19,
          values: [408, 170],
        },
      },
    },
    view2: {
      id: "2",
      viewimages: {
        0: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_13_Material_39_Color_423_View_2.png",
          zindex: 3,
          isicon: "",
          rel: 13,
        },
        1: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_18_Material_11_Color_336_View_2.png",
          zindex: 0,
          isicon: "",
          rel: 18,
        },
        2: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_17_Material_4_Color_4_View_2.png",
          zindex: 1,
          isicon: "",
          rel: 17,
        },
        3: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_10_Material_32_Color_432_View_2.png",
          zindex: 2,
          isicon: "",
          rel: 10,
        },

        4: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_19_Material_18_Color_419_View_2.png",
          zindex: 4,
          isicon: "",
          rel: 19,
        },
        5: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Innerlining_View_2.png",
          zindex: 4,
          isicon: "",
          rel: 0,
        },
      },
      viewicons: {
        5: {
          hover_src: "media/Locators/Locator_Material02_hover.png",
          src: "media/Locators/Locator_Material02.png",
          zindex: 0,
          isicon: "yes",
          rel: 18,
          values: [416, 180],
        },
        6: {
          hover_src: "media/Locators/Locator_Material01_hover.png",
          src: "media/Locators/Locator_Material01.png",
          zindex: 1,
          isicon: "yes",
          rel: 17,
          values: [50, 198],
        },
        7: {
          hover_src: "media/Locators/Locator_Sole_hover.png",
          src: "media/Locators/Locator_Sole.png",
          zindex: 2,
          isicon: "yes",
          rel: 10,
          values: [530, 263],
        },
        8: {
          hover_src: "media/Locators/Locator_Lace_hover.png",
          src: "media/Locators/Locator_Lace.png",
          zindex: 3,
          isicon: "yes",
          rel: 13,
          values: [293, 86],
        },
        9: {
          hover_src: "media/Locators/Locator_Eyelet_hover.png",
          src: "media/Locators/Locator_Eyelet.png",
          zindex: 4,
          isicon: "yes",
          rel: 19,
          values: [197, 178],
        },
      },
    },
    view3: {
      id: "3",
      viewimages: {
        0: {
          src:
            "media/front/product-images/product446227523/Product_446227523_Part_10_Material_32_Color_432_View_3.png",
          zindex: 0,
          isicon: "",
          rel: 10,
        },
      },
      viewicons: {
        1: {
          hover_src: "media/Locators/Locator_Sole_hover.png",
          src: "media/Locators/Locator_Sole.png",
          zindex: 0,
          isicon: "yes",
          rel: 10,
          values: [300, 200],
        },
      },
    },
  },
};

var $j;
jQuery(document).ready(function (jQuery) {
  $j = jQuery;

  //remove shopify Turbo theme classes
  $j("div.container").removeClass("container main content");

  //get all initial data
  basePath = jQuery("#basePath").val();
  baseMediaPath = jQuery("#baseMediaPath").val();
  siteUrl = basePath;
  ajaxPath = basePath + "custom-ajax/";

  sessionStorage.setItem("customize", "yes");

  //changes angle of product
  jQuery(".rotate").click(function () {
    currView = jQuery("#views").find(".active").attr("next");
    switch (jQuery(this).attr("id")) {
      case "rotate-angle-next":
        hideAllViews();

        visibleView();
        break;
    }
  });

  jQuery(".site-header #navToggle").click(function () {
    jQuery("body").toggleClass("left-menu-toolopen");
    jQuery(this).toggleClass("cross-remove");
    // display/hide mobile dropdown menu
    jQuery(".nav-mobile").toggleClass("custom-hide");
  });

  jQuery("#snapshot_it").click(function () {
    jQuery(".loader_effect").show();
    generateImage("snapshot");
  });

  jQuery("#save_user_design").on("click", function () {
    var custId = sessionStorage.getItem("customer_id");
    if (custId != "" && custId) {
      //jQuery(".loading").show();
      jQuery(".shoe-data-preloader").show();
      jQuery(".page-wrapper > .site-header").hide();
      jQuery("header").css("opacity", "0.3");
      jQuery(".tool-sec").css("opacity", "0.3");
      //site-header
      generateImage("save");
    } else {
      jQuery("#LoGIn").modal("show");
    }
  });

  jQuery(".add-to-cart").on("click", function () {
    //jQuery(".loading").show();
    if (jQuery("#sizes option:selected").text().toLowerCase() != "choose your size") {
      jQuery(".shoe-data-preloader").show();
      jQuery(".page-wrapper > .site-header").hide();
      jQuery("header").css("opacity", "0.3");
      jQuery(".tool-sec").css("opacity", "0.3");
      cartFlag = true;
      generateImage("cart");
      // saveDesign();
    } else {
      jQuery("#sizes").addClass("border-red"); //adds red border to size select when there's no size selected
      jQuery("#sizes").focus();
    }
  });

  $(document.body).on("change", "#sizes", function () {
    $("#sizes").removeClass("border-red");
  });

  $(document.body).on("click", ".climgs", function (e) {
    if(!e.isTrigger){
      $(this).closest("div.cat_boxin").find("a").first().click();
    }
  });

  $(document.body).on("click", ".tool_left_cat li .cat_boxin", function (e) {
    if(e.target == this){
      $(this).closest("div.cat_boxin").find("a").first().click();
    }
  });
});

function changeViewAttrbuteWise(actAttrId) {
  if (actAttrId == "10") {
    //sole 3
    if (mainProductId == decorations.regent.id) {
      currView = "1";
    } else {
      currView = "3";
    }
  } else if (actAttrId == "27") {
    //Zipper 2
    currView = "2";
  } else {
    // other 1

    if (currView == "3" || currView == "2") currView = "1";
  }

  hideAllViews();
  visibleView();
}

function saveDesign() {
  // jQuery(".loading").show();
  jQuery(".shoe-data-preloader").show();
  jQuery("header").css("opacity", "0.3");

  var design = getCustomizedData();
  console.log(design);

  // var decorationData = getDecorationData();

  jQuery.ajax({
    type: "POST",
    url: basePath + siteToolUrl + "/save-design-image",
    // url: ajaxPath + 'saveDesign.php',
    data: {
      design: design,

      //decorationData:decorationData
    },
    success: function (msg) {
      if (cartFlag) {
        //

        // -------------------------------------------------------------------------------------
        // POST to cart/add.js returns the JSON of the line item associated with the added item.
        // -------------------------------------------------------------------------------------
        /*Shopify.addItem = function (variant_id, quantity, product_id) {
                 var quantity = quantity || 1;
                 var product_id = product_id || 1463683329;
                 var params = {
                 type: 'POST',
                 url: '/cart/add.js',
                 data: 'quantity=' + quantity + '&product_id=' + product_id,
                 dataType: 'json',
                 success: function (line_item) {
                 Shopify.onItemAdded(line_item, product_id);
                 },
                 error: function (XMLHttpRequest, textStatus) {
                 Shopify.onError(XMLHttpRequest, textStatus);
                 }
                 };
                 jQuery.ajax(params);
                 };*/

        //

        cartFlag = false;

        createProductNew();
      } else {
        // has asked to remove this popup
        //$("#designSave").modal("show");
        myaccount_user();

        jQuery(".loading").hide();
        jQuery(".shoe-data-preloader").hide();
        jQuery("header").css("opacity", "1");
        jQuery(".tool-sec").css("opacity", "1");
        jQuery(".tool-img").css("opacity", "1");
      }
    },
  });
}

function hideAllViews() {
  jQuery(".views").hide();
  jQuery(".views").removeClass("active");
}

function visibleView() {
  jQuery("#view_" + currView).css("display", "block");
  jQuery("#view_" + currView).addClass("active");
  jQuery("#actViewName").text("View " + currView);

  // loadAngleArea();
}

function imageExists(image_url) {
  var http = new XMLHttpRequest();

  http.setRequestHeader("Access-Control-Allow-Methods", "GET, POST, OPTIONS");
  http.setRequestHeader("Access-Control-Allow-Credentials", "true");
  http.setRequestHeader(
    "Access-Control-Allow-Origin",
    "https://www.juliabo.com"
  );
  http.setRequestHeader("Access-Control-Allow-Origin", "//juliaboshop.com");
  http.setRequestHeader("Access-Control-Allow-Headers", "Content-Type");

  http.open("HEAD", image_url, false);
  http.send();

  return http.status != 404;
}

function onMoverMaterial(actObj) {
  return false;
  var currentDiv;
  var currId;

  currentDiv = jQuery(actObj).parent().parent().find(".product_info");
  currId = jQuery(currentDiv).attr("product_id");

  if (productMaterial.viewByTexture[currId].text) {
    jQuery(currentDiv).html(productMaterial.viewByTexture[currId].text);
    jQuery(currentDiv).fadeIn(200);
  }
}

function onMoutMaterial(actObj) {
  jQuery(".product_info").css({ display: "none" });
}

function removeDupIds(array) {
  var list = {},
    id;
  for (var i = 0; i < array.length; i++) {
    id = array[i].id;
    if (id in list) {
      // found a dup id, remove it
      array.splice(i, 1);
      // correct for loop index so it will process the item
      // that just moved down in place of the one we just removed
      --i;
    } else {
      // add the id to our map
      list[id] = true;
    }
  }
}

function getPartThumb(partId) {
  for (var part in allProductData["attribute_thumb"]) {
    if (allProductData["attribute_thumb"][part].shoe_attribute_id == partId) {
      //console.log("part == " + partId + " thumb img == " + allProductData["attribute_thumb"][part].image)
      return allProductData["attribute_thumb"][part].image;
    }
  }
}

function loadProductAttributes() {
  //load attribute

  var attrList = allProductData["attribute"];
  jQuery(".gallery-left-option").html("");
  for (var attr in attrList) {
    if (attrList[attr]["name"] == "size") {
      jQuery(".gallery-left-option").append(
        '<a class="tool_head" onclick="toolToggleHead(this)" href="javascript:void(0)">' +
          attrList[attr]["name"].toUpperCase() +
          '<i class="fa fa-info-circle pull-right" onclick="showSizeInfo()"></i></a><div class="tool_left_cat"><ul class="sub-menu" id="attribute_' +
          attrList[attr]["id"] +
          '"></ul></div>'
      );
    } else {
      jQuery(".gallery-left-option").append(
        '<a class="tool_head" onclick="toolToggleHead(this)" href="javascript:void(0)">' +
          attrList[attr]["name"].toUpperCase() +
          '</a><div class="tool_left_cat"><ul class="sub-menu" id="attribute_' +
          attrList[attr]["id"] +
          '"></ul></div>'
      );
    }
  }

  //load shoes parts
  var shoeParts = allProductData["shoesparts"];
  var materialCat = allProductData["materialCat"];
  var materialDescription33 = getMaterialDescription("BUCKLE");
  var colors = allProductData["colors"];
  var sizes = allProductData["size"]; //{"size1": {"size": "EU 32 | US 2.0", "id": 1}, "size2": {"size": "EU 34 | US 4.0", "id": 2}, "size3": {"size": "EU 36 | US 6.0", "id": 3}, "size4": {"size": "EU 38 | US 8.0", "id": 4}}
  var thumb;
  var laceCnt = 1;
  for (var part in shoeParts) {
    //shoeParts[part]["iconImageSrc"]

    thumb = getPartThumb(shoeParts[part]["id"]);

    console.log("Part: -> " + shoeParts[part]["id"]);

    if (thumb) {
      if (shoeParts[part]["id"] == "19") {
        //eyelet
        jQuery("#attribute_1").append(
          '<li id="part_' +
            shoeParts[part]["id"] +
            '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
            shoeParts[part]["rel"] +
            '" view="' +
            shoeParts[part]["view"] +
            '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
            shoeParts[part]["name"].toUpperCase() +
            '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img  width="20" height="20" colorid="1" rel="19" src="' +
            basePath +
            'media/front/product-color-images/1512466771.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
            thumb +
            '" alt="thumb"><h6>' +
            shoeParts[part]["name"] +
            '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer" style="display:none"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div><div class="product-typer addRemove "><h6>ADD/REMOVE</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><input type="checkbox" onchange="addEyeletImage(this)" name="eyelet"><span></span></div></td></tr></tbody></table></div></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
        ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
      } else if (shoeParts[part]["id"] == "31") {
        //elastic
        console.log("thumb img for elastic = " + thumb);
        // jQuery("#attribute_1").append('<li id="part_' + shoeParts[part]["id"] + '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' + shoeParts[part]["rel"] + '" view="' + shoeParts[part]["view"] + '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' + (shoeParts[part]["name"]).toUpperCase() + '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="31" rel="31" src="" class="thumb_pattern_img"> <img  width="20" height="20" colorid="1" rel="31" src="' + basePath + 'media/front/product-color-images/1512466771.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' + thumb + '" alt="thumb"><h6>' + shoeParts[part]["name"] + '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer" style="display:none"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div><div class="product-typer addRemove "><h6>Choose your material</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><input type="checkbox" onchange="#" name="elasticcover"><span></span></div></td></tr></tbody></table></div></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        if (mainProductId == "9987925889" || mainProductId == "1356909903958") {
          //lamont
          jQuery("#attribute_1").append(
            '<li id="part_' +
              shoeParts[part]["id"] +
              '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
              shoeParts[part]["rel"] +
              '" view="' +
              shoeParts[part]["view"] +
              '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
              shoeParts[part]["name"].toUpperCase() +
              '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="31" rel="31" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="31" src="' +
              basePath +
              'media/front/product-color-images/1525259564.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
              thumb +
              '" alt="thumb"><h6>' +
              shoeParts[part]["name"] +
              '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer"><h6>LEATHER	 COVER</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><input type="checkbox" onchange="showLamontelastic(this)" name="elasticcover"><span></span></div></td></tr></tbody></table></div><ul class="selct-material clearfix hide" style="display:none"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
          ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        } else if (mainProductId == "4219595649") {
          //chelsea
          jQuery("#attribute_1").append(
            '<li id="part_' +
              shoeParts[part]["id"] +
              '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
              shoeParts[part]["rel"] +
              '" view="' +
              shoeParts[part]["view"] +
              '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
              shoeParts[part]["name"].toUpperCase() +
              '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="31" rel="31" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="31" src="' +
              basePath +
              'media/front/product-color-images/1525259564.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
              thumb +
              '" alt="thumb"><h6>' +
              shoeParts[part]["name"] +
              '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer"><h6>LEATHER	 COVER</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><input type="checkbox" onchange="showChelseaelastic(this)" name="elasticcover"><span></span></div></td></tr></tbody></table></div><ul class="selct-material clearfix" style="display:none"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
          ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        }
      } else if (shoeParts[part]["id"] == "35") {
        //strap
        if (mainProductId == "4219340353") {
          //classon /
          jQuery("#attribute_1").append(
            '<li id="part_' +
              shoeParts[part]["id"] +
              '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
              shoeParts[part]["rel"] +
              '" view="' +
              shoeParts[part]["view"] +
              '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
              shoeParts[part]["name"].toUpperCase() +
              '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="35" rel="16" src="" class="thumb_pattern_img"> <img  width="20" height="20" colorid="1" rel="35" src="' +
              basePath +
              'media/front/product-color-images/1512466771.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
              thumb +
              '" alt="thumb"><h6>' +
              shoeParts[part]["name"] +
              '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer" style="display:none"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div><div class="product-typer addRemove "><h6>ADD/REMOVE</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><input type="checkbox" onchange="addStrapImage(this)" name="strap"><span></span></div></td></tr></tbody></table></div></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
          ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        } else if (mainProductId == "6567881729") {
          //madeline
          jQuery("#attribute_1").append(
            '<li id="part_' +
              shoeParts[part]["id"] +
              '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
              shoeParts[part]["rel"] +
              '" view="' +
              shoeParts[part]["view"] +
              '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
              shoeParts[part]["name"].toUpperCase() +
              '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="35" rel="16" src="" class="thumb_pattern_img"> <img  width="20" height="20" colorid="1" rel="35" src="' +
              basePath +
              'media/front/product-color-images/1512466771.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
              thumb +
              '" alt="thumb"><h6>' +
              shoeParts[part]["name"] +
              '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div><div class="product-typer addRemove" style="display:none"><h6>ADD/REMOVE</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><img src="' +
              allProductData["materialCat"]["cat2"].src +
              '" alt="thumb"><span></span></div></td></tr></tbody></table></div></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
          ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        }
      } else if (shoeParts[part]["id"] == "27") {
        //zipper
        jQuery("#attribute_1").append(
          '<li id="part_' +
            shoeParts[part]["id"] +
            '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
            shoeParts[part]["rel"] +
            '" view="' +
            shoeParts[part]["view"] +
            '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
            shoeParts[part]["name"].toUpperCase() +
            '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="27" rel="16" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="27" src="' +
            basePath +
            'media/front/product-color-images/1512821872.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
            thumb +
            '" alt="thumb"><h6>' +
            shoeParts[part]["name"] +
            '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer" style="display:none"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div><div class="product-typer addRemove "><h6>ADD/REMOVE</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><input type="checkbox" checked onchange="addZipperImage(this)" name="zipper"><span></span></div></td></tr></tbody></table></div></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
        ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
      } else if (shoeParts[part]["id"] == "13") {
        jQuery("#attribute_1").append(
          '<li id="part_' +
            shoeParts[part]["id"] +
            '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
            shoeParts[part]["rel"] +
            '" view="' +
            shoeParts[part]["view"] +
            '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
            shoeParts[part]["name"].toUpperCase() +
            '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="16" src="' +
            basePath +
            'media/front/product-color-images/1512821872.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
            thumb +
            '" alt="thumb"><h6>' +
            shoeParts[part]["name"] +
            '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer"><h6>SELECT YOUR LACES</h6><ul class="selct-material clearfix"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
        ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
      } else if (shoeParts[part]["id"] == "32") {
        //rear tab
        if (
          mainProductId == "4219595649" ||
          mainProductId == "4219340353" ||
          mainProductId == "9987925889" ||
          mainProductId == "1356909903958" ||
          mainProductId == decorations.regent.id ||
          mainProductId == decorations.burton.id
        ) {
          //chelsea
          jQuery("#attribute_1").append(
            '<li id="part_' +
              shoeParts[part]["id"] +
              '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
              shoeParts[part]["rel"] +
              '" view="' +
              shoeParts[part]["view"] +
              '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
              shoeParts[part]["name"].toUpperCase() +
              '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img  width="20" height="20" colorid="1" rel="19" src="' +
              basePath +
              'media/front/product-color-images/1512466771.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
              thumb +
              '" alt="thumb"><h6>' +
              shoeParts[part]["name"] +
              '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer" style="display:none"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div><div class="product-typer addRemove "><h6>ADD/REMOVE</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><input type="checkbox" onchange="addRearTab(this)" checked name="reartab"><span></span></div></td></tr></tbody></table></div></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
          ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        } else {
          jQuery("#attribute_1").append(
            '<li id="part_' +
              shoeParts[part]["id"] +
              '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
              shoeParts[part]["rel"] +
              '" view="' +
              shoeParts[part]["view"] +
              '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
              shoeParts[part]["name"].toUpperCase() +
              '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="16" src="' +
              basePath +
              'media/front/product-color-images/1512821872.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
              thumb +
              '" alt="thumb"><h6>' +
              shoeParts[part]["name"] +
              '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
          ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        }
      } else if (shoeParts[part]["id"] == "33") {
        //buckle
        jQuery("#attribute_1").append(
          '<li id="part_' +
            shoeParts[part]["id"] +
            '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
            shoeParts[part]["rel"] +
            '" view="' +
            shoeParts[part]["view"] +
            '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
            shoeParts[part]["name"].toUpperCase() +
            '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="16" src="' +
            basePath +
            'media/front/product-color-images/1512821872.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
            thumb +
            '" alt="thumb"><h6>' +
            shoeParts[part]["name"] +
            '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">' +
            materialDescription33 +
            '</div></div></div><div class="product-typer"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
        ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
      } else if (shoeParts[part]["id"] == "26") {
        //fringe
        jQuery("#attribute_1").append(
          '<li id="part_' +
            shoeParts[part]["id"] +
            '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
            shoeParts[part]["rel"] +
            '" view="' +
            shoeParts[part]["view"] +
            '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
            shoeParts[part]["name"].toUpperCase() +
            '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img  width="20" height="20" colorid="1" rel="19" src="' +
            basePath +
            'media/front/product-color-images/1512466771.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
            thumb +
            '" alt="thumb"><h6>' +
            shoeParts[part]["name"] +
            '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer" style="display:none"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div><div class="product-typer addRemove "><h6>ADD/REMOVE</h6><div class="holder"> <table width="100%"><tbody><tr><td><div><input type="checkbox" onchange="addFringeImage(this)" name="fringe"><span></span></div></td></tr></tbody></table></div></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
        ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
      } else {
        if(mainProductId === decorations.kent.id && shoeParts[part]["id"] == "10"){
          jQuery("#attribute_1").append(
            '<li id="part_' +
              shoeParts[part]["id"] +
              '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
              shoeParts[part]["rel"] +
              '" view="' +
              shoeParts[part]["view"] +
              '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
              shoeParts[part]["name"].toUpperCase() +
              '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="16" src="' +
              basePath +
              'media/front/product-color-images/1512821872.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
              thumb +
              '" alt="thumb"><h6>' +
              shoeParts[part]["name"] +
              '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Sole</a><div class="description">' +
              'Rubber Sole Versatile and comfortable sole, suitable for all seasons.' +
              '</div></div></div><div class="product-typer"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
          ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        }else if(mainProductId === decorations.conicKent.id && shoeParts[part]["id"] == "10"){
            jQuery("#attribute_1").append(
              '<li id="part_' +
                shoeParts[part]["id"] +
                '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
                shoeParts[part]["rel"] +
                '" view="' +
                shoeParts[part]["view"] +
                '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
                shoeParts[part]["name"].toUpperCase() +
                '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="16" src="' +
                basePath +
                'media/front/product-color-images/1512821872.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
                thumb +
                '" alt="thumb"><h6>' +
                shoeParts[part]["name"] +
                '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Sole</a><div class="description">' +
                'Rubber Sole Versatile and comfortable sole, suitable for all seasons.' +
                '</div></div></div><div class="product-typer"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
            );
        }else{
          jQuery("#attribute_1").append(
            '<li id="part_' +
              shoeParts[part]["id"] +
              '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
              shoeParts[part]["rel"] +
              '" view="' +
              shoeParts[part]["view"] +
              '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
              shoeParts[part]["name"].toUpperCase() +
              '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="16" src="' +
              basePath +
              'media/front/product-color-images/1512821872.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
              thumb +
              '" alt="thumb"><h6>' +
              shoeParts[part]["name"] +
              '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">' +
              shoeParts[part]["name"].toUpperCase() +
              '</div></div></div><div class="product-typer"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
          ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
        }
      }
    } else {
      jQuery("#attribute_1").append(
        '<li id="part_' +
          shoeParts[part]["id"] +
          '" onmouseover="attrHoverIn(this,event)" onmouseout="attrHoverOut(this,event)"><div class="cat_boxin imagheight"><a rel="' +
          shoeParts[part]["rel"] +
          '" view="' +
          shoeParts[part]["view"] +
          '" onclick="shoesPartClick(this)" href="javascript:void(0)" class="clearfix attr_list_name" >' +
          shoeParts[part]["name"].toUpperCase() +
          '</a><div class="climgs">  <img alt="Smooth/Lisse" patternid="19" rel="16" src="" class="thumb_pattern_img"> <img width="20" height="20" colorid="1" rel="16" src="' +
          basePath +
          'media/front/product-color-images/1512821872.png" alt="Camel" class="thumb_color_img"></div><div class="inter-design-way"><ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
          shoeParts[part]["iconImageSrc"] +
          '" alt="thumb"><h6>' +
          shoeParts[part]["name"] +
          '</h6></div></li><li><div class="hover_container"><div class="hover_popup"><p><img src="" alt="image"></p><p class="colorName">Color Name</p></div><div class="hover_popup_material"><a>Soft Leather</a><div class="description">croc print leathercroc print leathercroc print leathercroc print leathercroc print leather</div></div></div><div class="product-typer"><h6>Choose Your material</h6><ul class="selct-material clearfix"></ul></div></li><li><div class="product-typer"> <h6>Choose Your Color</h6>  <ul class="scaprt-codes clearfix" class="" style="display: block;"></ul></div</li></ul></div></li></div>'
      ); //https://www.o-singuliers.com/media/color_images/logo_cuir.png
    }

    for (var cat in materialCat) {
      //load materials
      if (materialCat[cat]["parent"] == shoeParts[part]["id"]) {
        var sttus = materialCat[cat]["material_status"];

        if (shoeParts[part]["id"] == "13") {
          if (sttus == "0") {
            //jQuery("#part_" + shoeParts[part]["id"]).find(".selct-material").append('<li><a href="javascript:void(0)" title="' + (materialCat[cat]["material_name"]).toLowerCase() + '" onclick="showMaterialColor(this)" mat-id="' + materialCat[cat]["id"] + '"><img src="' + materialCat[cat]["src"] + '" alt="Material"></a><div class="st-tooltip"><img src="' + materialCat[cat]["src"]+'" alt="alt-img"/> <p>'+materialCat[cat]["material_name"]+'</p></div></li>');
            jQuery("#part_" + shoeParts[part]["id"])
              .find(".selct-material")
              .append(
                '<li titlelm="' +
                  materialCat[cat]["material_name"].toLowerCase().trim() +
                  '" style="opacity:0.3;pointer-events:none;" mat-id="' +
                  materialCat[cat]["id"] +
                  '" onmouseover="materialHoverIn(this)" onmouseout="materialHoverOut(this)"><a style="cursor: default;" href="javascript:void(0)" titlel="' +
                  materialCat[cat]["material_name"].toLowerCase().trim() +
                  '" onclick="showMaterialColor(this)" mat-id="' +
                  materialCat[cat]["id"] +
                  '"><img src="' +
                  materialCat[cat]["src"] +
                  '" alt="Material"></a><p>' +
                  laceCnt +
                  "</p></li>"
              );
            laceCnt++;
          } else {
            //jQuery("#part_" + shoeParts[part]["id"]).find(".selct-material").append('<li><a href="javascript:void(0)" title="' + (materialCat[cat]["material_name"]).toLowerCase() + '" onclick="showMaterialColor(this)" mat-id="' + materialCat[cat]["id"] + '"><img src="' + materialCat[cat]["src"] + '" alt="Material"></a><div class="st-tooltip"><img src="' + materialCat[cat]["src"]+'" alt="alt-img"/> <p>'+materialCat[cat]["material_name"]+'</p></div></li>');
            jQuery("#part_" + shoeParts[part]["id"])
              .find(".selct-material")
              .append(
                '<li titlelm="' +
                  materialCat[cat]["material_name"].toLowerCase().trim() +
                  '" style="opacity:1;pointer-events:auto;" mat-id="' +
                  materialCat[cat]["id"] +
                  '" onmouseover="materialHoverIn(this)" onmouseout="materialHoverOut(this)"><a style="cursor: pointer;" href="javascript:void(0)" titlel="' +
                  materialCat[cat]["material_name"].toLowerCase().trim() +
                  '" onclick="showMaterialColor(this)" mat-id="' +
                  materialCat[cat]["id"] +
                  '"><img src="' +
                  materialCat[cat]["src"] +
                  '" alt="Material"></a><p>' +
                  laceCnt +
                  "</p></li>"
              );
            laceCnt++;
          }
        } else {
          if (sttus == "0") {
            //jQuery("#part_" + shoeParts[part]["id"]).find(".selct-material").append('<li><a href="javascript:void(0)" title="' + (materialCat[cat]["material_name"]).toLowerCase() + '" onclick="showMaterialColor(this)" mat-id="' + materialCat[cat]["id"] + '"><img src="' + materialCat[cat]["src"] + '" alt="Material"></a><div class="st-tooltip"><img src="' + materialCat[cat]["src"]+'" alt="alt-img"/> <p>'+materialCat[cat]["material_name"]+'</p></div></li>');
            jQuery("#part_" + shoeParts[part]["id"])
              .find(".selct-material")
              .append(
                '<li titlelm="' +
                  materialCat[cat]["material_name"].toLowerCase().trim() +
                  '" style="opacity:0.3;pointer-events:none;" mat-id="' +
                  materialCat[cat]["id"] +
                  '" onmouseover="materialHoverIn(this)" onmouseout="materialHoverOut(this)"><a style="cursor: default;" href="javascript:void(0)" titlel="' +
                  materialCat[cat]["material_name"].toLowerCase().trim() +
                  '" onclick="showMaterialColor(this)" mat-id="' +
                  materialCat[cat]["id"] +
                  '"><img src="' +
                  materialCat[cat]["src"] +
                  '" alt="Material"></a></li>'
              );
          } else {
            //jQuery("#part_" + shoeParts[part]["id"]).find(".selct-material").append('<li><a href="javascript:void(0)" title="' + (materialCat[cat]["material_name"]).toLowerCase() + '" onclick="showMaterialColor(this)" mat-id="' + materialCat[cat]["id"] + '"><img src="' + materialCat[cat]["src"] + '" alt="Material"></a><div class="st-tooltip"><img src="' + materialCat[cat]["src"]+'" alt="alt-img"/> <p>'+materialCat[cat]["material_name"]+'</p></div></li>');
            jQuery("#part_" + shoeParts[part]["id"])
              .find(".selct-material")
              .append(
                '<li titlelm="' +
                  materialCat[cat]["material_name"].toLowerCase().trim() +
                  '" style="opacity:1;pointer-events:auto;" mat-id="' +
                  materialCat[cat]["id"] +
                  '" onmouseover="materialHoverIn(this)" onmouseout="materialHoverOut(this)"><a style="cursor: pointer;" href="javascript:void(0)" titlel="' +
                  materialCat[cat]["material_name"].toLowerCase().trim() +
                  '" onclick="showMaterialColor(this)" mat-id="' +
                  materialCat[cat]["id"] +
                  '"><img src="' +
                  materialCat[cat]["src"] +
                  '" alt="Material"></a></li>'
              );
          }
        }
      }
    }

    //load colors

    for (var color in colors) {
      if (shoeParts[part]["id"] == colors[color]["parent_atr"]) {
        jQuery("#part_" + shoeParts[part]["id"])
          .find(".scaprt-codes")
          .append(
            '<li style="display: block;" class="hideColor" onclick="showColor(this)" onmouseover="colorHoverIn(this)" onmouseout="colorHoverOut(this)"><a href="javascript:void(0)" titlel="' +
              colors[color]["name"].toLowerCase() +
              '" parentid="' +
              colors[color]["parent"] +
              '" parentattr="' +
              colors[color]["parent_atr"] +
              '" color-id="' +
              colors[color]["id"] +
              '" rel="' +
              colors[color]["rel"] +
              '" class="color-list"><img src="' +
              colors[color]["image"] +
              '" alt="color"></a> </li>'
          );
      }
    }
  }

  //append brogue /hide brouge for temp
  jQuery("#part_20").hide();
  jQuery("#part_28").hide();

  //decoration section
  if (
    mainProductId == "1465578305" ||
    mainProductId == "550440370206" ||
    mainProductId == "7632957377"
  ) {
    //savile

    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("21") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "1267259905" || mainProductId == "7743501889") {
    //hudson
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  }else if(mainProductId == "7743501889"){
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  }else if(mainProductId == decorations.astoria.id){
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span></span></div><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li id="toeCap_bannerList"><div class="product-typer"><h6 id="toeCap_head">CAP TOE</h6> <div class="holder"> <table width="100%"><tr style="position: relative;"><td><img style="visibility: hidden;" src="//cdn.shopify.com/s/files/1/0805/5969/t/59/assets/perf_thumb.png?v=140574900195999999591671027387"></td><td style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);"><div id="toeCap"><input name="toecap" onchange="addtoeCapImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  }else if (mainProductId == "1362437832790") {
    //morgan
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "1358365491286" || mainProductId == decorations.conicHolborn.id) {
    //holborn
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == decorations.aldgate.id || mainProductId == decorations.conicAldgate.id) {
    //aldgate
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span>1</span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  }
  else if (mainProductId == decorations.kent.id) {
    //kent
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  }
  else if (mainProductId == decorations.conicKent.id) {
    //kent
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  }
  else if (mainProductId == decorations.florence.id) {
    //florence
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span>1</span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == decorations.joplin.id || mainProductId == decorations.joplinPumps.id) {
    //joplin
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "1358467629142") {
    //Marry
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "460990265") {
    //lenox
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == decorations.regent.id) {
    //regent
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == decorations.burton.id) {
    //burton
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li id="toeCap_bannerList"><div class="product-typer"><h6 id="toeCap_head">CAP TOE</h6> <div class="holder"> <table width="100%"><tr><td></td><td style="padding-top:28px;"><div id="toeCap"><input name="toecap" onchange="addtoeCapImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (
    mainProductId == "1357580927062" ||
    mainProductId == "6566222337"
  ) {
    //baron//duke
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li id="toeCap_bannerList"><div class="product-typer"><h6 id="toeCap_head">CAP TOE</h6> <div class="holder"> <table width="100%"><tr><td></td><td style="padding-top:28px;"><div id="toeCap"><input name="toecap" onchange="addtoeCapImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == decorations.jane.id || mainProductId == decorations.janePumps.id) {
    //jane
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li id="toeCap_bannerList"><div class="product-typer"><h6 id="toeCap_head">CAP TOE</h6> <div class="holder"> <table width="100%"><tr><td></td><td style="padding-top:28px;"><div id="toeCap"><input name="toecap" onchange="addtoeCapImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "6567881729") {
    //Madeline
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "4219340353") {
    //classon
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div><div><input name="brouge" onchange="addBrogueImage2Lamont(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
    jQuery("#part_33").hide();
  } else if (
    mainProductId == "1358334558294" ||
    mainProductId == "1362437865558"
  ) {
    //Viennal
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation"  onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (
    mainProductId == "1464803201" ||
    mainProductId == "1357577519190"
  ) {
    //Limehouse
    //jQuery("#attribute_1").append('<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="'+getPartThumb("20")+'" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Broguing</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>');
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (
    mainProductId == "460991377" ||
    mainProductId == "9978267073" ||
    mainProductId == "1466429441"
  ) {
    //gatsby and dupliacategatsby
    //jQuery("#attribute_1").append('<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="'+getPartThumb("21")+'" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Broguing</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="'+getRivetColrData("colorid","gold")+'" part="21" matId="'+getRivetColrData("matid","gold")+'" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="'+getRivetColrData("colorid","silver")+'" part="21" matId="'+getRivetColrData("matid","silver")+'" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>');
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (
    mainProductId == "9987925889" ||
    mainProductId == "1356909903958"
  ) {
    //lamont
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("20") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage2Lamont(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "4219595649") {
    //Chelsea
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("28") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge2" onchange="addBrogueImage2Lamont(this)" type="checkbox" /><span></span></div><div><input name="brouge" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "552167276574") {
    //harlow
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("21") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div><div><input name="brouge2" onchange="addBrogueImage2(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    );
  } else if (mainProductId == "2197325185") {
    //saddle
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("21") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    ); /*---<input type="checkbox" name="deco" onchange="checkDecorations(this)"> --*/
  } else if (mainProductId == "1467857665") {
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("21") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne"></span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    ); /*---<input type="checkbox" name="deco" onchange="checkDecorations(this)"> --*/
  } else {
    //console.log("else part of load attributes")
    jQuery("#attribute_1").append(
      '<li id="decorations_20" onmouseout="attrHoverOut(this,event)" onmouseover="attrHoverIn(this,event)"><div class="cat_boxin imagheight" ><a href="javascript:void(0)" onclick="shoesPartClick(this)" class="attr_list_name" style="width:200px">DECORATIONS</a><div class="climgs">   </div>     <div class="inter-design-way inters-che-boxs"> <ul class="clearfix"><li><div class="product-typer product-thumber"> <img src="' +
        getPartThumb("21") +
        '" alt="thumb"><h6>Decorations</h6></div></li><li><div class="product-typer"><h6>Brogues</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Broguing_Thumb.png"  alt="checker images"/></td><td><div><input name="brouge" onchange="addBrogueImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Perforations</h6> <div class="holder"> <table width="100%"><tr><td><img src="' + $("#perf_thumb").text() + '" alt="checker images"/></td><td><div><input name="perforation" checked onchange="addPerforationImage(this)" type="checkbox" /><span class="perfOne">1</span></div><div><input name="perforation2" onchange="addPerforationImage2(this)" type="checkbox" /><span>2</span></div></td></tr></table></div></div></li><li id="rivetColorHolder"><div class="product-typer"><h6>Studs</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Rivets_Thumbs.png" alt="checker images"/></td><td id="rivetColor"><div><input class="gold" colorId="' +
        getRivetColrData("colorid", "gold") +
        '" part="21" matId="' +
        getRivetColrData("matid", "gold") +
        '" type="checkbox" name="rivetgold" onchange="addRivetImageGold(this)" /><span style="background-color: gold;"></span></div><div><input class="silver" colorId="' +
        getRivetColrData("colorid", "silver") +
        '" part="21" matId="' +
        getRivetColrData("matid", "silver") +
        '" type="checkbox" name="rivetsilver" onchange="addRivetImageSilver(this)"/><span style="background-color: silver;"></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Fringe</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Fringe_Thumb.png" alt="checker images"/></td><td><div><input name="fringe" onchange="addFringeImage(this)" type="checkbox" /><span></span></div></td></tr></table></div></div></li><li><div class="product-typer"><h6>Piping</h6> <div class="holder"> <table width="100%"><tr><td><img src="//cdn.shopify.com/s/files/1/0805/5969/t/2/assets/Piping_Thumbnail.png" alt="checker images"/></td><td><div><input type="checkbox" name="piping" onchange="addPipingImage(this)" /><span></span></div></td></tr></table></div></div></li></ul></div></div></li>'
    ); /*---<input type="checkbox" name="deco" onchange="checkDecorations(this)"> --*/
  }

  jQuery("#part_19 .thumb_color_img").hide();

  //}

  //remove css
  //jQuery(".holder table td").show()

  //act deafult material
  jQuery("#attribute_1 > li").each(function () {
    jQuery(this).find(".attr_list_name").trigger("click");

    //end
    if (jQuery(this).attr("id")) {
      var sPartr = jQuery(this).attr("id").split("_")[1];

      if (attributeOrder[sPartr]) {
        jQuery(this).attr("data-id", attributeOrder[sPartr].id);
      }
    }
  });

  //load product shoe sizes
  jQuery("#attribute_2").append(
    '<div class="custom-droper"><select class="form-control" id="sizes" onclick="changeViewAttrbuteWise()"></select></div>'
  );
  jQuery("#sizes").append(
    "<option disabled selected>Choose your size</option>"
  );
  for (var size in sizes) {
    if (sizes.hasOwnProperty(size)) {
      jQuery("#sizes").append(
        '<option id="' +
          sizes[size]["size"] +
          '">' +
          sizes[size]["size"] +
          "</option>"
      );
    }
  }
  //end

  //jQuery(".shoe-data-preloader").show();
  //jQuery(".loading").show();

  //console.log("ahdhjshlshslflsfsfhlshfslhlsfhslh")
}

function addBrogueImageLamont() {
  brogue1Status = false;
}

function addtoeCapImage(obj) {
  var chk = jQuery(obj).prop("checked");
  if (chk) {
    if (mainProductId == decorations.burton.id) {
      jQuery("#view_1").find("img[rel=38][isicon='no']").show();
      jQuery("#view_2").find("img[rel=38][isicon='no']").show();
      // set brougue2 inactive
      setDecorationStatus("brouge2", false);
      brogue2Status = false;
      if (!brogue1Status) {
        jQuery("[name='rivetgold']").prop("checked", false);
        jQuery("[name='rivetsilver']").prop("checked", false);
        jQuery("#view_1").find("img[decoration='rivet'][isicon='no']").hide();
        jQuery("#view_2").find("img[decoration='rivet'][isicon='no']").hide();
      }
    }else if(mainProductId == decorations.astoria.id){
      jQuery("#view_1").find("img[rel=38][isicon='no']").show();
      jQuery("#view_2").find("img[rel=38][isicon='no']").show();
      // set brougue2 inactive
      setDecorationStatus("brouge", false);
      brogue1Status = false;
    } else {
      jQuery("#part_29").show();
      jQuery("#view_1").find("img[rel=29][isicon='no']").show();
      jQuery("#view_2").find("img[rel=29][isicon='no']").show();
      // set brougue inactive
      setDecorationStatus("brouge", false);
      jQuery("[name='rivetgold']").prop("checked", false);
      jQuery("[name='rivetsilver']").prop("checked", false);
      jQuery("#view_1").find("img[decoration='rivet'][isicon='no']").hide();
      jQuery("#view_2").find("img[decoration='rivet'][isicon='no']").hide();
      brogue1Status = false;
    }

    showColor();
  } else {
    if (mainProductId == decorations.burton.id || mainProductId == decorations.astoria.id) {
      jQuery("#view_1").find("img[rel=38][isicon='no']").hide();
      jQuery("#view_2").find("img[rel=38][isicon='no']").hide();
    } else {
      if (brogue1Status) {
        jQuery("#part_29").show();
        jQuery("#view_1").find("img[decoration='rivet'][isicon='no']").show();
        jQuery("#view_2").find("img[decoration='rivet'][isicon='no']").show();
        jQuery("#view_1").find("img[rel=29][isicon='no']").show();
        jQuery("#view_2").find("img[rel=29][isicon='no']").show();
      } else {
        jQuery("#part_29").hide();
        jQuery("#view_1").find("img[rel=29][isicon='no']").hide();
        jQuery("#view_2").find("img[rel=29][isicon='no']").hide();
      }
    }
  }
}

function checkIfDecoImage() {
  var decoImg = jQuery("#decorations_20 .product-thumber img").attr("src");

  if (decoImg == "undefined") {
    jQuery("#decorations_20 .product-thumber img").attr(
      "src",
      jQuery("#part_17 .product-thumber img").attr("src")
    );
  }
}

function updateColorOrder() {
  //mate-1 croc
  var brown = jQuery(
    "#part_17 .color-list[titlel='brown'][parentid=5]"
  ).parent();
  var blue = jQuery("#part_17 .color-list[titlel='blue'][parentid=5]").parent();
  var red = jQuery("#part_17 .color-list[titlel='red'][parentid=5]").parent();
  var vervet = jQuery(
    "#part_17 .color-list[titlel='velve beige'][parentid=5]"
  ).parent();
  jQuery(blue).insertAfter(brown);
  jQuery(red).insertAfter(blue);
  jQuery(vervet).insertAfter(red);

  //mate-1 aged leather

  var brown1 = jQuery(
    "#part_17 .color-list[titlel='brown'][parentid=4]"
  ).parent();
  var tuscan = jQuery(
    "#part_17 .color-list[titlel='tuscan brown'][parentid=4]"
  ).parent();
  var auburn = jQuery(
    "#part_17 .color-list[titlel='auburn'][parentid=4]"
  ).parent();
  var forest = jQuery(
    "#part_17 .color-list[titlel='forest green'][parentid=4]"
  ).parent();
  var ocean = jQuery(
    "#part_17 .color-list[titlel='ocean blue'][parentid=4]"
  ).parent();

  jQuery(tuscan).insertAfter(brown1);
  jQuery(auburn).insertAfter(tuscan);
  jQuery(forest).insertAfter(ocean);
}

function getRivetColrData(data, title) {
  if (data == "colorid") {
    return jQuery("#part_21 [titlel='" + title + "']").attr("color-id");
  } else if (data == "matid") {
    return jQuery("#part_21 [titlel='" + title + "']").attr("parentid");
  }
}
function recursiveFunction(key, val) {
  actualFunction(key, val);

  var value = val["key2"];

  if (value instanceof Object) {
    jQuery.each(value, function (key, val) {
      recursiveFunction(key, val);
    });
  }
}

function actualFunction(key, val) {
  /// do stuff console.
  var matId;
  var coloId;
  var attrId;

  attrId = val["attrId"];
  coloId = val["colId"];
  matId = val["mateId"];

  if (attrId) {
    if (attrId == "13") {
      jQuery("#part_" + attrId + " .attr_list_name").trigger("click");

      jQuery(
        "#part_" + attrId + " a[mat-id=" + val["lace2MatId"] + "]"
      ).trigger("click");
      jQuery("#part_" + attrId + " a[color-id=" + val["lace2ColId"] + "]")
        .parent()
        .trigger("click");

      jQuery(
        "#part_" + attrId + " a[mat-id=" + val["lace1MatId"] + "]"
      ).trigger("click");
      jQuery("#part_" + attrId + " a[color-id=" + val["lace1ColId"] + "]")
        .parent()
        .trigger("click");
    } else {
      //actPartsColorGroup[attrId]=matId+"_"+coloId;

      jQuery("#part_" + attrId + " a[mat-id=" + attrId + "]").addClass(
        "actMaterial"
      );

      jQuery("#part_" + attrId + " a[color-id=" + coloId + "]")
        .parent()
        .addClass("actColor");

      getColorImg(attrId, coloId, matId);
    }
  }
}

function setDefaultActiveColEdit() {
  console.log("in edit....");
  sessionStorage.setItem("customizeThrough", "");

  var customizeData = getCustomizationDataofProd(mainProductId);

  jQuery.each(customizeData, function (key, val) {
    recursiveFunction(key, val);
  });

  if (mainProductId == "1362437832790") {
    //morgan
    jQuery("#part_17").find(".selct-material").find('li[mat-id="2395"]').hide();

    var bChk = jQuery(".product-typer")
      .find('input[name="brouge2"]')
      .prop("checked");
    // alert(bChk)
    if (bChk == false) {
      // alert('yes')
      jQuery("#view_1").find("img[rel=29][isicon=no]").hide();
      jQuery("#view_2").find("img[rel=29][isicon=no]").hide();
      jQuery("#part_29").hide();
    }
  }

  if (mainProductId == "1467857665") {
    //armada
    jQuery("input[name='perforation2']").parent().hide();
  }

  jQuery("#part_21").hide();

  //set attribute order
  jQuery("#part_17").insertBefore("#part_10");
  jQuery("#part_18").insertAfter("#part_17");
  jQuery("#part_29").insertAfter("#part_18");
  jQuery("#part_13").insertAfter("#part_29");
  jQuery("#decorations_20").insertAfter("#part_13");
  jQuery("#part_19").insertAfter("#part_13");
  jQuery("#decorations_20").insertBefore("#part_10");

  jQuery("#part_26").insertAfter("#decorations_20");
  jQuery("#part_27").insertBefore("#decorations_20");

  jQuery("#part_23").insertAfter("#decorations_20");
  jQuery("#part_29").insertBefore("#part_13");

  //sole at end
  jQuery("#part_10").insertAfter("#part_21");

  // jQuery("#part_10").insertAfter("#part_31");
  //jQuery("#part_31").insertBefore("#part_10");
  jQuery("#part_31").insertAfter("#part_13");
  jQuery("#part_32").insertAfter("#part_31");
  jQuery("#part_35").insertAfter("#part_32");
  jQuery("#part_33").insertAfter("#part_35");

  jQuery("#decorations_20").insertAfter("#part_33");
  jQuery("#part_10").insertAfter("#decorations_20");
  jQuery("#part_37").insertAfter("#part_10");

  jQuery("#attribute_1 li:visible:last").css({ "border-bottom": "none" });

  setTimeout(function () {
    console.log("loaded...");

    jQuery("#part_19 .attr_list_name").trigger("click");

    jQuery("#part_26 .attr_list_name").trigger("click");

    jQuery("#part_27 .attr_list_name").trigger("click");

    jQuery("#part_23 .attr_list_name").trigger("click");

    jQuery("#part_17 .attr_list_name").trigger("click");

    jQuery(".shoe-data-preloader").hide();
    jQuery(".loading").hide();
    jQuery(".loading1").hide();

    jQuery("body").css("opacity", "1");
    jQuery("header").css("opacity", "1");
    jQuery(".tool-sec").css("opacity", "1");
    jQuery(".shoe-data-preloader").hide();

    loaderFlag = false;

    editDecorationData();
  }, 2000);
}

function editDecorationData() {
  var customizeData = getCustomizationDataofProd(mainProductId);

  // alert('inside');
  if (customizeData["decoData"]["brogue2"] === "true") {
    //console.log('in brogue 2222222 edit ')
    jQuery("input[name=brouge2]").trigger("click");
  }

  var gold = customizeData["decoData"]["rivetgold"];

  if (gold === "true") {
    jQuery("input[name=rivetgold]").trigger("click");
  }

  var silver = customizeData["decoData"]["rivetsilver"];

  if (silver === "true") {
    jQuery("input[name=rivetsilver]").trigger("click");
  }

  var perf1 = customizeData["decoData"]["perforation_option1"];
  if (perf1 === "true") {
    jQuery("input[name=perforation]").trigger("click");
  }

  var perf2 = customizeData["decoData"]["perforation_option2"];

  if (perf2 === "true") {
    jQuery("input[name=perforation2]").trigger("click");
  }

  var fringe = customizeData["decoData"]["fringe"];

  if (fringe === "true") {
    jQuery("input[name=fringe]").trigger("click");
  }

  var piping = customizeData["decoData"]["piping"];

  if (piping === "true") {
    jQuery("input[name=piping]").trigger("click");
  }

  var eyelet = customizeData["decoData"]["eyelet"];

  if (eyelet === "true") {
    jQuery("input[name=eyelet]").trigger("click");
  }

  var zipper = customizeData["decoData"]["zipper"];

  if (zipper === "false") {
    jQuery("input[name=zipper]").trigger("click");
  }

  var strap = customizeData["decoData"]["strap"];

  if (strap === "true") {
    jQuery("input[name=strap]").trigger("click");
  }

  if (customizeData["decoData"]["brogue"] === "true") {
    // console.log('in brogue 1111')
    jQuery("input[name=brouge]").trigger("click");
  }
}

function setDefaultActiveColCustom() {
  sessionStorage.setItem("customizeThrough", "");

  console.log("in  setDefaultActiveColCustom ");

  //remove act color all class
  jQuery(".hideColor").removeClass("actColor");
  //remove act color all class

  jQuery(".selct-material").find(".actMaterial").removeClass("actMaterial");

  //here we adding default ids of color which we want to show for shoes when user click on customize
  //button,ly we have added it for six shoes,if you want add new shoes the you need to add it at the last
  //after oddity.
  if (mainProductId == "1463683329") {
    //boggart
    //sole
    actPartsColorGroup["10"] = "32_433"; //sole => materialid_colorid
    jQuery("[color-id=433]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 433, 32);

    //lace
    getColorImg(13, 423, 39);

    //mat 1
    actPartsColorGroup["17"] = "8_12";
    jQuery("a[mat-id=8]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=12]").parent().addClass("actColor");
    getColorImg(17, 12, 8);

    //mat 2
    actPartsColorGroup["18"] = "17_407"; //mat2
    jQuery("a[mat-id=17]").addClass("actMaterial");
    jQuery("[color-id=407]").parent().addClass("actColor");
    getColorImg(18, 407, 17);

    //eyelet
    getColorImg(19, 419, 18);

    jQuery("[name='eyelet']").trigger("click");
  } else if (mainProductId == "7632957377") {
    //saratoga

    //sole
    actPartsColorGroup["10"] = "61_769"; //sole
    jQuery("[color-id=769]").parent().addClass("actColor");
    getColorImg(10, 769, 61);

    //mat 1
    actPartsColorGroup["17"] = "45_577";
    jQuery("a[mat-id=45]").addClass("actMaterial");
    //jQuery("a[mat-id=45]").trigger("click");
    jQuery("[color-id=577]").parent().addClass("actColor");
    getColorImg(17, 577, 45);

    //mat 2
    actPartsColorGroup["18"] = "53_671"; //mat2
    jQuery("a[mat-id=53]").addClass("actMaterial");
    jQuery("[color-id=671]").parent().addClass("actColor");
    getColorImg(18, 671, 53);
  } else if (mainProductId == "6050500865") {
    //nassau

    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();
    jQuery(".perfOne").text("");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "113_1320"; //sole
    jQuery("[color-id=1320]").parent().addClass("actColor");
    getColorImg(10, 1320, 113);

    //mat 1
    actPartsColorGroup["17"] = "92_1073";
    jQuery("a[mat-id=92]").addClass("actMaterial");

    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=1073]").parent().addClass("actColor");
    getColorImg(17, 1073, 92);

    //mat 2
    actPartsColorGroup["18"] = "99_1187";
    jQuery("a[mat-id=99]").addClass("actMaterial");
    jQuery("[color-id=1187]").parent().addClass("actColor");
    getColorImg(18, 1187, 99);

    //lace
    actPartsColorGroup["13"] = "114_2135";

    jQuery("a[mat-id=114]").addClass("actMaterial");
    jQuery("[color-id=2135]").parent().addClass("actColor");

    getColorImg(13, 2135, 114);
  } else if (mainProductId == "1465578305") {
    //saville

    //sole
    actPartsColorGroup["10"] = "108_1304"; //sole
    jQuery("[color-id=1304]").parent().addClass("actColor");
    getColorImg(10, 1304, 108);

    //mat 1
    actPartsColorGroup["17"] = "68_858";
    jQuery("a[mat-id=68]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=858]").parent().addClass("actColor");
    getColorImg(17, 858, 68);

    //mat 2
    actPartsColorGroup["18"] = "75_923";
    jQuery("a[mat-id=75]").addClass("actMaterial");
    jQuery("[color-id=923]").parent().addClass("actColor");
    getColorImg(18, 923, 75);

    //piping
    getColorImg(23, 1317, 110);

    //lace
    actPartsColorGroup["13"] = "109_2085";
    jQuery("a[mat-id=109]").addClass("actMaterial");
    jQuery("[color-id=2085]").parent().addClass("actColor");
    getColorImg(13, 2085, 109);

    //eyelet
    getColorImg(19, 2051, 185);

    jQuery("[name='rivetsilver']").trigger("click");
  } else if (mainProductId == "5419162049") {
    //Arsenal

    jQuery(".product-thumber img").css("padding", "0px 0 15px");

    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();

    //sole
    actPartsColorGroup["10"] = "173_1942"; //sole
    jQuery("[color-id=1942]").parent().addClass("actColor");
    getColorImg(10, 1942);

    //zipper

    actPartsColorGroup["27"] = "184_2047"; //zipper
    jQuery("[color-id=2047]").parent().addClass("actColor");
    getColorImg(27, 2047);

    jQuery("[name=perforation]").prop("checked", true).trigger("change");

    //mat 1
    actPartsColorGroup["17"] = "156_1695";
    jQuery("a[mat-id=156]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=1695]").parent().addClass("actColor");
    getColorImg(17, 1695, 156);

    //mat 2
    actPartsColorGroup["18"] = "164_1812";
    jQuery("a[mat-id=164]").addClass("actMaterial");
    jQuery("[color-id=1812]").parent().addClass("actColor");
    getColorImg(18, 1812, 164);

    //lace
    actPartsColorGroup["13"] = "172_2112";
    jQuery("a[mat-id=172]").addClass("actMaterial");
    jQuery("[color-id=2112]").parent().addClass("actColor");
    getColorImg(13, 2112, 172);

    //eyelet
    getColorImg(19, 2030, 181);
  } else if (mainProductId == "4221337537") {
    //Oddity
    //     jQuery("[name='brouge']").trigger("click");
    //sole
    actPartsColorGroup["10"] = "138_1676"; //sole
    jQuery("[color-id=1676]").parent().addClass("actColor");
    getColorImg(10, 1676, 138);

    //mat 1
    actPartsColorGroup["17"] = "122_1359";
    jQuery("a[mat-id=122]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=1359]").parent().addClass("actColor");
    getColorImg(17, 1359, 122);

    //mat 2
    actPartsColorGroup["18"] = "125_1429";
    jQuery("a[mat-id=125]").addClass("actMaterial");
    jQuery("[color-id=1429]").parent().addClass("actColor");
    getColorImg(18, 1429, 125);

    //lace
    actPartsColorGroup["13"] = "139_2101";
    jQuery("a[mat-id=139]").addClass("actMaterial");
    jQuery("[color-id=2101]").parent().addClass("actColor");
    getColorImg(13, 2101, 139);

    //eyelet
    getColorImg(19, 2038, 183);
  } else if (mainProductId == "460972461") {
    //Oddity -2

    //sole
    actPartsColorGroup["10"] = "1294_20207"; //sole
    jQuery("[color-id=20207]").parent().addClass("actColor");
    getColorImg(10, 20207, 1294);

    //mat 1
    actPartsColorGroup["17"] = "1277_19990";
    jQuery("a[mat-id=1277]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=19990]").parent().addClass("actColor");
    getColorImg(17, 19990, 1277);

    //mat 2
    actPartsColorGroup["18"] = "1284_20082";
    jQuery("a[mat-id=1284]").addClass("actMaterial");
    jQuery("[color-id=20082]").parent().addClass("actColor");
    getColorImg(18, 20082, 1284);

    //lace
    actPartsColorGroup["13"] = "1295_20209";
    jQuery("a[mat-id=1295]").addClass("actMaterial");
    jQuery("[color-id=20209]").parent().addClass("actColor");
    getColorImg(13, 20209, 1295);

    //eyelet
    getColorImg(19, 20332, 1306);
  } else if (mainProductId == "548490182686") {
    //boggart duplicate
    //sole
    actPartsColorGroup["10"] = "1123_18182"; //sole => materialid_colorid
    jQuery("[color-id=18182]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 18182, 1123);

    //lace
    getColorImg(13, 18183, 1124);

    //mat 1
    actPartsColorGroup["17"] = "1105_17841";
    jQuery("a[mat-id=1105]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=17841]").parent().addClass("actColor");
    getColorImg(17, 17841, 1105);

    //mat 2
    actPartsColorGroup["18"] = "1114_18077"; //mat2
    jQuery("a[mat-id=1114]").addClass("actMaterial");
    jQuery("[color-id=18077]").parent().addClass("actColor");
    getColorImg(18, 18077, 1114);

    //eyelet
    getColorImg(19, 18089, 1115);

    jQuery("[name='eyelet']").trigger("click");
  } else if (mainProductId == "560918298654") {
    //saratogga duplicate
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "861_13360"; //sole
    jQuery("[color-id=13360]").parent().addClass("actColor");
    getColorImg(10, 13360, 861);

    //mat 1
    actPartsColorGroup["17"] = "840_13096";
    jQuery("a[mat-id=840]").addClass("actMaterial");
    //jQuery("a[mat-id=45]").trigger("click");
    jQuery("[color-id=13096]").parent().addClass("actColor");
    getColorImg(17, 13096, 840);

    //mat 2
    actPartsColorGroup["18"] = "853_13258"; //mat2
    jQuery("a[mat-id=853]").addClass("actMaterial");
    jQuery("[color-id=13258]").parent().addClass("actColor");
    getColorImg(18, 13258, 853);
  } else if (mainProductId == "547124019230") {
    //saville duplicate
    //sole
    actPartsColorGroup["10"] = "826_12954"; //sole
    jQuery("[color-id=12954]").parent().addClass("actColor");
    getColorImg(10, 12954, 826);

    //mat 1
    actPartsColorGroup["17"] = "809_12754";
    jQuery("a[mat-id=809]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=12754]").parent().addClass("actColor");
    getColorImg(17, 12754, 809);

    //mat 2
    actPartsColorGroup["18"] = "816_12813";
    jQuery("a[mat-id=816]").addClass("actMaterial");
    jQuery("[color-id=12813]").parent().addClass("actColor");
    getColorImg(18, 12813, 816);

    //piping
    getColorImg(23, 12964, 828);

    //lace
    actPartsColorGroup["13"] = "827_12955";
    jQuery("a[mat-id=827]").addClass("actMaterial");
    jQuery("[color-id=12955]").parent().addClass("actColor");
    getColorImg(13, 12955, 827);

    //eyelet
    getColorImg(19, 13001, 832);

    jQuery("[name='rivetsilver']").trigger("click");
  } else if (mainProductId == "560914563102") {
    //arsenal duplicate
    jQuery(".product-thumber img").css("padding", "0px 0 15px");

    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();

    //sole
    actPartsColorGroup["10"] = "1149_18470"; //sole
    jQuery("[color-id=18470]").parent().addClass("actColor");
    getColorImg(10, 18470);

    //zipper

    actPartsColorGroup["27"] = "1154_18488"; //zipper
    jQuery("[color-id=18488]").parent().addClass("actColor");
    getColorImg(27, 18488);

    jQuery("[name=perforation]").prop("checked", true).trigger("change");

    //mat 1
    actPartsColorGroup["17"] = "1132_18273";
    jQuery("a[mat-id=1132]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=18273]").parent().addClass("actColor");
    getColorImg(17, 18273, 1132);

    //mat 2
    actPartsColorGroup["18"] = "1140_18366";
    jQuery("a[mat-id=1140]").addClass("actMaterial");
    jQuery("[color-id=18366]").parent().addClass("actColor");
    getColorImg(18, 18366, 1140);

    //lace
    actPartsColorGroup["13"] = "1148_18461";
    jQuery("a[mat-id=1148]").addClass("actMaterial");
    jQuery("[color-id=18461]").parent().addClass("actColor");
    getColorImg(13, 18461, 1148);

    //eyelet
    getColorImg(19, 18484, 1153);
  } else if (mainProductId == "560913252382") {
    //Oddity duplicate
    //sole
    actPartsColorGroup["10"] = "1203_19042"; //sole
    jQuery("[color-id=19042]").parent().addClass("actColor");
    getColorImg(10, 19042, 1203);

    //mat 1
    actPartsColorGroup["17"] = "1187_18844";
    jQuery("a[mat-id=1187]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=18844]").parent().addClass("actColor");
    getColorImg(17, 18844, 1187);

    //mat 2
    actPartsColorGroup["18"] = "1190_18884";
    jQuery("a[mat-id=1190]").addClass("actMaterial");
    jQuery("[color-id=18884]").parent().addClass("actColor");
    getColorImg(18, 18884, 1190);

    //lace
    actPartsColorGroup["13"] = "1204_19050";
    jQuery("a[mat-id=1204]").addClass("actMaterial");
    jQuery("[color-id=19050]").parent().addClass("actColor");
    getColorImg(13, 19050, 1204);

    //eyelet
    getColorImg(19, 19153, 1215);
  } else if (mainProductId == "560915906590") {
    //Nassau duplicate
    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();
    jQuery(".perfOne").text("");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "1174_18761"; //sole
    jQuery("[color-id=18761]").parent().addClass("actColor");

    getColorImg(10, 18761, 1174);

    //mat 1
    actPartsColorGroup["17"] = "1160_18562";
    jQuery("a[mat-id=1160]").addClass("actMaterial");

    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=18562]").parent().addClass("actColor");
    getColorImg(17, 18562, 1160);

    //mat 2
    actPartsColorGroup["18"] = "1167_18637";
    jQuery("a[mat-id=1167]").addClass("actMaterial");
    jQuery("[color-id=18637]").parent().addClass("actColor");
    getColorImg(18, 18637, 1167);

    //lace
    actPartsColorGroup["13"] = "1177_18767";

    jQuery("a[mat-id=1177]").addClass("actMaterial");
    jQuery("[color-id=18767]").parent().addClass("actColor");

    getColorImg(13, 18767, 1177);

    //eyelet
    getColorImg(19, 18784, 1181);
  } else if (mainProductId == "1467857665") {
    //Armada
    //return false;
    jQuery(".product-thumber img").css("padding", "0px 0 15px");
    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();

    //partId,colorId,matId

    //sole
    actPartsColorGroup["10"] = "1074_17469"; //sole
    jQuery("[color-id=17469]").parent().addClass("actColor");
    getColorImg(10, 17469, 1074);

    //jQuery("[name=perforation]").prop("checked",false).trigger("change");

    //mat 1
    actPartsColorGroup["17"] = "1063_17473";
    jQuery("a[mat-id=1063]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=17473]").parent().addClass("actColor");
    getColorImg(17, 17473, 1063);

    //mat 2
    actPartsColorGroup["18"] = "1071_17524";
    jQuery("a[mat-id=1071]").addClass("actMaterial");
    jQuery("[color-id=17524]").parent().addClass("actColor");
    getColorImg(18, 17524, 1071);

    //lace
    actPartsColorGroup["13"] = "1057_17584";
    jQuery("a[mat-id=1057]").addClass("actMaterial");
    jQuery("[color-id=17584]").parent().addClass("actColor");
    getColorImg(13, 17584, 1057);

    //eyelet
    getColorImg(19, 17464, 1056);
  } else if (mainProductId == "1356883951702") {
    //Armada duplicate
    //return false;
    jQuery(".product-thumber img").css("padding", "0px 0 15px");
    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();
    jQuery(".product-typer").find('input[name="rivetgold"]').trigger("click");

    //partId,colorId,matId

    //sole
    actPartsColorGroup["10"] = "3049_40864"; //sole
    jQuery("[color-id=40864]").parent().addClass("actColor");
    getColorImg(10, 40864, 3049);

    jQuery("[name=perforation]").prop("checked", true).trigger("change");

    //mat 1
    actPartsColorGroup["17"] = "3038_40732";
    jQuery("a[mat-id=3038]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=40732]").parent().addClass("actColor");
    getColorImg(17, 40732, 3038);

    //mat 2
    actPartsColorGroup["18"] = "3044_40808";
    jQuery("a[mat-id=3044]").addClass("actMaterial");
    jQuery("[color-id=40808]").parent().addClass("actColor");
    getColorImg(18, 40808, 3044);

    //lace
    actPartsColorGroup["13"] = "3032_40661";
    jQuery("a[mat-id=3032]").addClass("actMaterial");
    jQuery("[color-id=40661]").parent().addClass("actColor");
    getColorImg(13, 40661, 3032);

    //lace2
    getColorImg(13, 40678, 3033);

    //eyelet
    getColorImg(19, 17464, 1056);
  } else if (mainProductId == "9977652737") {
    //Nassau duplicate  -2
    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();
    jQuery(".perfOne").text("");
    jQuery("[name=perforation]").prop("checked", true).trigger("change");

    //sole
    actPartsColorGroup["10"] = "1328_20605"; //sole
    jQuery("[color-id=20605]").parent().addClass("actColor");

    getColorImg(10, 20605, 1328);

    //mat 1
    actPartsColorGroup["17"] = "3144_41928";
    jQuery("a[mat-id=3144]").addClass("actMaterial");

    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=41928]").parent().addClass("actColor");
    getColorImg(17, 41928, 3144);

    //mat 2
    actPartsColorGroup["18"] = "3151_42017";
    jQuery("a[mat-id=3151]").addClass("actMaterial");
    jQuery("[color-id=42017]").parent().addClass("actColor");
    getColorImg(18, 42017, 3151);

    //lace
    actPartsColorGroup["13"] = "3161_42151";
    jQuery("a[mat-id=3161]").addClass("actMaterial");
    jQuery("[color-id=42151]").parent().addClass("actColor");
    getColorImg(13, 42151, 3161);

    //lace 2
    actPartsColorGroup["13"] = "3164_42170";
    getColorImg(13, 42170, 3164);

    jQuery("a[mat-id=3164]").addClass("actMaterial");
    jQuery("[color-id=42170]").parent().addClass("actColor");

    //eyelet
    getColorImg(19, 20642, 1333);
  } else if (mainProductId == "550440370206") {
    //Duplicate saville 2

    //sole
    actPartsColorGroup["10"] = "1390_21339"; //sole
    jQuery("[color-id=21339]").parent().addClass("actColor");
    getColorImg(10, 21339, 1390);

    //mat 1
    actPartsColorGroup["17"] = "3107_41516";
    jQuery("a[mat-id=3107]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=41516]").parent().addClass("actColor");
    getColorImg(17, 41516, 3107);

    //mat 2
    actPartsColorGroup["18"] = "3111_41551";
    jQuery("a[mat-id=3111]").addClass("actMaterial");
    jQuery("[color-id=41551]").parent().addClass("actColor");
    getColorImg(18, 41551, 3111);

    //piping
    getColorImg(23, 1317, 110);

    //lace
    actPartsColorGroup["13"] = "1391_21346";
    jQuery("a[mat-id=1391]").addClass("actMaterial");
    jQuery("[color-id=21346]").parent().addClass("actColor");
    getColorImg(13, 21346, 1391);

    //eyelet
    getColorImg(19, 21403, 1396);
    //lace 1
    getColorImg(13, 41725, 3125);
  } else if (mainProductId == "5418780353") {
    //saratogga duplicate 2
    //hide perforation option 2

    jQuery("[name=perforation2]").prop("checked", true).trigger("change");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "1425_21763"; //sole
    jQuery("[color-id=21763]").parent().addClass("actColor");
    getColorImg(10, 21763, 1425);

    //mat 1
    actPartsColorGroup["17"] = "1404_21501";
    jQuery("a[mat-id=1404]").addClass("actMaterial");
    //jQuery("a[mat-id=45]").trigger("click");
    jQuery("[color-id=21501]").parent().addClass("actColor");
    getColorImg(17, 21501, 1404);

    //mat 2
    actPartsColorGroup["18"] = "1412_21598"; //mat2
    jQuery("a[mat-id=1412]").addClass("actMaterial");
    jQuery("[color-id=21598]").parent().addClass("actColor");
    getColorImg(18, 21598, 1412);
  } else if (mainProductId == "1267259905") {
    //Hudson
    jQuery("[name=perforation2]").prop("checked", false).trigger("change");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");
    jQuery("[name='brouge']").trigger("click");

    //sole
    actPartsColorGroup["10"] = "1468_24119"; //sole
    jQuery("[color-id=24119]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 24119, 1468);

    //lace
    getColorImg(13, 21993, 1449);

    //mat 1
    actPartsColorGroup["17"] = "1428_21778";
    jQuery("a[mat-id=1428]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=21778]").parent().addClass("actColor");
    getColorImg(17, 21778, 1428);

    //mat 2
    actPartsColorGroup["18"] = "1435_21816"; //mat2
    jQuery("a[mat-id=1435]").addClass("actMaterial");
    jQuery("[color-id=21816]").parent().addClass("actColor");
    getColorImg(18, 21816, 1435);

    //mat 3
    actPartsColorGroup["29"] = "1442_21841"; //mat3
    jQuery("a[mat-id=1442]").addClass("actMaterial");
    jQuery("[color-id=21841]").parent().addClass("actColor");
    getColorImg(29, 21841, 1442);

    //eyelet
    getColorImg(19, 24117, 1453);
  } else if (mainProductId == "7743501889") {
    //Hudson duplicate
    jQuery("[name=perforation2]").prop("checked", true).trigger("change");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    jQuery("[name='brouge']").trigger("click");
    jQuery("[name='brouge']").prop("checked", true);

    //sole
    actPartsColorGroup["10"] = "2020_28884"; //sole
    jQuery("[color-id=28884]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 28884, 2020);

    //lace
    getColorImg(13, 28675, 2003);
    //lace2
    getColorImg(13, 28692, 2004);

    //mat 1
    actPartsColorGroup["17"] = "1988_28482";
    jQuery("a[mat-id=1988]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=28482]").parent().addClass("actColor");
    getColorImg(17, 28482, 1988);

    //mat 2
    actPartsColorGroup["18"] = "1989_28497"; //mat2
    jQuery("a[mat-id=1989]").addClass("actMaterial");
    jQuery("[color-id=28497]").parent().addClass("actColor");
    getColorImg(18, 28497, 1989);

    //mat 3
    actPartsColorGroup["29"] = "1996_28584"; //mat2
    jQuery("a[mat-id=1996]").addClass("actMaterial");
    jQuery("[color-id=28584]").parent().addClass("actColor");
    getColorImg(29, 28584, 1996);

    //eyelet
    getColorImg(19, 24117, 1453);
  } else if (mainProductId == "2197325185") {
    //Saddle
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "1550_24095"; //sole
    jQuery("[color-id=24095]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 24095, 1550);
    jQuery("[name='brouge']").trigger("click");
    //jQuery("[name='rivetsilver']").trigger("click");
    //lace
    getColorImg(13, 23895, 1533);

    //mat 1
    actPartsColorGroup["17"] = "1539_23126";
    jQuery("a[mat-id=1539]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=23126]").parent().addClass("actColor");
    getColorImg(17, 23126, 1539);

    //mat 2
    actPartsColorGroup["18"] = "1547_23861"; //mat2
    jQuery("a[mat-id=1547]").addClass("actMaterial");
    jQuery("[color-id=23861]").parent().addClass("actColor");
    getColorImg(18, 23861, 1547);

    //eyelet
    getColorImg(19, 24093, 1532);
  } else if (mainProductId == "552167276574") {
    //harlow dupliacte 1
    jQuery("[name=perforation2]").prop("checked", true).trigger("change");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");
    //jQuery("[name=brouge]").prop("checked",false).trigger("change");
    //sole
    actPartsColorGroup["10"] = "32_433"; //sole => materialid_colorid
    jQuery("[color-id=433]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 433, 32);

    //lace
    getColorImg(13, 24990, 1585);

    //mat 1
    actPartsColorGroup["17"] = "1591_24163";
    jQuery("a[mat-id=1591]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=24163]").parent().addClass("actColor");
    getColorImg(17, 24163, 1591);

    //mat 2
    actPartsColorGroup["18"] = "1599_24787"; //mat2
    jQuery("a[mat-id=1599]").addClass("actMaterial");
    jQuery("[color-id=24787]").parent().addClass("actColor");
    getColorImg(18, 24787, 1599);

    //eyelet
    getColorImg(19, 25022, 1584);
  } else if (mainProductId == "460991377") {
    //gatsby

    jQuery("[name=perforation]").prop("checked", false).trigger("change");
    //sole
    actPartsColorGroup["10"] = "1683_25420"; //sole => materialid_colorid
    jQuery("[color-id=25420]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 25420, 1683);

    //lace
    getColorImg(13, 25394, 1680);

    //jQuery('#part_18').find('.selct-material').find('li[titlelm="fabric"]').addClass('not-active')

    //mat 1
    actPartsColorGroup["17"] = "1649_25069";
    jQuery("a[mat-id=1649]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=25069]").parent().addClass("actColor");
    getColorImg(17, 25069, 1649);

    //mat 2
    actPartsColorGroup["18"] = "1670_25156"; //mat2
    jQuery("a[mat-id=1670]").addClass("actMaterial");
    jQuery("[color-id=25156]").parent().addClass("actColor");
    getColorImg(18, 25156, 1670);

    //eyelet
    getColorImg(19, 25424, 1673);
  } else if (mainProductId == "9978267073") {
    //gatsby  dupliacte 1
    jQuery("[name=perforation2]").prop("checked", true).trigger("change");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");
    //jQuery("[name=brouge]").prop("checked",false).trigger("change");
    //sole
    actPartsColorGroup["10"] = "2054_29279"; //sole => materialid_colorid
    jQuery("[color-id=29279]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 29279, 2054);

    //lace
    getColorImg(13, 29250, 2052);

    //mat 1
    actPartsColorGroup["17"] = "2026_28940";
    jQuery("a[mat-id=2026]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=28940]").parent().addClass("actColor");
    getColorImg(17, 28940, 2026);

    //mat 2
    actPartsColorGroup["18"] = "2047_29202"; //mat2
    jQuery("a[mat-id=2047]").addClass("actMaterial");
    jQuery("[color-id=29202]").parent().addClass("actColor");
    getColorImg(18, 29202, 2047);

    //eyelet
    getColorImg(19, 25022, 1584);
  } else if (mainProductId == "1466429441") {
    //gatsby  dupliacte 2
    jQuery("[name=perforation2]").prop("checked", false).trigger("change");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");
    //jQuery("[name=brouge]").prop("checked",false).trigger("change");
    //sole
    actPartsColorGroup["10"] = "32_433"; //sole => materialid_colorid
    jQuery("[color-id=433]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 433, 32);

    //lace
    getColorImg(13, 29250, 2052);
    //lace 2
    getColorImg(13, 29655, 2086);

    //mat 1
    actPartsColorGroup["17"] = "2059_29328";
    jQuery("a[mat-id=2059]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=2059]").parent().addClass("actColor");
    getColorImg(17, 29328, 2059);

    //mat 2
    actPartsColorGroup["18"] = "2080_29590"; //mat2
    jQuery("a[mat-id=2080]").addClass("actMaterial");
    jQuery("[color-id=29590]").parent().addClass("actColor");
    getColorImg(18, 29590, 2080);
    jQuery("[name=eyelet]").prop("checked", true).trigger("change");

    //eyelet
    getColorImg(19, 29630, 2083);
  } else if (mainProductId == "9987925889") {
    //lamont
    jQuery("[name=perforation2]").prop("checked", false).trigger("change");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");
    //jQuery("[name=brouge]").prop("checked",false).trigger("change");
    //sole
    actPartsColorGroup["10"] = "1713_25824"; //sole => materialid_colorid
    jQuery("[color-id=25824]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 25824, 1713);

    //lace
    getColorImg(13, 29250, 2052);

    //mat 1
    actPartsColorGroup["17"] = "1688_25520";
    jQuery("a[mat-id=1688]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=25520]").parent().addClass("actColor");
    getColorImg(17, 25520, 1688);

    //mat 2
    actPartsColorGroup["18"] = "1695_25607"; //mat2
    jQuery("a[mat-id=1695]").addClass("actMaterial");
    jQuery("[color-id=25607]").parent().addClass("actColor");
    getColorImg(18, 25607, 1695);

    //eyelet
    getColorImg(19, 25022, 1584);

    //rear tab
    actPartsColorGroup["32"] = "1720_25886";
    jQuery("a[mat-id=1720]").addClass("actMaterial");
    jQuery("[color-id=25886]").parent().addClass("actColor");
    getColorImg(32, 25886, 1720);

    //elastic
    actPartsColorGroup["31"] = "1842_27264";
    jQuery("a[mat-id=1842]").addClass("actMaterial");
    jQuery("[color-id=27264]").parent().addClass("actColor");
    getColorImg(31, 27264, 1842);
  } else if (mainProductId == "1356909903958") {
    //lamont duplicate

    jQuery("[name=perforation2]").prop("checked", false).trigger("change");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");
    //jQuery("[name=brouge]").prop("checked",false).trigger("change");
    //sole
    actPartsColorGroup["10"] = "1713_25824"; //sole => materialid_colorid
    jQuery("[color-id=25824]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 25824, 1713);

    //mat 1
    actPartsColorGroup["17"] = "2874_38727";
    jQuery("a[mat-id=2874]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=38727]").parent().addClass("actColor");
    getColorImg(17, 38727, 2874);

    //mat 2
    actPartsColorGroup["18"] = "2882_38843"; //mat2
    jQuery("a[mat-id=2882]").addClass("actMaterial");
    jQuery("[color-id=38843]").parent().addClass("actColor");
    getColorImg(18, 38843, 2882);

    //rear tab
    actPartsColorGroup["32"] = "2907_39127";
    jQuery("a[mat-id=2907]").addClass("actMaterial");
    jQuery("[color-id=39127]").parent().addClass("actColor");
    getColorImg(32, 39127, 2907);

    //elastic
    actPartsColorGroup["31"] = "2912_39167";
    jQuery("a[mat-id=2912]").addClass("actMaterial");
    jQuery("[color-id=39167]").parent().addClass("actColor");
    getColorImg(31, 39167, 2912);
  } else if (mainProductId == "1362437832790") {
    //morgan

    jQuery("#part_17").find(".selct-material").find('li[mat-id="2395"]').hide();

    var bChk = jQuery(".product-typer")
      .find('input[name="brouge2"]')
      .prop("checked");
    if (bChk == false) {
      jQuery("#view_1").find("img[rel=29][isicon=no]").hide();
      jQuery("#view_2").find("img[rel=29][isicon=no]").hide();
      jQuery("#part_29").hide();
    }
    jQuery("#view_1").find("img[rel=29][isicon=no]").hide();
    jQuery("#view_2").find("img[rel=29][isicon=no]").hide();
    //sole
    actPartsColorGroup["10"] = "2437_33486"; //sole
    jQuery("[color-id=33486]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 33486, 2437);

    //lace
    getColorImg(13, 33491, 2438);

    //mat 1
    actPartsColorGroup["17"] = "2416_33238";
    jQuery("a[mat-id=2416]").addClass("actMaterial");
    jQuery("[color-id=33238]").parent().addClass("actColor");
    getColorImg(17, 33238, 2416);

    //mat 2
    actPartsColorGroup["18"] = "2424_33340"; //mat2
    jQuery("a[mat-id=2424]").addClass("actMaterial");
    jQuery("[color-id=33340]").parent().addClass("actColor");
    getColorImg(18, 33340, 2424);

    //mat 3
    actPartsColorGroup["29"] = "2430_33403"; //mat3
    jQuery("a[mat-id=2430]").addClass("actMaterial");
    jQuery("[color-id=33403]").parent().addClass("actColor");
    getColorImg(29, 33403, 2430);

    //eyelet
    getColorImg(19, 34870, 2552);
    jQuery(".product-typer")
      .find('input[name="perforation2"]')
      .trigger("click");
  } else if (mainProductId == "1362437865558") {
    //vienna duplicate

    jQuery(".product-typer").find('input[name="eyelet"]').trigger("click");
    //sole
    actPartsColorGroup["10"] = "2992_40166"; //sole
    jQuery("[color-id=40166]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 40166, 2992);

    //mat 1
    actPartsColorGroup["17"] = "2995_40209";
    jQuery("a[mat-id=2995]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=40209]").parent().addClass("actColor");
    getColorImg(17, 40209, 2995);

    //mat 2
    actPartsColorGroup["18"] = "3002_40297"; //mat2
    jQuery("a[mat-id=3002]").addClass("actMaterial");
    jQuery("[color-id=40297]").parent().addClass("actColor");
    getColorImg(18, 40297, 3002);

    //lace 1
    actPartsColorGroup["13"] = "2993_40168"; //mat2
    jQuery("a[mat-id=2993]").addClass("actMaterial");
    jQuery("[color-id=40168]").parent().addClass("actColor");
    getColorImg(13, 40168, 2993);
    //lace 2
    getColorImg(13, 40185, 2994);
    //eyelet
    getColorImg(19, 40466, 3016);
  } else if (mainProductId == "6567881729") {
    //madeline
    jQuery(".product-typer").find('input[name="perforation"]').trigger("click");
    //sole
    actPartsColorGroup["10"] = "2454_33699"; //sole
    jQuery("[color-id=40166]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 33699, 2454);

    //mat 1
    actPartsColorGroup["17"] = "2456_33725";
    jQuery("a[mat-id=2456]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=33725]").parent().addClass("actColor");
    getColorImg(17, 33725, 2456);

    //mat 2
    actPartsColorGroup["18"] = "2463_33813"; //mat2
    jQuery("a[mat-id=2463]").addClass("actMaterial");
    jQuery("[color-id=33813]").parent().addClass("actColor");
    getColorImg(18, 33813, 2463);

    //buckle
    getColorImg(33, 33701, 2455);

    //Strap
    getColorImg(35, 34076, 2486);
  } else if (mainProductId == "4219595649") {
    //chelsea

    jQuery('input[name="reartab"]').prop("checked", false);
    var views = productViews["views"];
    for (var view in views) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=32][isicon=no]")
        .hide();
    }

    //sole
    actPartsColorGroup["10"] = "2363_32632"; //sole => materialid_colorid
    jQuery("[color-id=32632]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 32632, 2363);

    //mat 1
    actPartsColorGroup["17"] = "2335_32307";
    jQuery("a[mat-id=2335]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=32307]").parent().addClass("actColor");
    getColorImg(17, 32307, 2335);

    //mat 2
    actPartsColorGroup["18"] = "2343_32395"; //mat2
    jQuery("a[mat-id=2343]").addClass("actMaterial");
    jQuery("[color-id=32395]").parent().addClass("actColor");
    getColorImg(18, 32395, 2343);

    //rear tab
    actPartsColorGroup["32"] = "2355_32552";
    jQuery("a[mat-id=2355]").addClass("actMaterial");
    jQuery("[color-id=32552]").parent().addClass("actColor");
    getColorImg(32, 32552, 2355);

    //elastic
    actPartsColorGroup["31"] = "2353_32508";
    jQuery("a[mat-id=2353]").addClass("actMaterial");
    jQuery("[color-id=32508]").parent().addClass("actColor");
    getColorImg(31, 32508, 2353);
  } else if (mainProductId == "4219340353") {
    //classon

    jQuery("#part_36").hide();
    jQuery('input[name="reartab"]').prop("checked", false);
    var views = productViews["views"];
    for (var view in views) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=32][isicon=no]")
        .hide();
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=36][isicon=no]")
        .hide();
    }

    //sole
    actPartsColorGroup["10"] = "2519_34466"; //sole
    jQuery("[color-id=34466]").parent().addClass("actColor");
    getColorImg(10, 34466, 2519);

    //buckle
    getColorImg(33, 34467, 2520);
    //strap
    getColorImg(35, 34662, 2536);

    //mat 1
    actPartsColorGroup["17"] = "2526_34536";
    jQuery("a[mat-id=2526]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=34536]").parent().addClass("actColor");
    getColorImg(17, 34536, 2526);

    //mat 2
    actPartsColorGroup["18"] = "2533_34624";
    jQuery("a[mat-id=2533]").addClass("actMaterial");
    jQuery("[color-id=34624]").parent().addClass("actColor");
    getColorImg(18, 34624, 2533);

    actPartsColorGroup["27"] = "2521_34472"; //Zippper
    jQuery("[color-id=34472]").parent().addClass("actColor");
    getColorImg(27, 34472, 2521);

    actPartsColorGroup["32"] = "2538_34687"; //rear tab
    jQuery("[color-id=34687]").parent().addClass("actColor");
    getColorImg(32, 34687, 2538);
  } else if (mainProductId == "1464803201") {
    //limehouse

    jQuery(".product-typer").find('input[name="brouge"]').trigger("click");
    jQuery(".product-typer").find('input[name="brouge"]').prop("checked", true);
    //sole
    actPartsColorGroup["10"] = "2322_32243"; //sole
    jQuery("[color-id=32242]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 32243, 2322);

    //lace 1
    getColorImg(13, 32229, 2320);
    //lace 2
    getColorImg(13, 32238, 2321);

    //mat 1
    actPartsColorGroup["17"] = "2283_31781";
    jQuery("a[mat-id=2283]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=31781]").parent().addClass("actColor");
    getColorImg(17, 31781, 2283);

    //mat 2
    actPartsColorGroup["18"] = "2290_31884"; //mat2
    jQuery("a[mat-id=2290]").addClass("actMaterial");
    jQuery("[color-id=31884]").parent().addClass("actColor");
    getColorImg(18, 31884, 2290);

    //mat 3
    actPartsColorGroup["29"] = "2297_31972"; //mat3
    jQuery("a[mat-id=2297]").addClass("actMaterial");
    jQuery("[color-id=31972]").parent().addClass("actColor");
    getColorImg(29, 31972, 2297);
  } else if (mainProductId == "1357577519190") {
    //limehouse duplicate

    jQuery(".product-typer").find('input[name="brouge"]').trigger("click");
    jQuery(".product-typer").find('input[name="brouge"]').prop("checked", true);
    //sole
    actPartsColorGroup["10"] = "3093_41353"; //sole
    jQuery("[color-id=32242]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 41353, 3093);

    //lace 1
    getColorImg(13, 41334, 3091);
    //lace 2
    getColorImg(13, 41351, 3092);

    //mat 1
    actPartsColorGroup["17"] = "3057_40914";
    jQuery("a[mat-id=3057]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=40914]").parent().addClass("actColor");
    getColorImg(17, 40914, 3057);

    //mat 2
    actPartsColorGroup["18"] = "3063_40985"; //mat2
    jQuery("a[mat-id=3063]").addClass("actMaterial");
    jQuery("[color-id=40985]").parent().addClass("actColor");
    getColorImg(18, 40985, 3063);

    //mat 3
    actPartsColorGroup["29"] = "3070_41071"; //mat3
    jQuery("a[mat-id=3070]").addClass("actMaterial");
    jQuery("[color-id=41071]").parent().addClass("actColor");
    getColorImg(29, 41071, 3070);
  } else if (mainProductId == "1358467629142") {
    //mary

    //sole
    actPartsColorGroup["10"] = "3419_45066"; //sole
    jQuery("[color-id=45066]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 45066, 3419);

    //mat 1
    actPartsColorGroup["17"] = "3383_44629";
    jQuery("a[mat-id=3383]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=44629]").parent().addClass("actColor");
    getColorImg(17, 44629, 3383);

    //mat 2
    actPartsColorGroup["18"] = "3391_44742"; //mat2
    jQuery("a[mat-id=3391]").addClass("actMaterial");
    jQuery("[color-id=44742]").parent().addClass("actColor");
    getColorImg(18, 44742, 3391);

    //mat 3
    actPartsColorGroup["29"] = "3397_44805"; //mat3
    jQuery("a[mat-id=3397]").addClass("actMaterial");
    jQuery("[color-id=44805]").parent().addClass("actColor");
    getColorImg(29, 44805, 3397);
    //buckle
    getColorImg(33, 45064, 3418);
  } else if (mainProductId == "1358365491286") {
    //holborn

    jQuery("#part_37")
      .find(".inter-design-way .selct-material")
      .find("li[titlelm='natural']")
      .insertBefore(
        jQuery("#part_37")
          .find(".inter-design-way .selct-material")
          .find("li[titlelm='soft leather']")
      );
    //sole
    actPartsColorGroup["10"] = "3260_43374"; //sole
    jQuery("[color-id=43374]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 43374, 3260);

    //mat 1
    actPartsColorGroup["17"] = "3233_43022";
    jQuery("a[mat-id=3233]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=43022]").parent().addClass("actColor");
    getColorImg(17, 43022, 3233);

    //mat 2
    actPartsColorGroup["18"] = "3242_43159"; //mat2
    jQuery("a[mat-id=3242]").addClass("actMaterial");
    jQuery("[color-id=43159]").parent().addClass("actColor");
    getColorImg(18, 43159, 3242);

    //mat 3
    actPartsColorGroup["29"] = "3249_43247"; //mat3
    jQuery("a[mat-id=3249]").addClass("actMaterial");
    jQuery("[color-id=43247]").parent().addClass("actColor");
    getColorImg(29, 43247, 3249);

    //lace 1
    getColorImg(13, 43340, 3258);
    //lace 2
    getColorImg(13, 43357, 3259);

    //heel
    getColorImg(37, 44607, 3381);
  } else if (mainProductId == decorations.conicHolborn.id) {
    //conic holborn

    jQuery("#part_37")
      .find(".inter-design-way .selct-material")
      .find("li[titlelm='natural']")
      .insertBefore(
        jQuery("#part_37")
          .find(".inter-design-way .selct-material")
          .find("li[titlelm='soft leather']")
      );
    //sole
    actPartsColorGroup["10"] = "3930_51109"; //sole
    jQuery("[color-id=51109]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 51109, 3930);

    //mat 1
    actPartsColorGroup["17"] = "3904_50777";
    jQuery("a[mat-id=3904]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=50777]").parent().addClass("actColor");
    getColorImg(17, 50777, 3904);

    //mat 2
    actPartsColorGroup["18"] = "3911_50865"; //mat2
    jQuery("a[mat-id=3911]").addClass("actMaterial");
    jQuery("[color-id=50865]").parent().addClass("actColor");
    getColorImg(18, 50865, 3911);

    //mat 3
    actPartsColorGroup["29"] = "3918_50953"; //mat3
    jQuery("a[mat-id=3918]").addClass("actMaterial");
    jQuery("[color-id=50953]").parent().addClass("actColor");
    getColorImg(29, 50953, 3918);

    //lace 1
    getColorImg(13, 51083, 3928);
    //lace 2
    getColorImg(13, 51083, 3928);

    //heel
    getColorImg(37, 51111, 3931);
  }else if (mainProductId == "460990265") {
    //lenox

    //lace 1
    getColorImg(13, 42554, 3196);
    //lace 2
    getColorImg(13, 42571, 3197);
    //sole
    actPartsColorGroup["10"] = "3194_42540"; //sole
    jQuery("[color-id=42540]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 42540, 3194);

    //mat 1
    actPartsColorGroup["17"] = "3167_42221";
    jQuery("a[mat-id=3167]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=42221]").parent().addClass("actColor");
    getColorImg(17, 42221, 3167);

    //mat 2
    actPartsColorGroup["18"] = "3173_42281"; //mat2
    jQuery("a[mat-id=3173]").addClass("actMaterial");
    jQuery("[color-id=42281]").parent().addClass("actColor");
    getColorImg(18, 42281, 3173);

    //mat 3
    actPartsColorGroup["29"] = "3212_42762"; //mat3
    jQuery("a[mat-id=3212]").addClass("actMaterial");
    jQuery("[color-id=42762]").parent().addClass("actColor");
    getColorImg(29, 42762, 3212);
  } else if (mainProductId == "1357580927062") {
    //baron

    jQuery(".product-typer").find('input[name="toecap"]').trigger("click");
    jQuery(".product-typer").find('input[name="toecap"]').prop("checked", true);
    jQuery("#part_38").hide();
    //sole
    actPartsColorGroup["10"] = "3261_43377"; //sole
    jQuery("[color-id=43377]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 43377, 3261);

    //mat 1
    actPartsColorGroup["17"] = "3263_43402";
    jQuery("a[mat-id=3263]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=43402]").parent().addClass("actColor");
    getColorImg(17, 43402, 3263);

    //mat 2
    actPartsColorGroup["18"] = "3270_43490"; //mat2
    jQuery("a[mat-id=3270]").addClass("actMaterial");
    jQuery("[color-id=43490]").parent().addClass("actColor");
    getColorImg(18, 43490, 3270);

    //mat 3
    actPartsColorGroup["29"] = "3277_43578"; //mat3
    jQuery("a[mat-id=3277]").addClass("actMaterial");
    jQuery("[color-id=43578]").parent().addClass("actColor");
    getColorImg(29, 43578, 3277);

    //buckle
    getColorImg(33, 43379, 3262);
  }else if(mainProductId == decorations.astoria.id) {
    setDefaultActiveConfAstoria();
  }else if (mainProductId == decorations.jane.id) {
    //jane

    setDefaultActiveColJane();
  } else if (mainProductId == decorations.janePumps.id) {
    //jane

    setDefaultActiveColJanePumps();
  }else if (mainProductId == decorations.burton.id) {
    //Burton

    setDefaultConfBurton();
  } else if (mainProductId == decorations.aldgate.id) {
    //Aldgate

    setDefaultConfAldgate();
  } else if(mainProductId == decorations.conicAldgate.id){
    setDefaultConfConicAldgate();
  } else if (mainProductId == decorations.florence.id) {
    //Florence

    setDefaultConfFlorence();
  } else if (mainProductId == decorations.joplin.id) {
    //Joplin

    setDefaultConfJoplin();
  }else if (mainProductId == decorations.joplinPumps.id) {
    //JoplinPumps

    setDefaultConfJoplinPumps();
  }else if (mainProductId == decorations.kent.id){
    //Kent

    setDefaultConfKent();
  }else if (mainProductId == decorations.conicKent.id){
    //Kent

    setDefaultConfConicKent();
  }else if (mainProductId == "6566222337") {
    //duke

    jQuery("#part_29").hide();

    jQuery("#view_1").find("img[rel=29][isicon='no']").hide();
    jQuery("#view_2").find("img[rel=29][isicon='no']").hide();
    jQuery("#part_38").hide();

    //sole
    actPartsColorGroup["10"] = "3261_43377"; //sole
    jQuery("[color-id=43377]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 43377, 3261);

    //mat 1
    actPartsColorGroup["17"] = "3307_43826";
    jQuery("a[mat-id=3307]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=43826]").parent().addClass("actColor");
    getColorImg(17, 43826, 3307);

    //mat 2
    actPartsColorGroup["18"] = "3314_43914"; //mat2
    jQuery("a[mat-id=3314]").addClass("actMaterial");
    jQuery("[color-id=43914]").parent().addClass("actColor");
    getColorImg(18, 43914, 3314);

    //mat 3
    actPartsColorGroup["29"] = "3357_44345"; //mat3
    jQuery("a[mat-id=3357]").addClass("actMaterial");
    jQuery("[color-id=44345]").parent().addClass("actColor");
    getColorImg(29, 44345, 3357);

    //buckle
    getColorImg(33, 44343, 3356);

    // jQuery('.product-typer').find('input[name="brouge"]').trigger('click');

    // jQuery('.product-typer').find('input[name="brouge"]').prop('checked',true);
  } else if (mainProductId == decorations.regent.id) {
    //Regent

    setDefaultActiveColRegent();
  }

  jQuery("#part_21").hide();

  //set attribute order

  jQuery("#part_17").insertBefore("#part_10");
  jQuery("#part_18").insertAfter("#part_17");
  jQuery("#part_13").insertAfter("#part_18");
  jQuery("#part_19").insertAfter("#part_13");
  jQuery("#part_29").insertAfter("#part_18");

  jQuery("#part_33").insertAfter("#part_35");
  jQuery("#part_31").insertAfter("#part_33");
  jQuery("#part_32").insertAfter("#part_31");
  jQuery("#part_27").insertAfter("#part_32");
  jQuery("#part_10").insertAfter("#part_27");

  jQuery("#part_26").insertAfter("#decorations_20");
  jQuery("#part_27").insertBefore("#decorations_20");

  jQuery("#part_23").insertAfter("#decorations_20");
  //sole at end
  jQuery("#part_10").insertAfter("#part_21");

  jQuery("#part_10").insertAfter("#part_33");
  //jQuery("#part_10").insertAfter("#part_27");
  jQuery("#part_10").insertAfter("#decorations_20");

  jQuery("#attribute_1 li:visible:last").css({ "border-bottom": "none" });

  setTimeout(function () {
    //get color ids dynamically
    if (
      mainProductId == "1463683329" ||
      mainProductId == "1465578305" ||
      mainProductId == "5419162049" ||
      mainProductId == "548490182686" ||
      mainProductId == "547124019230" ||
      mainProductId == "560914563102" ||
      mainProductId == "460972461" ||
      mainProductId == "552173862942" ||
      mainProductId == "1466429441" ||
      mainProductId == "1362437865558" ||
      mainProductId == "1358365491286" ||
      mainProductId == decorations.conicHolborn.id
    ) {
      //boggart,savile,arsenal
      var lace1MatId = jQuery("#part_13 .selct-material li:first").attr(
        "mat-id"
      );
      var lace2MatId = jQuery("#part_13 .selct-material li:last").attr(
        "mat-id"
      );

      var lace1ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace1MatId +
          "][titlel='black']"
      ).attr("color-id");
      var lace2ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace2MatId +
          "][titlel='black']"
      ).attr("color-id");

      jQuery("#part_13")
        .find(".thumb_pattern_img")
        .attr("colorid", lace1ColorId)
        .attr("colorname", "Black");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "Black");
    } else if (
      mainProductId == "6050500865" ||
      mainProductId == "9977652737" ||
      mainProductId == "560915906590" ||
      mainProductId == "1467857665" ||
      mainProductId == "552167276574" ||
      mainProductId == "9978267073" ||
      mainProductId == "7743501889" ||
      mainProductId == "460991377" ||
      mainProductId == "1464803201"
    ) {
      //nassua

      var lace1MatId = jQuery("#part_13 .selct-material li:first").attr(
        "mat-id"
      );
      var lace2MatId = jQuery("#part_13 .selct-material li:last").attr(
        "mat-id"
      );

      var lace1ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace1MatId +
          "][titlel='beige']"
      ).attr("color-id");
      var lace2ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace2MatId +
          "][titlel='beige']"
      ).attr("color-id");

      jQuery("#part_13")
        .find(".thumb_pattern_img")
        .attr("colorid", lace1ColorId)
        .attr("colorname", "Beige");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "Beige");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "beige");
    } else if (mainProductId == "1357577519190") {
      //limehouse duplicate
      var lace1MatId = jQuery("#part_13 .selct-material li:first").attr(
        "mat-id"
      );
      var lace2MatId = jQuery("#part_13 .selct-material li:last").attr(
        "mat-id"
      );

      var lace1ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace1MatId +
          "][titlel='mint']"
      ).attr("color-id");
      var lace2ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace2MatId +
          "][titlel='mint']"
      ).attr("color-id");

      jQuery("#part_13")
        .find(".thumb_pattern_img")
        .attr("colorid", lace1ColorId)
        .attr("colorname", "mint");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "mint");
    } else if (
      mainProductId == "4221337537" ||
      mainProductId == "560913252382"
    ) {
      //oddity

      var lace1MatId = jQuery("#part_13 .selct-material li:first").attr(
        "mat-id"
      );
      var lace2MatId = jQuery("#part_13 .selct-material li:last").attr(
        "mat-id"
      );

      var lace1ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace1MatId +
          "][titlel='gray']"
      ).attr("color-id");
      var lace2ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace2MatId +
          "][titlel='gray']"
      ).attr("color-id");

      jQuery("#part_13")
        .find(".thumb_pattern_img")
        .attr("colorid", lace1ColorId)
        .attr("colorname", "Gray");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "Gray");
    } else if (
      mainProductId == "2197325185" ||
      mainProductId == "550440370206"
    ) {
      //saddle//savillie inspiration
      var lace1MatId = jQuery("#part_13 .selct-material li:first").attr(
        "mat-id"
      );
      var lace2MatId = jQuery("#part_13 .selct-material li:last").attr(
        "mat-id"
      );

      var lace1ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace1MatId +
          "][titlel='white']"
      ).attr("color-id");
      var lace2ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace2MatId +
          "][titlel='white']"
      ).attr("color-id");

      jQuery("#part_13")
        .find(".thumb_pattern_img")
        .attr("colorid", lace1ColorId)
        .attr("colorname", "white");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "white");
    } else if (mainProductId == "1362437832790") {
      //morgan
      var lace1MatId = jQuery("#part_13 .selct-material li:first").attr(
        "mat-id"
      );
      var lace2MatId = jQuery("#part_13 .selct-material li:last").attr(
        "mat-id"
      );

      var lace1ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace1MatId +
          "][titlel='electric blue']"
      ).attr("color-id");
      var lace2ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace2MatId +
          "][titlel='electric blue']"
      ).attr("color-id");

      jQuery("#part_13")
        .find(".thumb_pattern_img")
        .attr("colorid", lace1ColorId)
        .attr("colorname", "electric blue");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "electric blue");
    } else if (mainProductId == "460990265") {
      //lenox

      var lace1MatId = jQuery("#part_13 .selct-material li:first").attr(
        "mat-id"
      );
      var lace2MatId = jQuery("#part_13 .selct-material li:last").attr(
        "mat-id"
      );

      var lace1ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace1MatId +
          "][titlel='burgundy']"
      ).attr("color-id");
      var lace2ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace2MatId +
          "][titlel='burgundy']"
      ).attr("color-id");

      jQuery("#part_13")
        .find(".thumb_pattern_img")
        .attr("colorid", lace1ColorId)
        .attr("colorname", "burgundy");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "burgundy");
      //  }else if(mainProductId==decorations.regent.id){//regent

      //    var lace1MatId =  jQuery("#part_13 .selct-material li:first").attr('mat-id');
      //    var lace2MatId =  jQuery("#part_13 .selct-material li:last").attr('mat-id');

      //    var lace1ColorId =  jQuery("#part_13 .scaprt-codes .color-list[parentid="+lace1MatId+"][titlel='gray']").attr("color-id");
      //    var lace2ColorId =  jQuery("#part_13 .scaprt-codes .color-list[parentid="+lace2MatId+"][titlel='gray']").attr("color-id");

      //    jQuery("#part_13").find(".thumb_pattern_img").attr("colorid",lace1ColorId).attr("colorname","gray");
      //    jQuery("#part_13").find(".thumb_color_img").attr("colorid",lace2ColorId).attr("colorname","gray");
    } else {
      var lace1MatId = jQuery("#part_13 .selct-material li:first").attr(
        "mat-id"
      );
      var lace2MatId = jQuery("#part_13 .selct-material li:last").attr(
        "mat-id"
      );

      var lace1ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace1MatId +
          "][titlel='gray']"
      ).attr("color-id");
      var lace2ColorId = jQuery(
        "#part_13 .scaprt-codes .color-list[parentid=" +
          lace2MatId +
          "][titlel='gray']"
      ).attr("color-id");

      jQuery("#part_13")
        .find(".thumb_pattern_img")
        .attr("colorid", lace1ColorId)
        .attr("colorname", "Gray");
      jQuery("#part_13")
        .find(".thumb_color_img")
        .attr("colorid", lace2ColorId)
        .attr("colorname", "Gray");
    }

    //trigger to material 1 set default

    defaultTrigger = true;
    jQuery("#part_19 .attr_list_name").trigger("click");
    jQuery("#part_26 .attr_list_name").trigger("click");
    jQuery("#part_27 .attr_list_name").trigger("click");

    jQuery("#part_23 .attr_list_name").trigger("click");

    jQuery("#part_17 .attr_list_name").trigger("click");
    // jQuery("[name='eyelet']").trigger("click");

    if (
      mainProductId != "6050500865" &&
      mainProductId != "560915906590" &&
      mainProductId != "460972461" &&
      mainProductId != "1466429441" &&
      mainProductId != "7743501889" &&
      mainProductId != "460991377" &&
      mainProductId != "1362437865558" &&
      mainProductId != "1356883951702" &&
      mainProductId != "1357577519190" &&
      mainProductId != "1464803201" &&
      mainProductId != "1358467629142" &&
      mainProductId != "1358365491286" &&
      mainProductId != decorations.conicHolborn.id &&
      mainProductId != "1357580927062" &&
      mainProductId != "6566222337" &&
      mainProductId != decorations.regent.id &&
      mainProductId != decorations.kent.id &&
      mainProductId != decorations.conicKent.id
    ) {
      //nassau
      // alert("inside b1 trigger")
      jQuery("[name='brouge']").trigger("click");
      jQuery(".product-typer")
        .find('input[name="brouge"]')
        .prop("checked", true);
    } else if (mainProductId == "6566222337") {
      //check for duke shoe
      jQuery("#decorations_20 a").trigger("click");

      jQuery("[name='brouge']").trigger("click");
      jQuery(".product-typer")
        .find('input[name="brouge"]')
        .prop("checked", true);
      jQuery("#part_17 .attr_list_name").trigger("click");
      //jQuery('.product-typer').find('input[name="brouge"]').prop('checked',true);
    }

    //hide eyelet thumb
    // jQuery("#part_19").find(".thumb_color_img").show();

    //jQuery(".shoe-data-preloader").hide();
    jQuery(".loading").hide();
    jQuery(".loading1").hide();

    jQuery("body").css("opacity", "1");
    jQuery("header").css("opacity", "1");
    jQuery(".tool-sec").css("opacity", "1");
    jQuery(".shoe-data-preloader").hide();
    loaderFlag = false;

    setTimeout(function () {
      if (
        mainProductId == "550440370206" ||
        mainProductId == "1267259905" ||
        mainProductId == "552167276574" ||
        mainProductId == "552173862942" ||
        mainProductId == "9987925889" ||
        mainProductId == "7743501889" ||
        mainProductId == "1362437832790" ||
        mainProductId == "4219595649" ||
        mainProductId == "4219340353" ||
        mainProductId == "1464803201" ||
        mainProductId == "1357577519190" ||
        mainProductId == "460990265"
      ) {
        //|| mainProductId=="2197325185"
        jQuery("[name='brouge2']").trigger("click");
      }
    }, 500);
  }, 4500);
}

function setDefaultActiveCol() {
  sessionStorage.setItem("customizeThrough", "");

  console.log("in  setDefaultActiveCol ");
  //remove act color all class
  jQuery(".hideColor").removeClass("actColor");
  //remove act color all class

  jQuery(".selct-material").find(".actMaterial").removeClass("actMaterial");

  //here we adding default ids of color which we want to show for shoes when user click on shoe from th
  //product list page
  // we have added it for six shoes,if you want add new shoes the you need to add it at the last
  //after oddity.
  if (mainProductId == "1463683329") {
    //boggart
    //sole
    actPartsColorGroup["10"] = "32_433"; //sole
    jQuery("[color-id=433]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 433, 32);

    //lace
    getColorImg(13, 431, 39);

    //mat 1
    actPartsColorGroup["17"] = "8_306";
    jQuery("a[mat-id=8]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=306]").parent().addClass("actColor");
    getColorImg(17, 306, 8);

    //mat 2
    actPartsColorGroup["18"] = "15_376"; //mat2
    jQuery("a[mat-id=15]").addClass("actMaterial");
    jQuery("[color-id=376]").parent().addClass("actColor");
    getColorImg(18, 376, 15);

    //eyelet
    getColorImg(19, 422, 18);
  } else if (mainProductId == "7632957377") {
    //saratoga

    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "61_769"; //sole
    jQuery("[color-id=769]").parent().addClass("actColor");
    getColorImg(10, 769, 61);

    //mat 1
    actPartsColorGroup["17"] = "40_528";
    jQuery("a[mat-id=40]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=528]").parent().addClass("actColor");
    getColorImg(17, 528, 40);

    //mat 2
    actPartsColorGroup["18"] = "48_618"; //mat2
    jQuery("a[mat-id=48]").addClass("actMaterial");
    jQuery("[color-id=618]").parent().addClass("actColor");
    getColorImg(18, 618, 48);
  } else if (mainProductId == "6050500865") {
    //nassau

    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();
    jQuery(".perfOne").text("");

    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "113_1320"; //sole
    jQuery("[color-id=1320]").parent().addClass("actColor");
    getColorImg(10, 1320, 113);

    //mat 1
    actPartsColorGroup["17"] = "92_1079";
    jQuery("a[mat-id=92]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=1079]").parent().addClass("actColor");
    getColorImg(17, 1079, 92);

    //mat 2
    actPartsColorGroup["18"] = "99_1193";
    jQuery("a[mat-id=99]").addClass("actMaterial");
    jQuery("[color-id=1193]").parent().addClass("actColor");
    getColorImg(18, 1193, 99);

    //lace
    actPartsColorGroup["13"] = "114_2138";
    jQuery("a[mat-id=114]").addClass("actMaterial");
    jQuery("[color-id=2138]").parent().addClass("actColor");
    getColorImg(13, 2138, 114);

    //eyelet
    getColorImg(19, 2074, 186);
  } else if (mainProductId == "1465578305") {
    //saville

    //sole
    actPartsColorGroup["10"] = "108_1304"; //sole
    jQuery("[color-id=1304]").parent().addClass("actColor");
    getColorImg(10, 1304, 108);

    //mat 1
    actPartsColorGroup["17"] = "66_829";
    jQuery("a[mat-id=66]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=829]").parent().addClass("actColor");
    getColorImg(17, 829, 66);

    //mat 2
    actPartsColorGroup["18"] = "76_943";
    jQuery("a[mat-id=76]").addClass("actMaterial");
    jQuery("[color-id=943]").parent().addClass("actColor");
    getColorImg(18, 943, 76);

    //lace
    actPartsColorGroup["13"] = "109_2093";
    jQuery("a[mat-id=109]").addClass("actMaterial");
    jQuery("[color-id=2093]").parent().addClass("actColor");
    getColorImg(13, 2093, 109);

    //piping
    getColorImg(23, 1317, 110);

    //eyelet
    getColorImg(19, 2051, 185);
  } else if (mainProductId == "5419162049") {
    //Arsenal
    jQuery(".product-thumber img").css("padding", "0px 0 15px");
    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();

    //partId,colorId,matId

    //sole
    actPartsColorGroup["10"] = "173_1942"; //sole
    jQuery("[color-id=1942]").parent().addClass("actColor");
    getColorImg(10, 1942, 173);

    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //mat 1
    actPartsColorGroup["17"] = "156_1706";
    jQuery("a[mat-id=156]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=1706]").parent().addClass("actColor");
    getColorImg(17, 1706, 156);

    //mat 2
    actPartsColorGroup["18"] = "163_1790";
    jQuery("a[mat-id=163]").addClass("actMaterial");
    jQuery("[color-id=1790]").parent().addClass("actColor");
    getColorImg(18, 1790, 163);

    //lace
    actPartsColorGroup["13"] = "172_2120";
    jQuery("a[mat-id=172]").addClass("actMaterial");
    jQuery("[color-id=2120]").parent().addClass("actColor");
    getColorImg(13, 2120, 172);

    actPartsColorGroup["27"] = "184_2047"; //zipper
    jQuery("[color-id=2047]").parent().addClass("actColor");
    getColorImg(27, 2047);

    //eyelet
    getColorImg(19, 2030, 181);
  } else if (mainProductId == "4221337537") {
    //Oddity

    //sole
    actPartsColorGroup["10"] = "138_1676"; //sole
    jQuery("[color-id=1676]").parent().addClass("actColor");
    getColorImg(10, 1676, 138);

    //mat 1
    actPartsColorGroup["17"] = "122_1358";
    jQuery("a[mat-id=122]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=1358]").parent().addClass("actColor");
    getColorImg(17, 1358, 122);

    //mat 2
    actPartsColorGroup["18"] = "129_1472";
    jQuery("a[mat-id=129]").addClass("actMaterial");
    jQuery("[color-id=1472]").parent().addClass("actColor");
    getColorImg(18, 1472, 129);

    //lace
    actPartsColorGroup["13"] = "139_2102";
    jQuery("a[mat-id=139]").addClass("actMaterial");
    jQuery("[color-id=2102]").parent().addClass("actColor");
    getColorImg(13, 2102, 139);

    //eyelet
    getColorImg(19, 2038, 183);
    //fringe
    getColorImg(26, 1597, 147);
  } else if (mainProductId == "460972461") {
    //Oddity -2

    //sole
    actPartsColorGroup["10"] = "138_1678"; //sole
    jQuery("[color-id=1678]").parent().addClass("actColor");
    getColorImg(10, 1678, 138);

    //mat 1
    actPartsColorGroup["17"] = "122_1359";
    jQuery("a[mat-id=122]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=1359]").parent().addClass("actColor");
    getColorImg(17, 1359, 122);

    //mat 2
    actPartsColorGroup["18"] = "129_1473";
    jQuery("a[mat-id=129]").addClass("actMaterial");
    jQuery("[color-id=1473]").parent().addClass("actColor");
    getColorImg(18, 1473, 129);

    //lace
    actPartsColorGroup["13"] = "139_2102";
    jQuery("a[mat-id=139]").addClass("actMaterial");
    jQuery("[color-id=2102]").parent().addClass("actColor");
    getColorImg(13, 2102, 139);
  } else if (mainProductId == "9977652737") {
    //Nassau-2

    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();
    jQuery(".perfOne").text("");

    //sole
    actPartsColorGroup["10"] = "192_2082"; //sole
    jQuery("[color-id=2082]").parent().addClass("actColor");
    getColorImg(10, 2082, 192);

    //mat 1
    actPartsColorGroup["17"] = "189_2079";
    jQuery("a[mat-id=189]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=2079]").parent().addClass("actColor");
    getColorImg(17, 2079, 189);

    //mat 2
    actPartsColorGroup["18"] = "190_2080";
    jQuery("a[mat-id=190]").addClass("actMaterial");
    jQuery("[color-id=2080]").parent().addClass("actColor");
    getColorImg(18, 2080, 190);

    //lace
    actPartsColorGroup["13"] = "139_1675";
    jQuery("a[mat-id=139]").addClass("actMaterial");
    jQuery("[color-id=1675]").parent().addClass("actColor");
    getColorImg(13, 1675, 139);
  } else if (mainProductId == "548490182686") {
    //boggart duplicate
    //sole
    actPartsColorGroup["10"] = "1123_18181"; //sole
    jQuery("[color-id=18181]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 18181, 1123);

    //lace
    getColorImg(13, 18191, 1124);

    //mat 1
    actPartsColorGroup["17"] = "1105_17888";
    jQuery("a[mat-id=1105]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=17888]").parent().addClass("actColor");
    getColorImg(17, 17888, 1105);

    //mat 2
    actPartsColorGroup["18"] = "1033_18046"; //mat2
    jQuery("a[mat-id=1112]").addClass("actMaterial");
    jQuery("[color-id=18046]").parent().addClass("actColor");
    getColorImg(18, 18046, 1112);

    //eyelet
    getColorImg(19, 18092, 1115);
  } else if (mainProductId == "560913252382") {
    //Oddity duplicate
    //sole
    actPartsColorGroup["10"] = "1203_19042"; //sole
    jQuery("[color-id=19042]").parent().addClass("actColor");
    getColorImg(10, 19042, 1203);

    //mat 1
    actPartsColorGroup["17"] = "1187_18845";
    jQuery("a[mat-id=1187]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=18845]").parent().addClass("actColor");
    getColorImg(17, 18845, 1187);

    //mat 2
    actPartsColorGroup["18"] = "1194_18929";
    jQuery("a[mat-id=1194]").addClass("actMaterial");
    jQuery("[color-id=18929]").parent().addClass("actColor");
    getColorImg(18, 18929, 1194);

    //lace
    actPartsColorGroup["13"] = "1204_190515";
    jQuery("a[mat-id=1204]").addClass("actMaterial");
    jQuery("[color-id=19051]").parent().addClass("actColor");
    getColorImg(13, 19051, 1204);

    //eyelet
    getColorImg(19, 19153, 1215);
  } else if (mainProductId == "560918298654") {
    //saratogga duplicate
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "861_13359"; //sole
    jQuery("[color-id=13359]").parent().addClass("actColor");
    getColorImg(10, 13359, 861);

    //mat 1
    actPartsColorGroup["17"] = "840_13107";
    jQuery("a[mat-id=840]").addClass("actMaterial");
    //jQuery("a[mat-id=45]").trigger("click");
    jQuery("[color-id=13107]").parent().addClass("actColor");
    getColorImg(17, 13107, 840);

    //mat 2
    actPartsColorGroup["18"] = "848_13200"; //mat2
    jQuery("a[mat-id=848]").addClass("actMaterial");
    jQuery("[color-id=13200]").parent().addClass("actColor");
    getColorImg(18, 13200, 848);
  } else if (mainProductId == "547124019230") {
    //saville duplicate
    //sole
    actPartsColorGroup["10"] = "826_12953"; //sole
    jQuery("[color-id=12953]").parent().addClass("actColor");
    getColorImg(10, 12953, 826);

    //mat 1
    actPartsColorGroup["17"] = "807_12718";
    jQuery("a[mat-id=807]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=12718]").parent().addClass("actColor");
    getColorImg(17, 12718, 807);

    //mat 2
    actPartsColorGroup["18"] = "817_12833";
    jQuery("a[mat-id=817]").addClass("actMaterial");
    jQuery("[color-id=12833]").parent().addClass("actColor");
    getColorImg(18, 12833, 817);

    //piping
    getColorImg(23, 12964, 828);

    //lace
    actPartsColorGroup["13"] = "827_12963";
    jQuery("a[mat-id=827]").addClass("actMaterial");
    jQuery("[color-id=12963]").parent().addClass("actColor");
    getColorImg(13, 12963, 827);

    //eyelet
    getColorImg(19, 13004, 832);

    // jQuery("[name='rivetsilver']").trigger("click");
  } else if (mainProductId == "560914563102") {
    //arsenal duplicate
    jQuery(".product-thumber img").css("padding", "0px 0 15px");

    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();

    //sole
    actPartsColorGroup["10"] = "1149_18471"; //sole
    jQuery("[color-id=18471]").parent().addClass("actColor");
    getColorImg(10, 18471);

    //zipper

    actPartsColorGroup["27"] = "1154_18493"; //zipper
    jQuery("[color-id=18493]").parent().addClass("actColor");
    getColorImg(27, 18493);

    jQuery("[name=perforation]").prop("checked", true).trigger("change");

    //mat 1
    actPartsColorGroup["17"] = "1132_18262";
    jQuery("a[mat-id=1132]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=18262]").parent().addClass("actColor");
    getColorImg(17, 18262, 1132);

    //mat 2
    actPartsColorGroup["18"] = "1139_18348";
    jQuery("a[mat-id=1139]").addClass("actMaterial");
    jQuery("[color-id=18348]").parent().addClass("actColor");
    getColorImg(18, 18348, 1139);

    //lace
    actPartsColorGroup["13"] = "1148_18469";
    jQuery("a[mat-id=1148]").addClass("actMaterial");
    jQuery("[color-id=18469]").parent().addClass("actColor");
    getColorImg(13, 18469, 1148);

    //eyelet
    getColorImg(19, 18487, 1153);
  } else if (mainProductId == "560915906590") {
    //Nassau duplicate
    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();
    jQuery(".perfOne").text("");
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "1176_18761"; //sole
    jQuery("[color-id=18761]").parent().addClass("actColor");

    getColorImg(10, 18761, 1176);

    //mat 1
    actPartsColorGroup["17"] = "1160_18556";
    jQuery("a[mat-id=1160]").addClass("actMaterial");

    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=18556]").parent().addClass("actColor");
    getColorImg(17, 18556, 1160);

    //mat 2
    actPartsColorGroup["18"] = "1167_18643";
    jQuery("a[mat-id=1167]").addClass("actMaterial");
    jQuery("[color-id=18643]").parent().addClass("actColor");
    getColorImg(18, 18643, 1167);

    //lace
    actPartsColorGroup["13"] = "1177_18770";

    jQuery("a[mat-id=1177]").addClass("actMaterial");
    jQuery("[color-id=18770]").parent().addClass("actColor");

    getColorImg(13, 18770, 1177);

    //eyelet
    getColorImg(19, 18783, 1181);
  } else if (mainProductId == "1467857665") {
    //Armada

    jQuery(".product-thumber img").css("padding", "0px 0 15px");
    //hide perforation option 2
    jQuery("input[name='perforation2']").parent().hide();

    //partId,colorId,matId

    //sole
    actPartsColorGroup["10"] = "1074_17469"; //sole
    jQuery("[color-id=17469]").parent().addClass("actColor");
    getColorImg(10, 17469, 1074);

    //jQuery("[name=perforation]").prop("checked",false).trigger("change");

    //mat 1
    actPartsColorGroup["17"] = "1063_17496";
    jQuery("a[mat-id=1063]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=17496]").parent().addClass("actColor");
    getColorImg(17, 17496, 1063);

    //mat 2
    actPartsColorGroup["18"] = "1070_17489";
    jQuery("a[mat-id=1070]").addClass("actMaterial");
    jQuery("[color-id=17489]").parent().addClass("actColor");
    getColorImg(18, 17489, 1070);

    //lace
    actPartsColorGroup["13"] = "1057_17590";
    jQuery("a[mat-id=1057]").addClass("actMaterial");
    jQuery("[color-id=17590]").parent().addClass("actColor");
    getColorImg(13, 17590, 1057);

    //eyelet
    getColorImg(19, 17464, 1056);
  } else if (mainProductId == "1267259905") {
    //Hudson
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "1468_24119"; //sole
    jQuery("[color-id=24119]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 24119, 1468);

    //lace
    getColorImg(13, 21993, 1449);

    //mat 1
    actPartsColorGroup["17"] = "1428_21778";
    jQuery("a[mat-id=1428]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=21778]").parent().addClass("actColor");
    getColorImg(17, 21778, 1428);

    //mat 2
    actPartsColorGroup["18"] = "1435_21803"; //mat2
    jQuery("a[mat-id=1435]").addClass("actMaterial");
    jQuery("[color-id=21803]").parent().addClass("actColor");
    getColorImg(18, 21803, 1435);

    //mat 3
    actPartsColorGroup["29"] = "1442_21828"; //mat2
    jQuery("a[mat-id=1442]").addClass("actMaterial");
    jQuery("[color-id=21828]").parent().addClass("actColor");
    getColorImg(29, 21828, 1442);

    //eyelet
    getColorImg(19, 24117, 1453);
  } else if (mainProductId == "1362437832790") {
    //morgan
    jQuery("#part_17").find(".selct-material").find('li[mat-id="2395"]').hide();

    var bChk = jQuery(".product-typer")
      .find('input[name="brouge2"]')
      .prop("checked");
    if (bChk == false) {
      jQuery("#view_1").find("img[rel=29][isicon=no]").hide();
      jQuery("#view_2").find("img[rel=29][isicon=no]").hide();
      jQuery("#part_29").hide();
    }
    jQuery("#view_1").find("img[rel=29][isicon=no]").hide();
    jQuery("#view_2").find("img[rel=29][isicon=no]").hide();
    //sole
    actPartsColorGroup["10"] = "2437_33486"; //sole
    jQuery("[color-id=33486]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 33486, 2437);

    //lace
    getColorImg(13, 33496, 2438);

    //mat 1
    actPartsColorGroup["17"] = "2416_33233";
    jQuery("a[mat-id=2416]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=33233]").parent().addClass("actColor");
    getColorImg(17, 33233, 2416);

    //mat 2
    actPartsColorGroup["18"] = "2423_33321"; //mat2
    jQuery("a[mat-id=2423]").addClass("actMaterial");
    jQuery("[color-id=33321]").parent().addClass("actColor");
    getColorImg(18, 33321, 2423);

    //mat 3
    actPartsColorGroup["29"] = "2430_33409"; //mat2
    jQuery("a[mat-id=2430]").addClass("actMaterial");
    jQuery("[color-id=33409]").parent().addClass("actColor");
    getColorImg(29, 33409, 2430);

    //eyelet
    getColorImg(19, 34870, 2552);
  } else if (mainProductId == "460990265") {
    //lenox

    /* var bChk=jQuery('.product-typer').find('input[name="brouge2"]').prop('checked');
   if(bChk==false){
     jQuery("#view_1").find('img[rel=29][isicon=no]').hide();
     jQuery("#view_2").find('img[rel=29][isicon=no]').hide();
     jQuery("#part_29").hide();
   }
    jQuery("#view_1").find('img[rel=29][isicon=no]').hide();
     jQuery("#view_2").find('img[rel=29][isicon=no]').hide();*/
    //sole
    actPartsColorGroup["10"] = "3194_42540"; //sole
    jQuery("[color-id=42540]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 42540, 3194);

    //lace
    getColorImg(13, 42556, 3196);

    //mat 1
    actPartsColorGroup["17"] = "3166_42199";
    jQuery("a[mat-id=3166]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=42199]").parent().addClass("actColor");
    getColorImg(17, 42199, 3166);

    //mat 2
    actPartsColorGroup["18"] = "3173_42287"; //mat2
    jQuery("a[mat-id=3173]").addClass("actMaterial");
    jQuery("[color-id=42287]").parent().addClass("actColor");
    getColorImg(18, 42287, 3173);

    //mat 3
    actPartsColorGroup["29"] = "3212_42769"; //mat3
    jQuery("a[mat-id=3212]").addClass("actMaterial");
    jQuery("[color-id=42769]").parent().addClass("actColor");
    getColorImg(29, 42769, 3212);

    //eyelet
    getColorImg(19, 42544, 3195);
  } else if (mainProductId == "1358365491286") {
    //holborn

    jQuery("#part_37")
      .find(".inter-design-way .selct-material")
      .find("li[titlelm='natural']")
      .insertBefore(
        jQuery("#part_37")
          .find(".inter-design-way .selct-material")
          .find("li[titlelm='soft leather']")
      );

    //sole
    actPartsColorGroup["10"] = "3260_43374"; //sole
    jQuery("[color-id=43374]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 43374, 3260);

    //lace
    getColorImg(13, 43348, 3258);

    //heel
    getColorImg(37, 44607, 3381);

    //mat 1
    actPartsColorGroup["17"] = "3233_43033";
    jQuery("a[mat-id=3233]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=43033]").parent().addClass("actColor");
    getColorImg(17, 43033, 3233);

    //mat 2
    actPartsColorGroup["18"] = "3240_43121"; //mat2
    jQuery("a[mat-id=3240]").addClass("actMaterial");
    jQuery("[color-id=43121]").parent().addClass("actColor");
    getColorImg(18, 43121, 3240);

    //mat 3
    actPartsColorGroup["29"] = "3247_43209"; //mat3
    jQuery("a[mat-id=3247]").addClass("actMaterial");
    jQuery("[color-id=43209]").parent().addClass("actColor");
    getColorImg(29, 43209, 3247);

    //eyelet
    getColorImg(19, 43336, 3257);
  }else if( mainProductId == decorations.conicHolborn.id) {
    //conic holborn

    jQuery("#part_37")
      .find(".inter-design-way .selct-material")
      .find("li[titlelm='natural']")
      .insertBefore(
        jQuery("#part_37")
          .find(".inter-design-way .selct-material")
          .find("li[titlelm='soft leather']")
      );

    //sole
    actPartsColorGroup["10"] = "3930_51109"; //sole
    jQuery("[color-id=51109]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 51109, 3930);

    //lace
    getColorImg(13, 51083, 3928);

    //heel
    getColorImg(37, 51111, 3931);

    //mat 1
    actPartsColorGroup["17"] = "3904_50777";
    jQuery("a[mat-id=3904]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=50777]").parent().addClass("actColor");
    getColorImg(17, 50777, 3904);

    //mat 2
    actPartsColorGroup["18"] = "3911_50865"; //mat2
    jQuery("a[mat-id=3911]").addClass("actMaterial");
    jQuery("[color-id=50865]").parent().addClass("actColor");
    getColorImg(18, 50865, 3911);

    //mat 3
    actPartsColorGroup["29"] = "3918_50953"; //mat3
    jQuery("a[mat-id=3918]").addClass("actMaterial");
    jQuery("[color-id=50953]").parent().addClass("actColor");
    getColorImg(29, 50953, 3918);

    //eyelet
    getColorImg(19, 51071, 3927);
  } else if (mainProductId == "1358467629142") {
    //marry

    //sole
    actPartsColorGroup["10"] = "3419_45066"; //sole
    jQuery("[color-id=45066]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 45066, 3419);

    //buckle
    getColorImg(33, 45064, 3418);

    //mat 1
    actPartsColorGroup["17"] = "3383_44635";
    jQuery("a[mat-id=3383]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=44635]").parent().addClass("actColor");
    getColorImg(17, 44635, 3383);

    //mat 2
    actPartsColorGroup["18"] = "3390_44723"; //mat2
    jQuery("a[mat-id=3390]").addClass("actMaterial");
    jQuery("[color-id=44723]").parent().addClass("actColor");
    getColorImg(18, 44723, 3390);

    //mat 3
    actPartsColorGroup["29"] = "3397_44811"; //mat3
    jQuery("a[mat-id=3397]").addClass("actMaterial");
    jQuery("[color-id=44811]").parent().addClass("actColor");
    getColorImg(29, 44811, 3397);
  } else if (mainProductId == "1357580927062") {
    //baron

    jQuery("#part_29").hide();
    jQuery("#part_38").hide();
    jQuery("#view_1").find("img[rel=29][isicon='no']").hide();
    jQuery("#view_2").find("img[rel=29][isicon='no']").hide();

    //sole
    actPartsColorGroup["10"] = "3261_43376"; //sole
    jQuery("[color-id=43376]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 43376, 3261);

    //mat 1
    actPartsColorGroup["17"] = "3263_43391";
    jQuery("a[mat-id=3263]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=43391]").parent().addClass("actColor");
    getColorImg(17, 43391, 3263);

    //mat 2
    actPartsColorGroup["18"] = "3270_43479"; //mat2
    jQuery("a[mat-id=3270]").addClass("actMaterial");
    jQuery("[color-id=43479]").parent().addClass("actColor");
    getColorImg(18, 43479, 3270);

    //mat 3
    actPartsColorGroup["29"] = "3277_43567"; //mat3
    jQuery("a[mat-id=3277]").addClass("actMaterial");
    jQuery("[color-id=43567]").parent().addClass("actColor");
    getColorImg(29, 43567, 3277);

    //buckle
    getColorImg(33, 43378, 3262);

    //toe cap
    actPartsColorGroup["38"] = "3298_43743";
    getColorImg(38, 43743, 3298);
  } else if (mainProductId == decorations.jane.id) {
    //jane

    setDefaultActiveColJane();
  }else if (mainProductId == decorations.janePumps.id) {
    //janePumps

    setDefaultActiveColJanePumps();
  }else if(mainProductId == decorations.astoria.id){
    setDefaultActiveConfAstoria();
  }else if (mainProductId == decorations.burton.id) {
    //Burton

    setDefaultConfBurton();
  } else if (mainProductId == decorations.aldgate.id) {
    //Aldgate

    setDefaultConfAldgate();
  } else if(mainProductId == decorations.conicAldgate.id) {
    setDefaultConfConicAldgate();
  }else if (mainProductId == decorations.kent.id) {
    //Aldgate

    setDefaultConfKent();
  }else if (mainProductId == decorations.conicKent.id) {

    setDefaultConfConicKent();
  }else if (mainProductId == decorations.florence.id) {
    //Florence

    setDefaultConfFlorence();
  } else if (mainProductId == decorations.joplin.id) {
    //Joplin

    setDefaultConfJoplin();
  }else if (mainProductId == decorations.joplinPumps.id) {
    //JoplinPumps

    setDefaultConfJoplinPumps();
  }  else if (mainProductId == "6566222337") {
    //duke

    jQuery("#part_29").hide();
    jQuery("#view_1").find("img[rel=29][isicon='no']").hide();
    jQuery("#view_2").find("img[rel=29][isicon='no']").hide();

    jQuery("#part_38").hide();
    //sole
    actPartsColorGroup["10"] = "3306_43822"; //sole
    jQuery("[color-id=43822]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 43822, 3306);

    //mat 1
    actPartsColorGroup["17"] = "3307_43835";
    jQuery("a[mat-id=3307]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=43835]").parent().addClass("actColor");
    getColorImg(17, 43835, 3307);

    //mat 2
    actPartsColorGroup["18"] = "3314_43923"; //mat2
    jQuery("a[mat-id=3314]").addClass("actMaterial");
    jQuery("[color-id=43923]").parent().addClass("actColor");
    getColorImg(18, 43923, 3314);

    //mat 3
    actPartsColorGroup["29"] = "3357_44355"; //mat3
    jQuery("a[mat-id=3357]").addClass("actMaterial");
    jQuery("[color-id=44355]").parent().addClass("actColor");
    getColorImg(29, 44355, 3357);

    //buckle
    getColorImg(33, 44342, 3356);

    //toe cap
    actPartsColorGroup["38"] = "3364_44531";
    getColorImg(38, 44531, 3364);
  } else if (mainProductId == "4219340353") {
    //Classon
    jQuery(".product-thumber img").css("padding", "0px 0 15px");
    jQuery('input[name="reartab"]').prop("checked", false);
    jQuery("#part_36").hide();
    var views = productViews["views"];
    for (var view in views) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=32][isicon=no]")
        .hide();
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=36][isicon=no]")
        .hide();
    }

    //sole
    actPartsColorGroup["10"] = "2519_34465"; //sole
    jQuery("[color-id=34465]").parent().addClass("actColor");
    getColorImg(10, 34465, 2519);

    //jQuery("[name=perforation]").prop("checked",false).trigger("change");

    //buckle
    getColorImg(33, 34467, 2520);
    //strap
    getColorImg(35, 34662, 2536);

    //mat 1
    actPartsColorGroup["17"] = "2522_34486";
    jQuery("a[mat-id=2522]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=34486]").parent().addClass("actColor");
    getColorImg(17, 34486, 2522);

    //mat 2
    actPartsColorGroup["18"] = "2529_34574";
    jQuery("a[mat-id=2529]").addClass("actMaterial");
    jQuery("[color-id=34574]").parent().addClass("actColor");
    getColorImg(18, 34574, 2529);

    actPartsColorGroup["27"] = "2521_34474"; //Zippper
    jQuery("[color-id=34474]").parent().addClass("actColor");
    getColorImg(27, 34474, 2521);

    actPartsColorGroup["32"] = "2538_34687"; //rear tab
    jQuery("[color-id=34687]").parent().addClass("actColor");
    getColorImg(32, 34687, 2538);
  } else if (mainProductId == "6567881729") {
    //Madeline
    //sole
    actPartsColorGroup["10"] = "2454_33698"; //sole
    jQuery("[color-id=33698]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 33698, 2454);

    //mat 1
    actPartsColorGroup["17"] = "2456_33713";
    jQuery("a[mat-id=2456]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=33713]").parent().addClass("actColor");
    getColorImg(17, 33713, 2456);

    //mat 2
    actPartsColorGroup["18"] = "2463_33801"; //mat2
    jQuery("a[mat-id=2463]").addClass("actMaterial");
    jQuery("[color-id=33801]").parent().addClass("actColor");
    getColorImg(18, 33801, 2463);

    //buckle
    getColorImg(33, 33700, 2455);

    //Strap
    getColorImg(35, 34074, 2486);
  } else if (mainProductId == "1358334558294") {
    //Viennal

    //sole
    actPartsColorGroup["10"] = "2493_34151"; //sole
    jQuery("[color-id=34151]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 34151, 2493);

    //mat 1
    actPartsColorGroup["17"] = "2496_34198";
    jQuery("a[mat-id=2496]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=34198]").parent().addClass("actColor");
    getColorImg(17, 34198, 2496);

    //mat 2
    actPartsColorGroup["18"] = "2463_34285"; //mat2
    jQuery("a[mat-id=2503]").addClass("actMaterial");
    jQuery("[color-id=34285]").parent().addClass("actColor");
    getColorImg(18, 34285, 2503);

    //lace 1
    getColorImg(13, 34178, 2494);
    //lace 2
    getColorImg(13, 34161, 2495);
    //eyelet
    getColorImg(19, 34452, 2517);
  } else if (mainProductId == "2197325185") {
    //Saddle
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    jQuery(".perfOne").text("");
    //sole
    actPartsColorGroup["10"] = "1550_24095"; //sole
    jQuery("[color-id=24095]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 24095, 1550);

    //lace
    getColorImg(13, 23895, 1533);

    //mat 1
    actPartsColorGroup["17"] = "1539_23126";
    jQuery("a[mat-id=1539]").addClass("actMaterial");
    //jQuery("a[mat-id=4]").trigger("click");
    jQuery("[color-id=23126]").parent().addClass("actColor");
    getColorImg(17, 23126, 1539);

    //mat 2
    actPartsColorGroup["18"] = "1546_23840"; //mat2
    jQuery("a[mat-id=1546]").addClass("actMaterial");
    jQuery("[color-id=23840]").parent().addClass("actColor");
    getColorImg(18, 23840, 1546);

    //eyelet
    getColorImg(19, 24093, 1532);
  } else if (mainProductId == "552167276574") {
    //harlow
    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    //sole
    actPartsColorGroup["10"] = "32_433"; //sole => materialid_colorid
    jQuery("[color-id=433]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 433, 32);

    //lace
    getColorImg(13, 24993, 1585);

    //mat 1
    actPartsColorGroup["17"] = "1591_24173";
    jQuery("a[mat-id=1591]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=24173]").parent().addClass("actColor");
    getColorImg(17, 24173, 1591);

    //mat 2
    actPartsColorGroup["18"] = "1598_24360"; //mat2
    jQuery("a[mat-id=1598]").addClass("actMaterial");
    jQuery("[color-id=24360]").parent().addClass("actColor");
    getColorImg(18, 24360, 1598);

    //eyelet
    getColorImg(19, 25022, 1584);
  } else if (mainProductId == "460991377") {
    //gatsby

    jQuery("[name=perforation]").prop("checked", false).trigger("change");
    //sole
    actPartsColorGroup["10"] = "1683_25421"; //sole => materialid_colorid
    jQuery("[color-id=25421]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 25421, 1683);

    //lace
    getColorImg(13, 25394, 1680);

    //jQuery('#part_18').find('.selct-material').find('li[titlelm="fabric"]').addClass('not-active')

    //mat 1
    actPartsColorGroup["17"] = "1649_25080";
    jQuery("a[mat-id=1649]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=25080]").parent().addClass("actColor");
    getColorImg(17, 25080, 1649);

    //mat 2
    actPartsColorGroup["18"] = "1670_25167"; //mat2
    jQuery("a[mat-id=1670]").addClass("actMaterial");
    jQuery("[color-id=25167]").parent().addClass("actColor");
    getColorImg(18, 25167, 1670);

    //eyelet
    getColorImg(19, 25424, 1673);
  } else if (mainProductId == "9987925889") {
    //lamont

    jQuery("[name=perforation]").prop("checked", false).trigger("change");

    jQuery(".product-thumber img").css("padding", "0px 0 15px");
    jQuery(".product-thumber img").parent().addClass("biggerThumbnail");

    //sole
    actPartsColorGroup["10"] = "1713_433"; //sole => materialid_colorid
    jQuery("[color-id=25825]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 25825, 1713);

    //mat 1
    actPartsColorGroup["17"] = "1688_25514";
    jQuery("a[mat-id=1688]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=25514]").parent().addClass("actColor");
    getColorImg(17, 25514, 1688);

    //mat 2
    actPartsColorGroup["18"] = "1695_25601"; //mat2
    jQuery("a[mat-id=1695]").addClass("actMaterial");
    jQuery("[color-id=25601]").parent().addClass("actColor");
    getColorImg(18, 25601, 1695);

    //rear tab
    actPartsColorGroup["32"] = "1720_25880";
    jQuery("a[mat-id=1720]").addClass("actMaterial");
    jQuery("[color-id=25880]").parent().addClass("actColor");
    getColorImg(32, 25880, 1720);

    //elastic
    actPartsColorGroup["31"] = "1842_27263";
    jQuery("a[mat-id=1842]").addClass("actMaterial");
    jQuery("[color-id=27263]").parent().addClass("actColor");
    getColorImg(31, 27263, 1842);
  } else if (mainProductId == "4219595649") {
    //Chelsea

    jQuery(".product-thumber img").css("padding", "0px 0 15px");
    jQuery(".product-thumber img").parent().addClass("biggerThumbnail");
    jQuery('input[name="reartab"]').prop("checked", false);
    var views = productViews["views"];
    for (var view in views) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=32][isicon=no]")
        .hide();
    }
    //sole
    actPartsColorGroup["10"] = "2363_32631"; //sole => materialid_colorid
    jQuery("[color-id=32631]").parent().addClass("actColor");
    //parameter Attribute id , color id , Material id.
    getColorImg(10, 32631, 2368);

    //mat 1
    actPartsColorGroup["17"] = "2331_32255";
    jQuery("a[mat-id=2331]").addClass("actMaterial");
    //jQuery("a[mat-id=8]").trigger("click");
    jQuery("[color-id=32255]").parent().addClass("actColor");
    getColorImg(17, 32255, 2331);

    //mat 2
    actPartsColorGroup["18"] = "2339_32343"; //mat2
    jQuery("a[mat-id=2339]").addClass("actMaterial");
    jQuery("[color-id=32343]").parent().addClass("actColor");
    getColorImg(18, 32343, 2339);

    //rear tab
    actPartsColorGroup["32"] = "2355_32552";
    jQuery("a[mat-id=2355]").addClass("actMaterial");
    jQuery("[color-id=32552]").parent().addClass("actColor");
    getColorImg(32, 32552, 2355);

    //elastic
    actPartsColorGroup["31"] = "2353_32508";
    jQuery("a[mat-id=2353]").addClass("actMaterial");
    jQuery("[color-id=32508]").parent().addClass("actColor");
    getColorImg(31, 32508, 2353);
  } else if (mainProductId == "1464803201") {
    //limehouse

    var bChk = jQuery(".product-typer")
      .find('input[name="brouge2"]')
      .prop("checked");
    if (!bChk) {
      jQuery("#view_1").find("img[rel=29][isicon=no]").hide();
      jQuery("#view_2").find("img[rel=29][isicon=no]").hide();
      jQuery("#part_29").hide();
    }

    //sole
    actPartsColorGroup["10"] = "2322_32242"; //sole
    jQuery("[color-id=32242]").parent().addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(10, 32242, 2322);

    //mat 1
    actPartsColorGroup["17"] = "2283_31771";
    jQuery("a[mat-id=2283]").addClass("actMaterial");
    //jQuery("#part_"+17+" a[mat-id="+2283+"]").trigger("click");
    jQuery("[color-id=31771]").parent().addClass("actColor");
    getColorImg(17, 31771, 2283);

    //mat 2
    actPartsColorGroup["18"] = "2290_31874"; //mat2
    jQuery("a[mat-id=2290]").addClass("actMaterial");
    jQuery("[color-id=31874]").parent().addClass("actColor");
    getColorImg(18, 31874, 2290);

    //mat 3
    actPartsColorGroup["29"] = "2297_31962"; //mat3
    jQuery("a[mat-id=2297]").addClass("actMaterial");
    jQuery("[color-id=31962]").parent().addClass("actColor");
    getColorImg(29, 31962, 2297);

    //lace 1
    getColorImg(13, 32232, 2320);
    //lace 2
    getColorImg(13, 32241, 2321);
  } else if (mainProductId == decorations.regent.id) {
    //Regent

    setDefaultActiveColRegent();
  }

  //trigger to material 1 set default
  jQuery("#part_19 .attr_list_name").trigger("click");
  jQuery("#part_29 .attr_list_name").trigger("click");
  jQuery("#part_26 .attr_list_name").trigger("click");
  jQuery("#part_27 .attr_list_name").trigger("click");
  jQuery("#part_23 .attr_list_name").trigger("click");
  jQuery("#part_17 .attr_list_name").trigger("click");

  //change position of rivet section and hide fro list
  /*  jQuery("#part_21 .scaprt-codes").clone().appendTo("#rivetColor"); 
  jQuery("#rivetColor ul").show();
  jQuery("#rivetColor ul").removeClass("scaprt-codes").addClass("rivetColors");*/
  jQuery("#part_21").hide();

  //set attribute order
  jQuery("#part_17").insertBefore("#part_10");
  jQuery("#part_18").insertAfter("#part_17");
  jQuery("#part_13").insertAfter("#part_18");
  jQuery("#part_19").insertAfter("#part_13");
  jQuery("#part_29").insertAfter("#part_18");

  jQuery("#part_33").insertAfter("#part_35");
  jQuery("#part_31").insertAfter("#part_33");
  jQuery("#part_32").insertAfter("#part_31");
  jQuery("#part_27").insertAfter("#part_32");
  jQuery("#part_10").insertAfter("#part_27");

  //jQuery("#part_32").insertAfter("#part_31");
  //jQuery("#part_33").insertAfter("#part_27");
  //jQuery("#part_35").insertAfter("#part_33");

  //jQuery("#decorations_20").insertAfter("#part_33");
  // jQuery("#part_10").insertAfter("#decorations_20");
  //jQuery("#decorations_20").insertBefore("#part_10");

  // jQuery("#decorations_20").insertAfter("#part_32");

  jQuery("#part_26").insertAfter("#decorations_20");
  jQuery("#part_27").insertBefore("#decorations_20");

  jQuery("#part_23").insertAfter("#decorations_20");
  //sole at end
  jQuery("#part_10").insertAfter("#part_21");

  jQuery("#part_10").insertAfter("#part_33");
  //jQuery("#part_10").insertAfter("#part_27");
  jQuery("#part_10").insertAfter("#decorations_20");

  jQuery("#part_37").insertAfter("#part_10");

  //hide material section  of sole , lace and eyelets

  /*jQuery("#part_10").find(".selct-material").parent().parent().hide();
   jQuery("#part_19").find(".selct-material").parent().parent().hide();
   jQuery("#part_13").find(".selct-material").parent().parent().hide();*/
  jQuery("#attribute_1 li:visible:last").css({ "border-bottom": "none" });

  setTimeout(function () {
    //get color ids dynamically
    var lace1MatId = jQuery("#part_13 .selct-material li:first").attr("mat-id");
    var lace2MatId = jQuery("#part_13 .selct-material li:last").attr("mat-id");

    var lace1ColorId = jQuery(
      "#part_13 .scaprt-codes .color-list[parentid=" +
        lace1MatId +
        "][titlel='white']"
    ).attr("color-id");
    var lace2ColorId = jQuery(
      "#part_13 .scaprt-codes .color-list[parentid=" +
        lace2MatId +
        "][titlel='white']"
    ).attr("color-id");

    var lace1ColorSrc = jQuery(
      "#part_13 .scaprt-codes .color-list[parentid=" +
        lace1MatId +
        "][titlel='white'] img"
    ).attr("src");
    var lace2ColorSrc = jQuery(
      "#part_13 .scaprt-codes .color-list[parentid=" +
        lace2MatId +
        "][titlel='white'] img"
    ).attr("src");

    jQuery("#part_13")
      .find(".thumb_pattern_img")
      .attr("colorid", lace1ColorId)
      .attr("colorname", "White")
      .attr("src", lace1ColorSrc);
    jQuery("#part_13")
      .find(".thumb_color_img")
      .attr("colorid", lace2ColorId)
      .attr("colorname", "White")
      .attr("src", lace2ColorSrc);

    //hide eyelet thumb
    jQuery("#part_19").find(".thumb_color_img").hide();

    jQuery(".loading").hide();

    jQuery(".loading1").hide();
    jQuery("body").css("opacity", "1");

    jQuery("header").css("opacity", "1");
    jQuery(".tool-sec").css("opacity", "1");
    jQuery(".shoe-data-preloader").hide();

    loaderFlag = false;
  }, 2000);
}

function setDefaultActiveColJane() {
  jQuery("#part_29").hide();
  jQuery("#part_38").hide();
  jQuery("#view_1").find("img[rel=29][isicon='no']").hide();
  jQuery("#view_2").find("img[rel=29][isicon='no']").hide();
  jQuery("#view_1").find("img[rel=20][isicon='no']").hide();
  jQuery("#view_2").find("img[rel=20][isicon='no']").hide();

  // set toecap and brogue inactive
  jQuery(".product-typer").find('input[name="toecap"]').prop("checked", true);
  jQuery(".product-typer").find('input[name="toecap"]').trigger("click");

  //sole
  var softMatId = 3571;
  var whiteColorId = 46859;
  actPartsColorGroup["10"] = softMatId + "_" + whiteColorId;
  jQuery("[color-id=" + whiteColorId + "]")
    .parent()
    .addClass("actColor");
  //attributeid , colorid , materialid
  getColorImg(10, whiteColorId, softMatId);

  //mat 1
  var softMatId = 3499;
  var whiteColorId = 46040;
  actPartsColorGroup["17"] = softMatId + "_" + whiteColorId;
  jQuery("a[mat-id=" + softMatId + "]").addClass("actMaterial");
  //jQuery("a[mat-id=4]").trigger("click");
  jQuery("[color-id=" + whiteColorId + "]")
    .parent()
    .addClass("actColor");
  getColorImg(17, whiteColorId, softMatId);

  //mat 2
  var softMatId = 3505;
  var whiteColorId = 46113;
  actPartsColorGroup["18"] = softMatId + "_" + whiteColorId;
  jQuery("a[mat-id=" + softMatId + "]").addClass("actMaterial");
  jQuery("[color-id=" + whiteColorId + "]")
    .parent()
    .addClass("actColor");
  getColorImg(18, whiteColorId, softMatId);

  //mat 3
  var softMatId = 3513;
  var whiteColorId = 46647;
  actPartsColorGroup["29"] = softMatId + "_" + whiteColorId;
  jQuery("a[mat-id=" + softMatId + "]").addClass("actMaterial");
  jQuery("[color-id=" + whiteColorId + "]")
    .parent()
    .addClass("actColor");
  getColorImg(29, whiteColorId, softMatId);

  //buckle
  getColorImg(33, 46862, 3531);

  //toe cap
  actPartsColorGroup["38"] = "3298_43743";
  getColorImg(38, 43743, 3298);
}

function setDecorationStatus(name, active) {
  jQuery(".product-typer")
    .find('input[name="' + name + '"]')
    .prop("checked", !active);
  jQuery(".product-typer")
    .find('input[name="' + name + '"]')
    .trigger("click");
}

function setDefaultActiveColJanePumps() {
  jQuery("#part_29").hide();
  jQuery("#part_39").hide();
  jQuery("#view_1").find("img[rel=29][isicon='no']").hide();
  jQuery("#view_2").find("img[rel=29][isicon='no']").hide();
  jQuery("#view_1").find("img[rel=20][isicon='no']").hide();
  jQuery("#view_2").find("img[rel=20][isicon='no']").hide();

  // set toecap and brogue inactive
  jQuery(".product-typer").find('input[name="toecap"]').prop("checked", true);
  jQuery(".product-typer").find('input[name="toecap"]').trigger("click");

  //sole
  var softMatId = 3789;
  var whiteColorId = 49387;
  actPartsColorGroup["10"] = softMatId + "_" + whiteColorId;
  jQuery("[color-id=" + whiteColorId + "]")
    .parent()
    .addClass("actColor");
  //attributeid , colorid , materialid
  getColorImg(10, whiteColorId, softMatId);

  //mat 1
  var softMatId = 3771;
  var whiteColorId = 49212;
  actPartsColorGroup["17"] = softMatId + "_" + whiteColorId;
  jQuery("a[mat-id=" + softMatId + "]").addClass("actMaterial");
  //jQuery("a[mat-id=4]").trigger("click");
  jQuery("[color-id=" + whiteColorId + "]")
    .parent()
    .addClass("actColor");
  getColorImg(17, whiteColorId, softMatId);

  //mat 2
  var softMatId = 3777;
  var whiteColorId = 49285;
  actPartsColorGroup["18"] = softMatId + "_" + whiteColorId;
  jQuery("a[mat-id=" + softMatId + "]").addClass("actMaterial");
  jQuery("[color-id=" + whiteColorId + "]")
    .parent()
    .addClass("actColor");
  getColorImg(18, whiteColorId, softMatId);

  //mat 3
  var softMatId = 3783;
  var whiteColorId = 49358;
  actPartsColorGroup["29"] = softMatId + "_" + whiteColorId;
  jQuery("a[mat-id=" + softMatId + "]").addClass("actMaterial");
  jQuery("[color-id=" + whiteColorId + "]")
    .parent()
    .addClass("actColor");
  getColorImg(29, whiteColorId, softMatId);

  //buckle
  getColorImg(33, 49389, 3790);

  //toe cap
  actPartsColorGroup["39"] = "3783_49358";
  getColorImg(39, 49358, 3783);
}

function setDecorationStatus(name, active) {
  jQuery(".product-typer")
    .find('input[name="' + name + '"]')
    .prop("checked", !active);
  jQuery(".product-typer")
    .find('input[name="' + name + '"]')
    .trigger("click");
}

function setDefaultActiveConfAstoria() {
  var conf = new Array();
  conf["10"] = [3958, 51365]; // sole
  conf["17"] = [3944, 51191]; // mat1
  conf["18"] = [3950, 51264]; // mat2
  conf["29"] = [3956, 51337]; // mat3
  conf["38"] = [3963, 51412]; // toe cap

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });

  //lace 1
  getColorImg(13, 51136, 3939);
  //lace 2
  getColorImg(13, 51531, 3971);

  //eyelet
  getColorImg(19, 51440, 3966);

  // hide toe cap
  jQuery("#part_38").hide();
  // set toecap inactive
  setDecorationStatus("toecap", false);

  //hide perforations
  jQuery("#part_25").hide();

  var views = productViews["views"];
  for (var view in views) {
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
  }
}

function setDefaultConfBurton() {
  var conf = new Array();
  conf["10"] = [3603, 46900]; // sole
  conf["17"] = [3572, 46932]; // mat1
  conf["18"] = [3578, 47007]; // mat2
  conf["29"] = [3585, 47100]; // mat3
  conf["32"] = [3609, 47347]; // rear tab
  conf["26"] = [3607, 47322]; // fringe

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });

  //lace 1
  getColorImg(13, 46910, 3604);
  //lace 2
  getColorImg(13, 47404, 3611);

  //hide perforations
  jQuery("#part_25").hide();
  // hide toe cap
  jQuery("#part_38").hide();
  // set toecap inactive
  setDecorationStatus("toecap", false);
  // set rear tab active
  setDecorationStatus("reartab", true);
  // show fringe check
  jQuery(".product-typer")
    .find('input[name="fringe"]')
    .parents("li")
    .first()
    .show();

  // Hide fringe image
  var views = productViews["views"];
  for (var view in views) {
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=26][isicon=no]")
      .hide();
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
  }

  //hide view buttons
  // jQuery("#rotate-angle-next").hide();
}

function setDefaultConfAldgate() {
  var conf = new Array();
  conf["10"] = [3631, 47856]; // sole
  conf["17"] = [3612, 47428]; // mat1
  conf["18"] = [3618, 47505]; // mat2
  conf["29"] = [3625, 47592]; // mat3
  conf["37"] = [3634, 47815]; // heel

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });

  //lace 1
  getColorImg(13, 47874, 3650);
  //lace 2
  getColorImg(13, 47893, 3651);

  //hide perforations
  jQuery("#part_25").hide();

  var views = productViews["views"];
  for (var view in views) {
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
  }
}

function setDefaultConfConicAldgate() {
  var conf = new Array();
  conf["10"] = [3836, 49947]; // sole
  conf["17"] = [3817, 49725]; // mat1
  conf["18"] = [3823, 49799]; // mat2
  conf["29"] = [3830, 49885]; // mat3
  conf["37"] = [3839, 49957]; // heel

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });

  //lace 1
  getColorImg(13, 50167, 3855);
  //lace 2
  getColorImg(13, 50185, 3856);

  //hide perforations
  jQuery("#part_25").hide();

  var views = productViews["views"];
  for (var view in views) {
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
  }
}

function setDefaultConfKent() {
  var conf = new Array();
  conf["10"] = [3732, 48736]; // sole
  conf["17"] = [3735, 48788]; // mat1
  conf["18"] = [3741, 48862]; // mat2
  conf["29"] = [3759, 49030]; // mat3
  conf["37"] = [3756, 49686]; // heeel

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });
  

  //lace 1
  getColorImg(13, 48746, 3733);
  //lace 2
  getColorImg(13, 48764, 3734);

  //hide perforations
  jQuery("#part_25").hide();

  //hide mat3
  jQuery("#part_29").hide();

  var views = productViews["views"];
  for (var view in views) {
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
  }
}

function setDefaultConfConicKent() {
  var conf = new Array();
  conf["10"] = [3858, 50210]; // sole
  conf["17"] = [3861, 50259]; // mat1
  conf["18"] = [3867, 50332]; // mat2
  conf["29"] = [3884, 50528]; // mat3
  conf["37"] = [3881, 50477]; // heeel

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });
  

  //lace 1
  getColorImg(13, 50220, 3859);
  //lace 2
  getColorImg(13, 50238, 3860);

  //hide perforations
  jQuery("#part_25").hide();

  //hide mat3
  jQuery("#part_29").hide();

  var views = productViews["views"];
  for (var view in views) {
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
  }
}

function setDefaultConfFlorence() {
  var conf = new Array();
  conf["10"] = [3653, 47922]; // sole
  conf["17"] = [3656, 47974]; // mat1
  conf["18"] = [3662, 48048]; // mat2
  conf["29"] = [3685, 48277]; // mat3

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });

  //lace 1
  getColorImg(13, 47932, 3654);
  //lace 2
  getColorImg(13, 47952, 3655);

  var views = productViews["views"];
  for (var view in views) {
    // Hide material1 blank image
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
    // Hide material3 image
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=29][isicon=no]")
      .hide();
  }

  // Hide material 3 initially - must be active only when brogue2 is active
  jQuery("#part_29").hide();
}

function setDefaultConfJoplin() {
  var conf = new Array();
  conf["10"] = [3692, 48366]; // sole
  conf["17"] = [3693, 48379]; // mat1
  conf["18"] = [3699, 48452]; // mat2
  conf["29"] = [3714, 48616]; // mat3
  conf["33"] = [3712, 48679]; // buckle

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });

  var views = productViews["views"];
  for (var view in views) {
    // Hide material1 blank image
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
    // Show buckle
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=33][isicon=no]")
      .show();
  }
}

function setDefaultConfJoplinPumps() {
  var conf = new Array();
  conf["10"] = [3815, 49683]; // sole
  conf["17"] = [3797, 49508]; // mat1
  conf["18"] = [3803, 49581]; // mat2
  conf["29"] = [3809, 49654]; // mat3
  conf["33"] = [3816, 49685]; // buckle

  conf.forEach(function (v, partId) {
    actPartsColorGroup[partId] = v[0] + "_" + v[1];
    jQuery("[color-id=" + v[1] + "]")
      .parent()
      .addClass("actColor");
    //attributeid , colorid , materialid
    getColorImg(partId, v[1], v[0]);
  });

  var views = productViews["views"];
  for (var view in views) {
    // Hide material1 blank image
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
    // Show buckle
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=33][isicon=no]")
      .show();
  }
}

function setDefaultActiveColRegent() {
  //hide perforations
  jQuery("#part_25").hide();

  //sole
  actPartsColorGroup["10"] = "3455_45500"; //sole
  jQuery("[color-id=45500]").parent().addClass("actColor");
  //attributeid , colorid , materialid
  getColorImg(10, 45500, 3455);

  //mat 1
  actPartsColorGroup["17"] = "3420_45079";
  jQuery("a[mat-id=3420]").addClass("actMaterial");
  jQuery("[color-id=45079]").parent().addClass("actColor");
  getColorImg(17, 45079, 3420);

  //mat 2
  actPartsColorGroup["18"] = "3426_45155"; //mat2
  jQuery("a[mat-id=3426]").addClass("actMaterial");
  jQuery("[color-id=45155]").parent().addClass("actColor");
  getColorImg(18, 45155, 3426);

  //mat 3
  actPartsColorGroup["29"] = "3433_45315"; //mat3
  jQuery("a[mat-id=3433]").addClass("actMaterial");
  jQuery("[color-id=45315]").parent().addClass("actColor");
  getColorImg(29, 45315, 3433);

  //rear tab
  actPartsColorGroup["32"] = "3458_45532";
  jQuery("a[mat-id=3458]").addClass("actMaterial");
  jQuery("[color-id=45532]").parent().addClass("actColor");
  getColorImg(32, 45532, 3458);

  jQuery('input[name="reartab"]').prop("checked", true);
  var views = productViews["views"];
  for (var view in views) {
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=20][isicon=no]")
      .hide();
  }

  //lace 1
  getColorImg(13, 45473, 3453);
  //lace 2
  getColorImg(13, 45490, 3454);
  //jQuery("#part_13 a").trigger('click');

  //hide view buttons
  //jQuery("#rotate-angle-next").hide();

  //jQuery("[parentid=3420][parentattr=17][color-id=45079]").parent().trigger("click");
}

/* code on hover of shoe attributes */
var attrHoverIn = function (obj, e) {
  if (jQuery(e.target).attr("class")) {
    var tarClass = jQuery(e.target).attr("class").split(" ")[1];
    var isEyelet = jQuery("[name='eyelet']").prop("checked");
    var isZipper = jQuery("[name='zipper']").prop("checked");
    var isRearTab = jQuery("[name='reartab']").prop("checked");
    var toecapStatus = jQuery("[name='toecap']").prop("checked");
    var isFringe = jQuery("[name='fringe']").prop("checked");
    var isStrap = strapStatus;
    if (
      mainProductId == "6567881729" ||
      mainProductId == "1357580927062" ||
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id ||
      mainProductId == "6566222337" ||
      mainProductId == "1358467629142" ||
      mainProductId == decorations.joplin.id ||
      mainProductId == decorations.joplinPumps.id ||
      mainProductId == decorations.kent.id ||
      mainProductId == decorations.conicKent.id
    ) {
      //madeline//duke/mary//baron//jane//joplin//kent
      isStrap = true;
    }

    if (tarClass != "attr_list_name") return false;

    var rel = jQuery(obj).attr("id").split("_")[1];
    console.log("rel ==" + rel);

    jQuery("#view_" + currView)
      .find("img[rel=" + rel + "][isicon='no']")
      .css("opacity", "0.5")
      .show();

    jQuery("#view_" + currView)
      .find("img[rel=" + rel + "][isicon='yes']")
      .show();

    if (!isEyelet) {
      jQuery("#view_" + currView)
        .find("img[rel=19][isicon='no']")
        .hide();
    }

    if (!isFringe) {
      jQuery("#view_" + currView)
        .find("img[rel=26][isicon='no']")
        .hide();
    }

    if (!isZipper) {
      jQuery("#view_" + currView)
        .find("img[rel=27][isicon='no']")
        .hide();
    }

    if (!isRearTab) {
      jQuery("#view_" + currView)
        .find("img[rel=32][isicon='no']")
        .hide();
    }

    if (!isStrap) {
      jQuery("#view_" + currView)
        .find("img[rel=35][isicon='no']")
        .hide();
      jQuery("#view_" + currView)
        .find("img[rel=33][isicon='no']")
        .hide();
    }
    if (mainProductId == "4219595649" || mainProductId == "4219340353") {
      if (!isRearTab) {
        jQuery("#view_" + currView)
          .find("img[rel=32][isicon='yes']")
          .hide();
      }
    }

    if (rel == "29" && mainProductId == decorations.florence.id) {
      jQuery("#view_" + currView)
        .find("img[rel=" + rel + "][isicon='no']")
        .hide();
    }

    if (
      mainProductId == "1357580927062" ||
      mainProductId == "6566222337" ||
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id
    ) {
      //baron//duke//jane//kent
      if (!toecapStatus && !brogue1Status) {
        //console.log('inside hove in ! toecap status baron');
        jQuery("#view_" + currView)
          .find("img[rel=29][isicon='no']")
          .hide();
        jQuery("#view_" + currView)
          .find("img[rel=29][isicon='yes']")
          .hide();
      } else {
        jQuery("#view_" + currView)
          .find("img[rel=29][isicon='no']")
          .show();
        jQuery("#view_" + currView)
          .find("img[rel=29][isicon='yes']")
          .show();
      }
    }

    /*
    if(rel == "20")
    { 
    
       console.log("decorat hover = ");
       jQuery("#view_" + currView).find("img[rel=0][isicon='no'][decoration='perforation']").css("opacity", "0.5").show();
       jQuery("#view_" + currView).find("img[rel=0][isicon='no'][decoration='perforation2']").css("opacity", "0.5").show();
       jQuery("#view_" + currView).find("img[rel=0][isicon='no'][decoration='rivet']").css("opacity", "0.5").show();
       jQuery("#view_" + currView).find("img[rel=0][isicon='no'][decoration='fringe']").css("opacity", "0.5").show();
       jQuery("#view_" + currView).find("img[rel=0][isicon='no'][decoration='piping']").css("opacity", "0.5").show();
      jQuery("#view_" + currView).find("img[rel=0][isicon='no'][decoration='brouge']").css("opacity", "0.5").show();
      
   
       
    
    }*/
  }

  jQuery(obj).css("background-color", "lightgray");
};

var attrHoverOut = function (obj, e) {
  jQuery(".views img").css("opacity", "1");
  var rel = jQuery(obj).attr("id").split("_")[1];
  jQuery("#view_" + currView)
    .find("img[rel=" + rel + "][isicon='yes']")
    .hide();
  jQuery(obj).css("background-color", "#FFFFFF");
};

function viewHoverIn() {
  if (jQuery("[name='rivet']").prop("checked")) {
    jQuery("#view_" + currView)
      .find("img[isicon='yes']")
      .show();
  } else {
    jQuery("#view_" + currView)
      .find("img[isicon='yes'][rel!=21]")
      .show();
  }

  //check fringe icon

  if (!jQuery("[name='fringe']").prop("checked")) {
    jQuery("#view_" + currView)
      .find("img[isicon='yes'][rel=26]")
      .hide();
  }

  //check piping icon

  if (!jQuery("[name='piping']").prop("checked")) {
    jQuery("#view_" + currView)
      .find("img[isicon='yes'][rel=23]")
      .hide();
  }

  if (
    mainProductId == "1362437832790" ||
    mainProductId == "1464803201" ||
    mainProductId == "1357577519190"
  ) {
    //morgan / limehouse
    if (!jQuery("[name='brouge2']").prop("checked")) {
      jQuery("#view_" + currView)
        .find("img[isicon='yes'][rel=29]")
        .hide();
    } else {
      jQuery("#view_" + currView)
        .find("img[isicon='yes'][rel=29]")
        .show();
    }
  }

  if (mainProductId == "4219340353") {
    //classon
    if (!strapStatus) {
      jQuery("#view_" + currView)
        .find("img[isicon='yes'][rel=35]")
        .hide();
      jQuery("#view_" + currView)
        .find("img[isicon='yes'][rel=33]")
        .hide();
    } else {
      jQuery("#view_" + currView)
        .find("img[isicon='yes'][rel=35]")
        .show();
      jQuery("#view_" + currView)
        .find("img[isicon='yes'][rel=33]")
        .hide();
    }
  }

  var isRearTab = jQuery("[name='reartab']").prop("checked");

  if (mainProductId == "4219595649" || mainProductId == "4219340353") {
    if (!isRearTab) {
      jQuery("#view_" + currView)
        .find("img[isicon='yes'][rel=32]")
        .hide();
    }
  }
  var isToecap = jQuery("[name='toecap']").prop("checked");
  if (
    mainProductId == "1357580927062" ||
    mainProductId == "6566222337" ||
    mainProductId == decorations.jane.id ||
    mainProductId == decorations.janePumps.id ||
    mainProductId == decorations.kent.id ||
    mainProductId == decorations.conicKent.id
  ) {
    //baron//duke//jane//kent
    if (!isToecap && !brogue1Status) {
      jQuery("#view_1").find("img[isicon='yes'][rel=29]").hide();
      jQuery("#view_2").find("img[isicon='yes'][rel=29]").hide();
    }
  }

  jQuery(".views").find("img[rel=28][isicon=yes]").hide();
}

function viewHoverOut() {
  jQuery("#view_" + currView)
    .find("img[isicon='yes']")
    .hide();

  jQuery(".views").find("img[rel=28][isicon=yes]").hide();
}

var iconHoverIn = function (obj) {
  //alert('yes')
  var hoverImg = jQuery(obj).attr("hover_img");
  console.log("hover img=== " + hoverImg);

  jQuery(obj).attr("src", hoverImg);
};

var iconHoverOut = function (obj) {
  var defaultImg = jQuery(obj).attr("default_img");

  jQuery(obj).attr("src", defaultImg);
};

var colorHoverIn = function (obj) {
  jQuery(".hover_popup").show();
  jQuery(".hover_popup_material").hide();

  var Img = jQuery(obj).find("img").attr("src");
  var name = jQuery(obj).find("a").attr("titlel").toUpperCase();

  var pos = jQuery(obj).position();

  jQuery(".hover_popup").find("img").attr("src", Img);
  jQuery(".hover_popup p.colorName").html(name);
  jQuery(".hover_popup").css({
    left: pos.left + 225 + "px",
    top: pos.top + 50 + "px",
  });
};

var colorHoverOut = function (obj) {
  jQuery(".hover_popup").hide();
};

var materialHoverIn = function (obj) {
  jQuery(".hover_popup").hide();
  jQuery(".hover_popup_material").show();

  var name = jQuery(obj).find("a").attr("titlel").toUpperCase();

  var descrip = getMaterialDescription(name);
 
  var pos = jQuery(obj).position();

  jQuery(".hover_popup_material a").html(name);
  jQuery(".hover_popup_material > div").html(descrip);

  if (name == "LACES 1" || name == "LACES 2") {
    jQuery(".hover_popup_material").css({
      left: "15%",
      top: pos.top + 68 + "px",
      right: "15%",
    });
  } else {
    //jQuery(".hover_popup_material").css({"left": (pos.left+100) + "px","top":(pos.top+58) + "px" });
    jQuery(".hover_popup_material").css({
      left: "7%",
      top: pos.top + 38 + "px",
      right: "7%",
    });
  }
};

var materialHoverOut = function (obj) {
  jQuery(".hover_popup_material").hide();
};

/* --- end of code --- */

function toolToggleHead(actObj) {
  return false;
  jQuery(actObj).toggleClass("tool_head_close");
  jQuery(actObj).next().toggle("slow");
}

function shoesPartClick(obj) {
  /// trigger to lace 1

  if (
    jQuery("#part_13 [titlelm='laces 1']").children().length > 0 ||
    jQuery("#part_13 [titlelm='laces 1'] a").hasClass("actMaterial")
  ) {
    console.log("inside set default ");

    //jQuery("#attribute_1").find("ul").slideUp();
    jQuery("#attribute_1").find(".active").removeClass("active");
    jQuery("#attribute_1").find(".li_active").removeClass("li_active");

    jQuery("#part_13 [titlelm='laces 1'] a").trigger("click");

    setLace1Active();
  }

  console.log("outside set default ");

  if (jQuery(obj).attr("view") > 0) {
    currView = jQuery(obj).attr("view");
    hideAllViews();
    visibleView();
  }

  if (jQuery(obj).parent().hasClass("active")) {
    //jQuery(obj).parent().find("ul").slideUp();
    //jQuery(obj).parent().removeClass('active');
    //jQuery(obj).parent().parent().removeClass('li_active');
    //jQuery(obj).parent().parent().css({"background-color":"none"})
  } else {
    jQuery("#attribute_1").find("ul").slideUp();
    jQuery("#attribute_1").find(".active").removeClass("active");
    jQuery("#attribute_1").find(".li_active").removeClass("li_active");
    // jQuery("#attribute_1").find(".active").parent().css({"background-color":"none"})
    jQuery(obj).parent().find("ul").slideDown();
    jQuery(obj).parent().addClass("active");
    jQuery(obj).parent().parent().addClass("li_active");
    // jQuery(obj).parent().parent().css({"background-color":"#80F647"})
  }

  //check active material

  var hasActClass = jQuery(obj)
    .parent()
    .find(".actMaterial")
    .hasClass("actMaterial");

  if (!hasActClass) {
    jQuery(obj).parent().find(".selct-material li:first a").trigger("click");
  }

  var sPart;
  if (jQuery(".sub-menu").find(".active").parent().attr("id")) {
    sPart = jQuery(".sub-menu")
      .find(".active")
      .parent()
      .attr("id")
      .split("_")[1];

    changeViewAttrbuteWise(sPart);

    if (sPart == "13") {
      jQuery("#part_13 [titlelm='laces 1'] a").trigger("click");
    }
  }

  if (mainProductId == "9987925889" || mainProductId == "1356909903958") {
    //lamont

    var part;

    if (jQuery(".sub-menu").find(".active").parent().attr("id")) {
      part = jQuery(".sub-menu")
        .find(".active")
        .parent()
        .attr("id")
        .split("_")[1];

      if (part == "31") {
        //elasetic
        jQuery("#part_31")
          .find(".selct-material")
          .find('li[titlelm="soft leather"]')
          .hide();
        jQuery("#part_31")
          .find(".selct-material")
          .find('li[titlelm="elastic"]')
          .hide();
        jQuery("#part_31").find(".selct-material").css({ display: "none" });
      }
    }
  }

  if (mainProductId == "4219595649") {
    //Chelsea
    var part;

    if (jQuery(".sub-menu").find(".active").parent().attr("id")) {
      part = jQuery(".sub-menu")
        .find(".active")
        .parent()
        .attr("id")
        .split("_")[1];

      if (part == "31") {
        //elasetic
        jQuery("#part_31")
          .find(".selct-material")
          .find('li[titlelm="soft leather"]')
          .hide();
        jQuery("#part_31")
          .find(".selct-material")
          .find('li[titlelm="elastic"]')
          .hide();
        jQuery("#part_31").find(".selct-material").css({ display: "none" });
      }
    }
  }

  if (jQuery(".gallery-left-option > .tool_head").hasClass("tool_head_close")) {
    jQuery(".gallery-left-option > .tool_head").trigger("click");
  }

  //jQuery('.scaprt-codes').scrollTop($('.scaprt-codes li:nth-child(14)').position().top);
  jQuery(".scaprt-codes")
    .scrollTop(0)
    .scrollTop(jQuery(".scaprt-codes li:nth-child(0)"));
}

function showLamontelastic(obj) {
  if (mainProductId == "9987925889" || mainProductId == "1356909903958") {
    //lamont
    var part;

    if (jQuery(".sub-menu").find(".active").parent().attr("id")) {
      part = jQuery(".sub-menu")
        .find(".active")
        .parent()
        .attr("id")
        .split("_")[1];

      if (part == "31") {
        var chk = jQuery("input[name=elasticcover]").prop("checked");
        if (chk) {
          // console.log("inside chk of lamont")
          jQuery("#part_31")
            .find(".selct-material")
            .find('li[titlelm="soft leather"] a')
            .trigger("click");
        } else {
          // console.log("inside else chk of lamont")
          jQuery("#part_31")
            .find(".selct-material")
            .find('li[titlelm="elastic"] a')
            .trigger("click");
        }

        jQuery("#part_31")
          .find(".selct-material")
          .find('li[titlelm="soft leather"]')
          .hide();
        jQuery("#part_31")
          .find(".selct-material")
          .find('li[titlelm="elastic"]')
          .hide();
        //jQuery('#part_31').find('.selct-material').find('li[titlelm="elastic"] a').trigger('click')
      }
    }
  }
}

function showChelseaelastic(obj) {
  if (mainProductId == "4219595649") {
    //chelsea
    var part;

    if (jQuery(".sub-menu").find(".active").parent().attr("id")) {
      part = jQuery(".sub-menu")
        .find(".active")
        .parent()
        .attr("id")
        .split("_")[1];

      if (part == "31") {
        var chk = jQuery("input[name=elasticcover]").prop("checked");
        if (chk) {
          //console.log("inside chk of chelsea")
          jQuery("#part_31")
            .find(".selct-material")
            .find('li[titlelm="elastic"] a')
            .trigger("click");
        } else {
          //console.log("inside else chk of chelsea")
          jQuery("#part_31")
            .find(".selct-material")
            .find('li[titlelm="soft leather"] a')
            .trigger("click");
        }

        jQuery("#part_31")
          .find(".selct-material")
          .find('li[titlelm="soft leather"]')
          .hide();
        jQuery("#part_31")
          .find(".selct-material")
          .find('li[titlelm="elastic"]')
          .hide();
        //jQuery('#part_31').find('.selct-material').find('li[titlelm="elastic"] a').trigger('click')
      }
    }
  }
}

function showColor(actObj) {
  if (!loaderFlag && !keepLoaderFlag) {
    jQuery(".loading").hide();
    jQuery(".loading1").hide();

    jQuery(".shoe-data-preloader").show();
  }

  jQuery(actObj).parent().find(".actColor").removeClass("actColor");
  jQuery(actObj).addClass("actColor");
  //get act colo and mate

  var colorId = jQuery(actObj).find("a").attr("color-id");
  var colorIdName = jQuery(actObj).find("a").attr("titlel");

  var colorImg = jQuery(actObj).find("img").attr("src");

  var matId = jQuery(actObj)
    .parents(".inter-design-way")
    .find(".actMaterial")
    .attr("mat-id");

  if (!matId) {
    matId = jQuery("#part_17 .inter-design-way")
      .find(".actMaterial")
      .attr("mat-id");
  }

  var brouge = jQuery("input[name=brouge]").prop("checked");
  var brouge2 = jQuery("input[name=brouge2]").prop("checked");
  var eyelet = jQuery("input[name=eyelet]").prop("checked");
  var toeCap = jQuery('input[name="toecap"]').prop("checked");
  var strap = strapStatus;

  if (!eyelet) {
    //check eyelet add/remove button
    jQuery(".views [rel=19]").hide();
  }

  if (
    mainProductId == "6567881729" ||
    mainProductId == "1357580927062" ||
    mainProductId == "6566222337" ||
    mainProductId == "1358467629142" ||
    mainProductId == decorations.jane.id ||
    mainProductId == decorations.janePumps.id ||
    mainProductId == decorations.joplin.id ||
    mainProductId == decorations.joplinPumps.id
  ) {
    //madeline//duke/mary//jane//joplin
    strap = true;
  }
  if (!strap) {
    jQuery(".views [rel=35]").hide();
    jQuery(".views [rel=33]").hide();
  }

  var sPart;

  if (jQuery(".sub-menu").find(".active").parent().attr("id")) {
    //if not any attribute take mat1 active as default

    sPart = jQuery(".sub-menu")
      .find(".active")
      .parent()
      .attr("id")
      .split("_")[1];
  } else {
    sPart = "17";
  }

  // show material icon
  showMaterialIcon(jQuery("li#part_" + sPart + " .actMaterial"));

  actPartsColorGroup[sPart] = matId + "_" + colorId;

  //update lace color
  //console.log('title =  ' + jQuery(".selct-material a[mat-id="+matId+"]").attr("titlel") + ' spart =' + sPart)
  var actLaceId = jQuery(".selct-material a[mat-id=" + matId + "]")
    .attr("titlel")
    .split(" ")[1];

  if (actLaceId == "1") {
    if (sPart == "13") {
      //  console.log('inside actlace  = = = = 1 = = '+sPart)
      //update image part act color image
      jQuery(".sub-menu .active")
        .find(".thumb_pattern_img")
        .attr("src", colorImg);
      jQuery(".sub-menu .active")
        .find(".thumb_pattern_img")
        .attr("colorid", colorId);
      jQuery(".sub-menu .active")
        .find(".thumb_pattern_img")
        .attr("colorname", colorIdName);
    }
  } else if (actLaceId == "2") {
    //console.log('inside actlace 2')
    jQuery(".sub-menu .active").find(".thumb_color_img").attr("src", colorImg);
    jQuery(".sub-menu .active")
      .find(".thumb_color_img")
      .attr("colorid", colorId);
    jQuery(".sub-menu .active")
      .find(".thumb_color_img")
      .attr("colorname", colorIdName);
  } else {
    if (defaultTrigger) {
      defaultTrigger = false;
    } else {
      // console.log('inside act lace else')
      //update image part act color image
      jQuery(".sub-menu .active")
        .find(".thumb_color_img")
        .attr("src", colorImg);
      jQuery(".sub-menu .active")
        .find(".thumb_color_img")
        .attr("colorid", colorId);
    }
  }

  //end
  jQuery("#attribute_1 > li").each(function () {
    if (jQuery(this).attr("id")) {
      var sPartr = jQuery(this).attr("id").split("_")[1];
      var matId = jQuery(this).find(".thumb_pattern_img").attr("patternid");

      if (sPartr) {
        var hasActClass = jQuery(this).find(".actColor").hasClass("actColor");
        var colorId;

        if (!hasActClass) {
          colorId = jQuery(this)
            .find(".hideColor a[parentid=" + matId + "]:first")
            .attr("color-id");
          jQuery(this)
            .find(".hideColor a[parentid=" + matId + "]:first")
            .parent()
            .addClass("actColor");
        } else {
          colorId = jQuery(this).find(".actColor a").attr("color-id");
        }

        //var colorId = jQuery(this).find('.thumb_color_img').attr('colorid');

        if (sPartr != "21") {
          actPartsColorGroup[sPartr] = matId + "_" + colorId;
        }
      }
    }
  });

  //update brouge id
  actPartsColorGroup["20"] = getBrogueactColorId();
  actPartsColorGroup["28"] = getBrogue2actColorId();
  actPartsColorGroup["36"] = getMforStrapId();
  if (mainProductId == decorations.burton.id || mainProductId == decorations.astoria.id) {
    actPartsColorGroup["38"] = getCapToeActColorId();
  }

  //update color image from folder
  var imgPath;
  var id;

  matId = actPartsColorGroup[sPart].split("_")[0];
  colorId = actPartsColorGroup[sPart].split("_")[1];

  if (brouge) {
    //brogue
    if (
      mainProductId == "2197325185" ||
      mainProductId == decorations.regent.id ||
      mainProductId == decorations.burton.id ||
      mainProductId == "1464803201" ||
      mainProductId == "1357577519190"
    ) {
      if (sPart == "18") {
        sPart = "20";
      }
    } else if (
      mainProductId == "1267259905" ||
      mainProductId == "7743501889" ||
      mainProductId == "1357580927062" ||
      mainProductId == "6566222337" ||
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id ||
      mainProductId == decorations.kent.id ||
      mainProductId == decorations.conicKent.id ||
      mainProductId == decorations.astoria.id
    ) {
      if (sPart == "29") {
        sPart = "20";
      }
    } else if (
      mainProductId == "9987925889" ||
      mainProductId == "4219340353" ||
      mainProductId == "1356909903958" ||
      mainProductId == "4219595649"
    ) {
      //lamont/classon
      // console.log("spart classon== " + sPart )
      if (sPart == "20") {
        sPart = "17";
      }
    } else {
      if (sPart == "17") {
        sPart = "20";
      }
    }
  } else {
    if (
      mainProductId == "2197325185" ||
      mainProductId == decorations.regent.id ||
      mainProductId == "1464803201" ||
      mainProductId == "1357577519190"
    ) {
      if (sPart == "20") {
        sPart = "18";
      }
    } else if (
      mainProductId == "1267259905" ||
      mainProductId == "7743501889" ||
      mainProductId == "1357580927062" ||
      mainProductId == "6566222337" ||
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id ||
      mainProductId == decorations.kent.id ||
      mainProductId == decorations.conicKent.id ||
      mainProductId == decorations.astoria.id
    ) {
      if (sPart == "20") {
        sPart = "29";
      }
    } else if (mainProductId == decorations.burton.id ||  mainProductId == decorations.astoria.id) {
      if (toeCap && sPart == "20") {
        sPart = "38";
      } else if (sPart == "20") {
        sPart = "18";
      }
    } else {
      if (sPart == "20") {
        sPart = "17";
      }
    }
  }
  
  if (sPart == "18" && mainProductId == decorations.astoria.id && !brogue1Status) {
    jQuery("img[rel=20][isicon='no']").hide();
  }

  matId = actPartsColorGroup[sPart].split("_")[0];
  colorId = actPartsColorGroup[sPart].split("_")[1];

  jQuery(".views").each(function () {
    id = jQuery(this).attr("id").split("_")[1];

    if (sPart == "20") {
      if (
        mainProductId == "2197325185" ||
        mainProductId == decorations.regent.id ||
        mainProductId == decorations.burton.id
      ) {
        imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sPart +
          "_Material_" +
          matId +
          "_Color_" +
          colorId +
          "_View_" +
          id +
          ".png";
        jQuery(this).find("img[rel=18][isicon='no']").attr("src", imgPath);
      } else if (
        mainProductId == "1267259905" ||
        mainProductId == "7743501889"
      ) {
        //hudson , morgan
        imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sPart +
          "_Material_" +
          matId +
          "_Color_" +
          colorId +
          "_View_" +
          id +
          ".png";
        jQuery(this).find("img[rel=29][isicon='no']").attr("src", imgPath);
      } else if (
        mainProductId == "1362437832790" ||
        mainProductId == "460990265" ||
        mainProductId == "1358365491286" ||
        mainProductId == decorations.conicHolborn.id ||
        mainProductId == "1358467629142"
      ) {
        //morgan//lenox//holborn*//marry

        imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sPart +
          "_Material_" +
          matId +
          "_Color_" +
          colorId +
          "_View_" +
          id +
          ".png";
        jQuery(this).find("img[rel=17][isicon='no']").attr("src", imgPath);
      } else if (mainProductId == "6567881729") {
        //Madeline

        imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sPart +
          "_Material_" +
          matId +
          "_Color_" +
          colorId +
          "_View_" +
          id +
          ".png";
        jQuery(this).find("img[rel=17][isicon='no']").attr("src", imgPath);
      } else if (
        mainProductId == "1464803201" ||
        mainProductId == "1357577519190"
      ) {
        //limehouse
        imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sPart +
          "_Material_" +
          matId +
          "_Color_" +
          colorId +
          "_View_" +
          id +
          ".png";
        jQuery(this).find("img[rel=18][isicon='no']").attr("src", imgPath);
      } else if (mainProductId == "6566222337") {
        //baron//duke
        imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sPart +
          "_Material_" +
          matId +
          "_Color_" +
          colorId +
          "_View_" +
          id +
          ".png";
        // console.log("image path for 29 " + imgPath);
        jQuery(this).find("img[rel=29][isicon='no']").attr("src", imgPath);
      } else if (mainProductId == "1357580927062") {
        //baron
        var brogueStatus = jQuery("[name='brouge']").prop("checked");
        if (brogueStatus) {
          imgPath =
            basePath +
            "media/front/product-images/product" +
            mainProductId +
            "/Product_" +
            mainProductId +
            "_Part_" +
            sPart +
            "_Material_" +
            matId +
            "_Color_" +
            colorId +
            "_View_" +
            id +
            ".png";
          // console.log("image path for 29 " + imgPath);
          jQuery(this).find("img[rel=29][isicon='no']").attr("src", imgPath);
        } else {
          imgPath =
            basePath +
            "media/front/product-images/product" +
            mainProductId +
            "/Product_" +
            mainProductId +
            "_Part_" +
            29 +
            "_Material_" +
            matId +
            "_Color_" +
            colorId +
            "_View_" +
            id +
            ".png";
          //console.log("image path for 29 " + imgPath);
          jQuery(this).find("img[rel=29][isicon='no']").attr("src", imgPath);
        }
      } else if (mainProductId == decorations.jane.id || mainProductId == decorations.janePumps.id ) {
        //jane
        var brogueStatus = jQuery("[name='brouge']").prop("checked");
        if (brogueStatus) {
          imgPath =
            basePath +
            "media/front/product-images/product" +
            mainProductId +
            "/Product_" +
            mainProductId +
            "_Part_" +
            sPart +
            "_Material_" +
            matId +
            "_Color_" +
            colorId +
            "_View_" +
            id +
            ".png";
          // console.log("image path for 29 " + imgPath);
          jQuery(this).find("img[rel=29][isicon='no']").attr("src", imgPath);
        } else {
          imgPath =
            basePath +
            "media/front/product-images/product" +
            mainProductId +
            "/Product_" +
            mainProductId +
            "_Part_" +
            29 +
            "_Material_" +
            matId +
            "_Color_" +
            colorId +
            "_View_" +
            id +
            ".png";
          //console.log("image path for 29 " + imgPath);
          jQuery(this).find("img[rel=29][isicon='no']").attr("src", imgPath);
        }
      }else if  (mainProductId == decorations.astoria.id){
        imgPath =
        basePath +
        "media/front/product-images/product" +
        mainProductId +
        "/Product_" +
        mainProductId +
        "_Part_" +
        sPart +
        "_Material_" +
        matId +
        "_Color_" +
        colorId +
        "_View_" +
        id +
        ".png";
        
        if(brogue1Status) {
          const mat1Path = basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          29 +
          "_Material_" +
          actPartsColorGroup[29].split("_")[0] +
          "_Color_" +
          actPartsColorGroup[29].split("_")[1] +
          "_View_" +
          id +
          ".png";
          jQuery(this).find("img[rel=29][isicon='no']").attr("src", mat1Path);
        }
        
        jQuery(this).find("img[rel=20][isicon='no']").attr("src", imgPath);
        jQuery(this).find("img[rel=20][isicon='no']").show();
      }else if (mainProductId == decorations.kent.id || mainProductId == decorations.conicKent.id) {
        //kent
          imgPath =
            basePath +
            "media/front/product-images/product" +
            mainProductId +
            "/Product_" +
            mainProductId +
            "_Part_" +
            sPart +
            "_Material_" +
            matId +
            "_Color_" +
            colorId +
            "_View_" +
            id +
            ".png";
          // console.log("image path for 29 " + imgPath);
          jQuery(this).find("img[rel=20][isicon='no']").attr("src", imgPath);
          jQuery(this).find("img[rel=20][isicon='no']").show();
      }else {
        imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sPart +
          "_Material_" +
          matId +
          "_Color_" +
          colorId +
          "_View_" +
          id +
          ".png";
        jQuery(this).find("img[rel=17][isicon='no']").attr("src", imgPath);
      }
    } else {
      imgPath =
        basePath +
        "media/front/product-images/product" +
        mainProductId +
        "/Product_" +
        mainProductId +
        "_Part_" +
        sPart +
        "_Material_" +
        matId +
        "_Color_" +
        colorId +
        "_View_" +
        id +
        ".png";
      jQuery(this)
        .find("img[rel=" + sPart + "][isicon='no']")
        .attr("src", imgPath);

      // console.log(sPart+"  5556 sPart imgPath = "+imgPath)
      if (!jQuery("[name='brouge']").prop("checked") && (mainProductId == decorations.kent.id || mainProductId == decorations.conicKent.id)) {
        //hide brogue for kent
        jQuery(this).find("img[rel=20][isicon='no']").hide();
      }
      
      if (mainProductId == "4219340353") {
        var views = productViews["views"];
        imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_36_Material_" +
          actPartsColorGroup["36"].split("_")[0] +
          "_Color_" +
          actPartsColorGroup["36"].split("_")[1] +
          "_View_" +
          id +
          ".png";
        jQuery(this).find("img[rel=36][isicon='no']").attr("src", imgPath);

        if (strapStatus) {
          for (var view in views) {
            jQuery("#view_" + views[view]["id"])
              .find("img[rel=36][isicon=no]")
              .show();
          }
        } else {
          for (var view in views) {
            jQuery("#view_" + views[view]["id"])
              .find("img[rel=36][isicon=no]")
              .hide();
          }
        }
      }
    }
  });

  //end

  setTimeout(function () {
    if (!loaderFlag && !keepLoaderFlag) {
      jQuery(".shoe-data-preloader").hide();
    }

    if (mainProductId == decorations.astoria.id) {
      if (!brogue1Status && toeCap) {
        var sParts = "38";
        var MatColId = getCapToeActColorId();
        var imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sParts +
          "_Material_" +
          MatColId.split("_")[0] +
          "_Color_" +
          MatColId.split("_")[1] +
          "_View_1.png";
        var imgPath2 =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sParts +
          "_Material_" +
          MatColId.split("_")[0] +
          "_Color_" +
          MatColId.split("_")[1] +
          "_View_2.png";

        jQuery("#view_1")
          .find("img[rel=" + sParts + "][isicon='no']")
          .attr("src", imgPath);
        jQuery("#view_2")
          .find("img[rel=" + sParts + "][isicon='no']")
          .attr("src", imgPath2);
      }
    }

    if (brouge2) {
      //brogue
      if (mainProductId == "4219340353") {
        //classon
        var sParts = "20";
        var MatColId = getBrogue2actColorId();
        // console.log('inside b2 == ' + MatColId)
        var imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sParts +
          "_Material_" +
          MatColId.split("_")[0] +
          "_Color_" +
          MatColId.split("_")[1] +
          "_View_1.png";
        var imgPath2 =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sParts +
          "_Material_" +
          MatColId.split("_")[0] +
          "_Color_" +
          MatColId.split("_")[1] +
          "_View_2.png";

        // console.log("imgPath 11= = "+imgPath)

        jQuery("#view_1")
          .find("img[rel=" + 28 + "][isicon='no']")
          .attr("src", imgPath);
        jQuery("#view_2")
          .find("img[rel=" + 28 + "][isicon='no']")
          .attr("src", imgPath2);
      } else {
        var sParts = "28";
        var MatColId = getBrogue2actColorId();
        //console.log('inside b2 == ' + MatColId)
        var imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sParts +
          "_Material_" +
          MatColId.split("_")[0] +
          "_Color_" +
          MatColId.split("_")[1] +
          "_View_1.png";
        var imgPath2 =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sParts +
          "_Material_" +
          MatColId.split("_")[0] +
          "_Color_" +
          MatColId.split("_")[1] +
          "_View_2.png";

        // console.log("imgPath = = "+imgPath)

        jQuery("#view_1")
          .find("img[rel=" + sParts + "][isicon='no']")
          .attr("src", imgPath);
        jQuery("#view_2")
          .find("img[rel=" + sParts + "][isicon='no']")
          .attr("src", imgPath2);
      }
    } else if (toeCap) {
      if (mainProductId == decorations.burton.id) {
        var sParts = "38";
        var MatColId = getCapToeActColorId();
        var imgPath =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sParts +
          "_Material_" +
          MatColId.split("_")[0] +
          "_Color_" +
          MatColId.split("_")[1] +
          "_View_1.png";
        var imgPath2 =
          basePath +
          "media/front/product-images/product" +
          mainProductId +
          "/Product_" +
          mainProductId +
          "_Part_" +
          sParts +
          "_Material_" +
          MatColId.split("_")[0] +
          "_Color_" +
          MatColId.split("_")[1] +
          "_View_2.png";

        jQuery("#view_1")
          .find("img[rel=" + sParts + "][isicon='no']")
          .attr("src", imgPath);
        jQuery("#view_2")
          .find("img[rel=" + sParts + "][isicon='no']")
          .attr("src", imgPath2);
      }
    } else {
      jQuery(".views [rel=28]").hide();
    }
  }, 100);
}

function showMaterialColor(obj) {
  jQuery(obj)
    .parents(".selct-material")
    .find(".actMaterial")
    .removeClass("actMaterial");
  jQuery(obj).addClass("actMaterial");

  // var matImg = jQuery(obj).parents(".selct-material").find(".actMaterial").find("img").attr("src");
  var matId = jQuery(obj)
    .parents(".selct-material")
    .find(".actMaterial")
    .attr("mat-id");
  var actAttrId;

  if (jQuery("#attribute_1 > li > .active ").parent().attr("id")) {
    actAttrId = jQuery("#attribute_1 > li > .active ")
      .parent()
      .attr("id")
      .split("_")[1];
  } else {
    return false;
  }

  //update mat
  if (actAttrId != "13") {
    // console.log("material id== " + matId)
    //console.log('mat img  == ' + matImg)
    // jQuery(".sub-menu .active").find(".thumb_pattern_img").attr("src", matImg);
  } else {
    var tit = jQuery(obj).attr("titlel").split(" ")[1];
    var actCol;

    if (tit == "1") {
      // console.log("tit ======= " + tit)

      actCol = jQuery(".sub-menu .active")
        .find(".thumb_pattern_img")
        .attr("colorid");
      //  console.log("actCol == " + actCol)
      setTimeout(function () {
        jQuery(".hideColor .color-list[color-id=" + actCol + "]")
          .parent()
          .trigger("click");
      }, 100);
    } else if (tit == "2") {
      actCol = jQuery(".sub-menu .active")
        .find(".thumb_color_img")
        .attr("colorid");

      setTimeout(function () {
        jQuery(".hideColor .color-list[color-id=" + actCol + "]")
          .parent()
          .trigger("click");
      }, 100);
    }
  }

  // console.log("mat id 1 = " + matId)
  //jQuery(".sub-menu .active").find(".thumb_pattern_img").attr("patternid", matId);
  // console.log(jQuery(".sub-menu .active").find(".thumb_pattern_img").attr("patternid", matId))

  //shoe color on selected material
  jQuery(obj).parents(".inter-design-way").find(".hideColor").hide();
  jQuery(obj)
    .parents(".inter-design-way")
    .find("a[parentid=" + matId + "][parentattr=" + actAttrId + "]")
    .parent()
    .css({ display: "inline-block" });
  //jQuery(obj).parents(".inter-design-way").find("").parent().show();

  //scroll element to top

  /* if(actAttrId != "13"){
    jQuery('.scaprt-codes').stop().animate({
            scrollTop: jQuery('.scaprt-codes li:first').offset().top
    }, 1000);
  }*/

  jQuery(".scaprt-codes")
    .scrollTop(0)
    .scrollTop(jQuery(".scaprt-codes li:nth-child(0)"));
}

function showMaterialIcon(obj) {
  var matImg = jQuery(obj)
    .parents(".selct-material")
    .find(".actMaterial")
    .find("img")
    .attr("src");
  var matId = jQuery(obj)
    .parents(".selct-material")
    .find(".actMaterial")
    .attr("mat-id");
  var actAttrId;
  if (jQuery("#attribute_1 > li > .active ").parent().attr("id")) {
    actAttrId = jQuery("#attribute_1 > li > .active ")
      .parent()
      .attr("id")
      .split("_")[1];
  } else {
    return false;
  }
  if (actAttrId != "13") {
    jQuery(".sub-menu .active").find(".thumb_pattern_img").attr("src", matImg);
  }
  jQuery(".sub-menu .active")
    .find(".thumb_pattern_img")
    .attr("patternid", matId);
}

function resetBtns(actObj) {
  var this_btn = jQuery(actObj).attr("id");
  if (this_btn == "yes_reset") {
    jQuery("#user_login_submit").attr("reload", 1);
    checkForLoginUser("save", true);
  } else if (this_btn == "no_reset") {
    jQuery(".modal").modal("hide");
    //jQuery(".close").trigger("click");
    location.href = basePath;
  } else if (this_btn == "no_cnfrm") {
    jQuery(".modal").modal("hide");
    //jQuery(".close").trigger("click");
    window.open(basePath + "customtabs/index/view/id/" + insp_gal_did, "_self");
  } else if (this_btn == "no_rest") {
    jQuery(".modal").modal("hide");
    //jQuery(".close").trigger("click");
  } else if (this_btn == "yes_rest") {
    jQuery(".close").trigger("click");
    var dom_url = document.URL.toString();
    dom_url = dom_url.split("edit");
    var reload_url = dom_url[0].toString();
    jQuery(".loader_effect").show();
    //location.href = reload_url;
    jQuery(".product-holder li[product_id=" + mainProductId + "]").trigger(
      "click"
    );
  }
}

(function (jQuery) {
  jQuery.fn.test = function () {
    var self = this;
    this.one = function () {
      //set lace 1 active default
      setDefaultActiveLace1();

      return self;
    };
    this.two = function (type) {
      setTimeout(function () {
        jQuery(".shoe-data-preloader").show();
        jQuery(".tool-img").css({ opacity: "0.3" });
        jQuery("header").css("opacity", "0.3");
        jQuery(".tool-sec").css("opacity", "0.3");

        var brouge = jQuery("input[name=brouge]").prop("checked");
        var brouge2 = jQuery("input[name=brouge2]").prop("checked");
        var rivetsilver = jQuery("input[name=rivetsilver]").prop("checked");
        var rivetgold = jQuery("input[name=rivetgold]").prop("checked");
        var perforation = jQuery("input[name=perforation]").prop("checked");
        var perforation2 = jQuery("input[name=perforation2]").prop("checked");
        var fringe = jQuery("input[name=fringe]").prop("checked");
        var isEyelet = jQuery("input[name=eyelet]").prop("checked");
        var isZipper = jQuery("[name='zipper']").prop("checked");
        var isPiping = jQuery("[name='piping']").prop("checked");
        var isStrap = strapStatus;
        var isReartab = jQuery("[name='reartab']").prop("checked");
        var isToeCap = jQuery("[name='toecap']").prop("checked");
        //set default lace 1 color

        var matId, colorId;

        matId = jQuery("#part_13 .selct-material a:first").attr("mat-id");
        colorId = jQuery("#part_13 .thumb_pattern_img").attr("colorid");

        if (colorId != "") {
          actPartsColorGroup["13"] = matId + "_" + colorId;
        }

        console.log(actPartsColorGroup);

        const allowRivet = mainProductId != decorations.astoria.id || brouge;

        jQuery.ajax({
          type: "POST",
          url: ajaxPath + "get-preview-image.php",
          data: {
            mainProductId: mainProductId,
            views: views,
            actPartsColorGroup: actPartsColorGroup,
            brouge: brouge,
            brouge2: brouge2,
            type: type,
            rivetsilver: allowRivet && rivetsilver,
            rivetgold: allowRivet && rivetgold,
            perforation: perforation,
            perforation2: perforation2,
            fringe: fringe,
            isEyelet: isEyelet,
            isZipper: isZipper,
            isPiping: isPiping,
            isStrap: isStrap,
            isReartab: isReartab,
            isToeCap: isToeCap,
          },
          success: function (data) {
            if (data) {
              //jQuery(".shoe-data-preloader").hide();

              previewImagesData = JSON.parse(data);

              console.log(previewImagesData);

              var imageName =
                previewImagesData["previewImages"]["image1"]["src"]; //currView
              jQuery(".loader_effect").hide();

              if (type == "snapshot") {
                jQuery(".loading").hide();
                jQuery(".shoe-data-preloader").hide();
                jQuery(".tool-img").css({ opacity: "1" });
                jQuery("header").css("opacity", "1");
                jQuery(".tool-sec").css("opacity", "1");

                location.href =
                  basePath +
                  "custom-ajax/download.php?file=media/tool-data/img/preview-images/" +
                  imageName;
              } else if (type == "twitter") {
                jQuery(".loading").hide();
                jQuery(".shoe-data-preloader").hide();
                jQuery(".tool-img").css({ opacity: "1" });
                jQuery("header").css("opacity", "1");
                jQuery(".tool-sec").css("opacity", "1");

                callTwitter(
                  basePath + "media/tool-data/img/preview-images/" + imageName
                );
              } else if (type == "facebook") {
                jQuery(".loading").hide();
                jQuery(".shoe-data-preloader").hide();
                jQuery(".tool-img").css({ opacity: "1" });
                jQuery("header").css("opacity", "1");
                jQuery(".tool-sec").css("opacity", "1");

                fbs_click(
                  basePath + "media/tool-data/img/preview-images/" + imageName
                );
              } else if (type == "google") {
                jQuery(".loading").hide();
                jQuery(".shoe-data-preloader").hide();
                jQuery(".tool-img").css({ opacity: "1" });
                jQuery("header").css("opacity", "1");
                jQuery(".tool-sec").css("opacity", "1");

                var summary = "Juliabo Shoes";
                var imgPath =
                  basePath + "media/tool-data/img/preview-images/" + imageName;
                var url =
                  "https://plus.google.com/share?url=" +
                  imgPath +
                  "&media=" +
                  siteUrl +
                  "&description=" +
                  summary;
                //newwindow = window.open(url, 'name', 'height=500,width=800');

                var w = 620;
                var h = 360;
                var left = window.screen.width / 2 - (w / 2 + 10);
                var top = window.screen.height / 2 - (h / 2 + 50);
                var height = 500;
                var width = 650;

                newwindow = window.open(
                  url,
                  "google",
                  "height=" +
                    height +
                    ",width=" +
                    width +
                    ",resizable=yes,left=" +
                    left +
                    ",top=" +
                    top +
                    ",screenX=" +
                    left +
                    ",screenY=" +
                    top +
                    ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no"
                );

                if (window.focus()) {
                  newwindow.focus();
                }
              } else if (type == "pininterest") {
                jQuery(".loading").hide();
                jQuery(".shoe-data-preloader").hide();
                jQuery(".tool-img").css({ opacity: "1" });
                jQuery("header").css("opacity", "1");
                jQuery(".tool-sec").css("opacity", "1");

                sharePinterest(
                  basePath + "media/tool-data/img/preview-images/" + imageName
                );
              } else if (type == "send_email") {
                /* jQuery.ajax({
                     url: basePath + "getAttrData.php",
                     data: {
                     email_to: email_to,
                     email_from: email_from,
                     email_msg: email_message,
                     user_name: user_name,
                     image_name: imageName,
                     xAction: "sendUserEmail"
                     }, 
                     type: "post",
                     success: function (data) {
                     alert(data);
                     jQuery('#cancel-email').trigger('click');
                     },
                     error: function (msg) {  
                     alert('error');
                     }
                     });*/
              } else if (type == "save") {
                saveDesign();
              } else if (type == "cart") {
                saveDesign();
              }
            }
          },
        });
      }, 500);

      return self;
    };

    return this;
  };
})(jQuery);

function generateImage(type) {
  //jQuery(".loading").show();

  // VERY IMPORTANT: Must user $j, otherwise, if I use jQuery it won't work in Shopify
  var myplugin = $j().test();
  myplugin.one().two(type);
}
/*function generateImage(type)
 {
 html2canvas(document.getElementById('views'), {
 onrendered: function (can) {
 try {
 var dataURL = can.toDataURL('image/png');
 var image = new Image();
 
 image.height = jQuery("#views img").height();
 image.width = jQuery("#views img").width();
 image.src = dataURL;
 image.crossOrigin = "Anonymous";
 
 
 console.log("ht = "+image.height+" wt =  "+image.width);
 
 jQuery("#generateImg").html(image);
 
 
 
 image.onload = function () {
 if (dataURL === '') {
 console.log("No image source");
 } else {
 jQuery.post(basePath + "custom-ajax/savePreview.php", {
 data: jQuery("#generateImg img").attr("src"),
 type: type
 }).done(function (data) {
 if (data) {
 var imageName = data;
 jQuery('.loader_effect').hide();
 if (type == 'snapshot') {
 location.href = basePath + "custom-ajax/download.php?file=media/tool-data/img/customized-images/" + imageName;
 } else if (type == 'twitter') {
 callTwitter(basePath+"media/tool-data/img/customized-images/"+imageName);
 } else if (type == 'facebook') {
 fbs_click(basePath+"media/tool-data/img/customized-images/"+imageName);
 } else if (type == 'pininterest') {
 sharePinterest(basePath+"media/tool-data/img/customized-images/"+imageName);
 } else if (type == 'send_email') {
 
 }
 }
 });
 }
 }
 
 } catch (e) {
 alert("Data source error: " + e.message);
 return;
 }
 
 }
 });
 
 }
 
 
 /* --- code to Buy button --- */
function addDesignToCart() {
  return false;
  if (jQuery("#gallery_type").val() == "gallery") {
    size_flag = 0;
  }

  jQuery(".size-list-shoe").each(function () {
    if (jQuery(this).hasClass("active")) {
      size_flag = 1;
    }
  });

  //tempary code
  size_flag = 1;
  //end

  if (size_flag == 0) {
    jQuery(".black_overlay").show();
    var lang_flag = jQuery("#store_name").val();
    if (lang_flag == "french") {
      jQuery(".general_msg_container p").text(
        "Sélectionnez votre pointure s'il vous plaît"
      );
    } else {
      jQuery(".general_msg_container p").text("Please select shoe size.");
    }
    setTimeout(function () {
      jQuery(".general_msg_container").hide();
      jQuery(".black_overlay").hide();
    }, 2000);
    jQuery(".general_msg_container").css({
      left:
        parseFloat(
          jQuery(window).width() - jQuery(".general_msg_container").width()
        ) / 2,
      top: "245px",
    });
    jQuery(".general_msg_container").fadeIn("slow");
    jQuery(".tool_head:eq(3)").removeClass("tool_head_close");
    jQuery(".tool_head:eq(3)").next().slideDown("slow");
    jQuery(".getShoeSize").trigger("click");
    //jQuery("body,html").animate({ scrollTop: 400 }, 800);
    return false;
  } else {
    if (approval_img_flag == 0) {
      jQuery(".loader_effect").show();
      saveDesign(user_id, "cart", false, edit_id, design_id);
    } else {
      checkForLoginUser("cart", false);
    }
  }
}
/* ---end of the code --- */

function shareSocialMedia(type) {
  switch (type) {
    case "twitter":
      generateImage(type);
      break;
    case "pininterest":
      generateImage(type);
      break;
    case "twitter":
      break;
    case "facebook":
      generateImage(type);
      break;
    case "google":
      generateImage(type);

      break;
    case "email":
      jQuery(".popup-wrapper-container").find(".popup_data_container").html("");
      jQuery(".popup-wrapper-container")
        .find(".popup_data_container")
        .html(jQuery(".popup-email-wrapper").html());
      jQuery(".black_overlay").fadeIn("slow");
      jQuery(".popup-wrapper-container").css({ width: "auto", height: "auto" }); //, left: ((jQuery('.tool_main_div').width() - jQuery('.popup-wrapper-container').width()) / 2) + "px"
      jQuery(".popup-wrapper-container").fadeIn("slow");
      return false;
      break;
  }
}

/* --- code for twitter share --- */
function callTwitter(imgurl) {
  var msg = "";
  if (jQuery("#store_name").val() == "french") {
    msg = "Ce est ma nouvelle conception de chaussures.";
  } else {
    msg = "This is my new shoe design.";
  }
  var via = "Juliabo";
  var url =
    "https://twitter.com/share?url=" +
    imgurl +
    "&text=" +
    encodeURI(msg) +
    "&via=" +
    via +
    "&counturl=" +
    imgurl;

  //newwindow = window.open(url, 'twitterwindow', 'height=500,width=600');

  var w = 620;
  var h = 360;
  var left = window.screen.width / 2 - (w / 2 + 10);
  var top = window.screen.height / 2 - (h / 2 + 50);
  var height = 500;
  var width = 650;

  newwindow = window.open(
    url,
    "twitterwindow",
    "height=" +
      height +
      ",width=" +
      width +
      ",resizable=yes,left=" +
      left +
      ",top=" +
      top +
      ",screenX=" +
      left +
      ",screenY=" +
      top +
      ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no"
  );

  if (window.focus()) {
    newwindow.focus();
  }
  return false;
}
/* --- end of code --- */

/* --- code for facebook share --- */
function fbs_click(imgurl) {
  var summary = "";
  var t = "";
  if (jQuery("#store_name").val() == "french") {
    summary = "Ce est ma nouvelle conception de chaussures.";
    t = "Je ai conçu ce au Juliabo. Jetez un oeil.";
  } else {
    summary = "This is my new shoe design.";
    t = "I designed this at Juliabo. Just have a look.";
  }

  /*jQuery('meta[name=og\\:title]').attr('content', t);
  
    jQuery('meta[name=og\\:url]').attr('content', siteUrl);
    jQuery('meta[name=og\\:image]').attr('content', imgurl);
    jQuery('meta[name=og\\:description]').attr('content', summary);
    
    jQuery('meta[name=og\\:site_name]').attr('content', siteUrl);*/

  var link =
    "https://www.facebook.com/dialog/share?app_id=1726045611030483&href=" +
    imgurl;
  // var link = 'https://www.facebook.com/sharer.php?s=101&p[title]=' + encodeURI(t) + '&p[summary]=' + encodeURI(summary) + '&p[url]=' + imgurl + '&p[images][0]=' + siteUrl;
  //window.open(link,'sharer','toolbar=0,status=0,width=626,height=436');return false;

  // newwindow = window.open(link, 'sharer', 'toolbar=0,status=0,width=626,height=436');

  var w = 620;
  var h = 360;
  var left = window.screen.width / 2 - (w / 2 + 10);
  var top = window.screen.height / 2 - (h / 2 + 50);
  var height = 500;
  var width = 650;

  newwindow = window.open(
    link,
    "sharer",
    "height=" +
      height +
      ",width=" +
      width +
      ",resizable=yes,left=" +
      left +
      ",top=" +
      top +
      ",screenX=" +
      left +
      ",screenY=" +
      top +
      ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no"
  );

  if (window.focus()) {
    newwindow.focus();
  }
  return false;
}
/* --- end of code --- */

/* --- code for pinterest --- */
function sharePinterest(imgurl) {
  var msg = "";
  if (jQuery("#store_name").val() == "french") {
    msg = "Ce est ma nouvelle conception de chaussures.";
  } else {
    msg = "This is my new shoe design.";
  }
  var url =
    "//www.pinterest.com/pin/create/button/?url=" +
    siteUrl +
    "&media=" +
    imgurl +
    "&description=" +
    encodeURI(msg);
  //newwindow = window.open(url, 'name', 'height=500,width=600');

  var w = 620;
  var h = 360;
  var left = window.screen.width / 2 - (w / 2 + 10);
  var top = window.screen.height / 2 - (h / 2 + 50);
  var height = 500;
  var width = 650;

  newwindow = window.open(
    url,
    "pinterest",
    "height=" +
      height +
      ",width=" +
      width +
      ",resizable=yes,left=" +
      left +
      ",top=" +
      top +
      ",screenX=" +
      left +
      ",screenY=" +
      top +
      ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no"
  );

  if (window.focus()) {
    newwindow.focus();
  }
  return false;
}

/* --- end of code --- */

/* --- code to close social media share popup --- */
function socialMediaBack() {
  jQuery(".modal").hide();
}
/* --- end of code --- */

/* code to share social media images */
function socialMediaOk() {
  jQuery("#Share").modal("hide");
  var social_media = "";

  social_media = jQuery("#Share input:checked").attr("rel");

  shareSocialMedia(social_media);
}
/* --- end of code --- */

/* code to share social media images */
function socialMediaOkAccount() {
  //ShareAcc

  var social_media = "";

  var type = jQuery("#ShareAcc").find("input:checked").attr("rel");

  jQuery("#ShareAcc").modal("hide");

  var shareImage = jQuery(
    ".my-design-sec a[design_image_id=" + designImageId + "]"
  )
    .parent()
    .parent()
    .find("img")
    .attr("src");

  if (type == "twitter") {
    callTwitter(shareImage);
  } else if (type == "facebook") {
    fbs_click(shareImage);
  } else if (type == "google") {
    var summary = "Juliabo shoes";

    var url =
      "https://plus.google.com/share?url=" +
      shareImage +
      "&media=" +
      siteUrl +
      "&description=" +
      summary;
    newwindow = window.open(url, "name", "height=500,width=800");
    if (window.focus()) {
      newwindow.focus();
    }
  } else if (type == "pininterest") {
    sharePinterest(shareImage);
  }
}
/* --- end of code --- */

function checkForLoginUser(action_type, is_reload) {
  if (user_id != "") {
    jQuery(".loader_effect").show();
    saveDesign(user_id, action_type, is_reload, edit_id, design_id);
  } else {
    // popup for login
    jQuery(".popup-wrapper-container").find(".popup_data_container").html("");
    jQuery(".popup-wrapper-container")
      .find(".popup_data_container")
      .html(jQuery(".popup-login-wrapper").html());
    jQuery("#user_login_submit").attr("rel", action_type);
    jQuery(".black_overlay").fadeIn("slow");
    jQuery(".popup-wrapper-container").css({ width: "auto", height: "auto" });
    jQuery(".popup-wrapper-container").fadeIn("slow");
  }
}

function addBrogueImage(Obj) {
  var chk;
  brogue1Status = chk = jQuery(Obj).prop("checked");
  var MatColId = getBrogueactColorId();
  var views = productViews["views"];
  var next;
  
  actPartsColorGroup["20"] = MatColId;

  if (chk) {
    jQuery(Obj).parent().find("span").text("");
  } else {
    var brogue2El = jQuery('input[name="brouge2"]');
    if (brogue2El && brogue2El.length > 0) {
      // brouge2 check is present
      jQuery(Obj).parent().find("span").text("1");
    }
    if(mainProductId == decorations.astoria.id){
      jQuery(Obj).parent().find("span").text("2");
    }
  }

  var img1_view1,
    img2_view1,
    img3_view1,
    img4_view1,
    blank_img,
    img1_view2,
    img2_view2,
    img3_view2,
    img4_view2;
  var strapimg1_view1_silver,
    strapimg2_view1_silver,
    strapimg4_view1_silver,
    strapimg1_view2_silver,
    strapimg2_view2_silver,
    strapimg4_view2_silver;
  jQuery(
    "#part_20 .scaprt-codes [color-id=" + MatColId.split("_")[1] + "]"
  ).trigger("click");
  var img1_view1_silver,
    img2_view1_silver,
    img3_view1_silver,
    img4_view1_silver,
    img1_view2_silver,
    img2_view2_silver,
    img3_view2_silver,
    img4_view2_silver;
  var isRivetgold = jQuery("input[name='rivetgold']").prop("checked");
  var isRivetsilver = jQuery("input[name='rivetsilver']").prop("checked");
  var strapimg1_view1,
    strapimg1_view2,
    strapimg2_view1,
    strapimg2_view2,
    strapimg4_view1,
    strapimg4_view2;
  if (
    mainProductId == "9987925889" ||
    mainProductId == "4219595649" ||
    mainProductId == "1356909903958"
  ) {
    //lamont and chelsea
    // console.log("inside lamont ")
    for (var view in views) {
      if (brogue1Status == true && brogue2Status == true) {
        if (mainProductId == "4219595649") {
          //console.log("in chelsea in bothhhh true")
          jQuery("#view_" + views[view]["id"])
            .find("img[rel=28][isicon=no]")
            .insertAfter(
              "#view_" + views[view]["id"] + " img[rel=18][isicon=no]"
            );
        } else {
          // console.log("in lamont in bothhhh true")
          jQuery("#view_" + views[view]["id"])
            .find("img[rel=28][isicon=no]")
            .insertAfter(
              "#view_" + views[view]["id"] + " img[rel=17][isicon=no]"
            );
        }
      } else {
        // console.log("in else of both true")
        jQuery("#view_" + views[view]["id"])
          .find("img[rel=17][isicon=no]")
          .insertAfter(
            "#view_" + views[view]["id"] + " img[rel=18][isicon=no]"
          );
      }
    }
  }
  /**code for toe cap*/
  if (
    mainProductId == "1357580927062" ||
    mainProductId == "6566222337" ||
    mainProductId == decorations.jane.id||
    mainProductId == decorations.janePumps.id ||
    mainProductId == decorations.kent.id ||
    mainProductId == decorations.conicKent.id ||
    mainProductId == decorations.astoria.id
    ) {
    //baron//duke//jane
    
    if (brogue1Status) {
      // alert('inside b1 function')
      //jQuery("#toeCap_bannerList").hide();
      jQuery("#part_29").show();
      jQuery("#view_1").find("img[rel=29][isicon='no']").show();
      jQuery("#view_2").find("img[rel=29][isicon='no']").show();
      jQuery("#view_1").find("img[decoration='rivet'][isicon='no']").show();
      jQuery("#view_2").find("img[decoration='rivet'][isicon='no']").show();
      jQuery("[name='toecap']").prop("checked", false);
      if(mainProductId == decorations.astoria.id) {
        jQuery("#view_1").find("img[rel=38][isicon='no']").hide();
        jQuery("#view_2").find("img[rel=38][isicon='no']").hide();
      }
    } else {
      var toecapstatus = jQuery("[name='toecap']").prop("checked");
      if(mainProductId == decorations.astoria.id) {
        jQuery("#view_1").find("img[rel=20][isicon='no']").hide();
        jQuery("#view_2").find("img[rel=20][isicon='no']").hide();
      }else if (!toecapstatus) {
        jQuery("#part_29").hide();
        jQuery("#view_1").find("img[rel=29][isicon='no']").hide();
        jQuery("#view_2").find("img[rel=29][isicon='no']").hide();
      } else {
        jQuery("#part_29").show();
        jQuery("#view_1").find("img[rel=29][isicon='no']").show();
        jQuery("#view_2").find("img[rel=29][isicon='no']").show();
      }
      jQuery("#toeCap_bannerList").show();
    }
  }

  /**code for toe cap*/

  if (
    mainProductId == "460991377" ||
    mainProductId == "9978267073" ||
    mainProductId == "1466429441" ||
    mainProductId == "9987925889" ||
    mainProductId == "552167276574" ||
    mainProductId == "1267259905" ||
    mainProductId == "7743501889" ||
    mainProductId == "1465578305" ||
    mainProductId == "1362437832790" ||
    mainProductId == "1358334558294" ||
    mainProductId == "6567881729" ||
    mainProductId == "1464803201" ||
    mainProductId == "1357577519190" ||
    mainProductId == "1356909903958" ||
    mainProductId == "1362437865558" ||
    mainProductId == "460990265" ||
    mainProductId == "1358365491286" ||
    mainProductId == decorations.conicHolborn.id ||
    mainProductId == "1357580927062" ||
    mainProductId == "6566222337" ||
    mainProductId == "1358467629142" ||
    mainProductId == decorations.regent.id ||
    mainProductId == decorations.jane.id ||
    mainProductId == decorations.janePumps.id ||
    mainProductId == decorations.burton.id ||
    mainProductId == decorations.astoria.id ||
    mainProductId == decorations.aldgate.id ||
    mainProductId == decorations.conicAldgate.id ||
    mainProductId == decorations.florence.id ||
    mainProductId == decorations.joplin.id ||
    mainProductId == decorations.joplinPumps.id
  ) {
    //gatsby / lamont / harlow / hudson / morgan / madeline / limehouse//lenox //holborn//baron//duke//marry//jane//burton//aldgate//florence
    const productDecorations = Object.values(decorations).find((dec) => dec.id === mainProductId);
    const decorationsSourceId = productDecorations?.decorationsSource ?? mainProductId;
    img1_view1 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r1_gold.png";
    img2_view1 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r2_gold.png";
    img3_view1 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r3_gold.png";
    img4_view1 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r4_gold.png";

    img1_view2 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r1_gold.png";
    img2_view2 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r2_gold.png";
    img3_view2 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r3_gold.png";
    img4_view2 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r4_gold.png";

    img1_view1_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r1_silver.png";
    img2_view1_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r2_silver.png";
    img3_view1_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r3_silver.png";
    img4_view1_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r4_silver.png";

    img1_view2_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r1_silver.png";
    img2_view2_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r2_silver.png";
    img3_view2_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r3_silver.png";
    img4_view2_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r4_silver.png";

    blank_img =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/blank.png";
    if (isRivetgold) {
      if (brogue1Status == true && brogue2Status == true) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
      } else if (brogue1Status == true && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
      } else if (brogue1Status == false && brogue2Status == true) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else if (isRivetsilver) {
      if (brogue1Status == true && brogue2Status == true) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2_silver);
      } else if (brogue1Status == true && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2_silver);
      } else if (brogue1Status == false && brogue2Status == true) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2_silver);
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    }
  }
}
function addBrogueImage2(Obj) {
  //alert('hiiii')

  var chk;
  brogue2Status = chk = jQuery(Obj).prop("checked");

  /* code for toe cap */
  if (mainProductId == decorations.burton.id) {
    if (chk) {
      jQuery("#view_1").find("img[rel=38][isicon='no']").hide();
      jQuery("#view_2").find("img[rel=38][isicon='no']").hide();
      // set cap toe inactive
      setDecorationStatus("toecap", false);
    } else {
      jQuery("#view_1").find("img[rel=28][isicon=no]").hide();
      jQuery("#view_2").find("img[rel=28][isicon=no]").hide();
    }
  }

  /* show material 3 */
  if (
    mainProductId == "1362437832790" ||
    mainProductId == "1464803201" ||
    mainProductId == "1357577519190" ||
    mainProductId == decorations.florence.id
  ) {
    //morgan/limehouse//florence
    if (chk) {
      jQuery("#part_29").show();
    } else {
      jQuery("#part_29").hide();
    }
  }

  if (
    mainProductId == "1362437832790" ||
    mainProductId == "1464803201" ||
    mainProductId == "1357577519190"
  ) {
    //morgan/limehouse//
    if (chk) {
      jQuery("#view_1").find("img[rel=29][isicon=no]").show();
      jQuery("#view_2").find("img[rel=29][isicon=no]").show();
    } else {
      jQuery("#view_1").find("img[rel=29][isicon=no]").hide();
      jQuery("#view_2").find("img[rel=29][isicon=no]").hide();
    }
  }
  var MatColId = getBrogue2actColorId();

  var img1_view1,
    img2_view1,
    img3_view1,
    img4_view1,
    blank_img,
    img1_view2,
    img2_view2,
    img3_view2,
    img4_view2;
  var img1_view1_silver,
    img2_view1_silver,
    img3_view1_silver,
    img4_view1_silver,
    img1_view2_silver,
    img2_view2_silver,
    img3_view2_silver,
    img4_view2_silver;
  actPartsColorGroup["28"] = MatColId;
  var isRivetgold = jQuery("input[name='rivetgold']").prop("checked");
  var isRivetsilver = jQuery("input[name='rivetsilver']").prop("checked");
  var strapimg1_view1_silver,
    strapimg2_view1_silver,
    strapimg4_view1_silver,
    strapimg1_view2_silver,
    strapimg2_view2_silver,
    strapimg4_view2_silver;
  var strapimg1_view1,
    strapimg1_view2,
    strapimg2_view1,
    strapimg2_view2,
    strapimg4_view1,
    strapimg4_view2;
  var views = productViews["views"];
  var next;

  if (
    mainProductId == "460991377" ||
    mainProductId == "9978267073" ||
    mainProductId == "1466429441"
  ) {
    //gatsby
    if (perforation2status) {
      if (brogue2Status) {
        jQuery("#view_1")
          .find("img[rel=0][decoration=perforation2]")
          .attr(
            "src",
            "https://juliaboshop.com/media/decorations-images/460991377/perforation/05.png"
          );
        jQuery("#view_2")
          .find("img[rel=0][decoration=perforation2]")
          .attr(
            "src",
            "https://juliaboshop.com/media/decorations-images/460991377/perforation/06.png"
          );
      } else {
        jQuery("#view_1")
          .find("img[rel=0][decoration=perforation2]")
          .attr(
            "src",
            "https://juliaboshop.com/media/decorations-images/460991377/perforation/03.png"
          );

        jQuery("#view_2")
          .find("img[rel=0][decoration=perforation2]")
          .attr(
            "src",
            "https://juliaboshop.com/media/decorations-images/460991377/perforation/04.png"
          );
      }
    }
  }

  if (mainProductId == "1358334558294" || mainProductId == "1362437865558") {
    //vienna
    if (perforation2status) {
      if (brogue2Status) {
        jQuery("#view_1")
          .find("img[rel=0][decoration=perforation2]")
          .attr(
            "src",
            "https://juliaboshop.com/media/decorations-images/" +
              mainProductId +
              "/perforation/05.png"
          );
        jQuery("#view_2")
          .find("img[rel=0][decoration=perforation2]")
          .attr(
            "src",
            "https://juliaboshop.com/media/decorations-images/" +
              mainProductId +
              "/perforation/06.png"
          );
      } else {
        jQuery("#view_1")
          .find("img[rel=0][decoration=perforation2]")
          .attr(
            "src",
            "https://juliaboshop.com/media/decorations-images/" +
              mainProductId +
              "/perforation/03.png"
          );

        jQuery("#view_2")
          .find("img[rel=0][decoration=perforation2]")
          .attr(
            "src",
            "https://juliaboshop.com/media/decorations-images/" +
              mainProductId +
              "/perforation/04.png"
          );
      }
    }
  }

  if (chk) {
    jQuery(".views [rel=28]").show();
    jQuery(Obj).parent().find("span").text("");
  } else {
    jQuery(".views [rel=28]").hide();
    jQuery(Obj).parent().find("span").text("2");
  }

  jQuery(
    "#part_28 .scaprt-codes [color-id=" + MatColId.split("_")[1] + "]"
  ).trigger("click");

  if (
    mainProductId == "4219340353" ||
    mainProductId == decorations.regent.id ||
    mainProductId == decorations.burton.id ||
    mainProductId == decorations.astoria.id ||
    mainProductId == decorations.aldgate.id ||
    mainProductId == decorations.conicAldgate.id ||
    mainProductId == decorations.florence.id ||
    mainProductId == decorations.kent.id ||
    mainProductId == decorations.conicKent.id
  ) {
    //classon
    var sPart = "20";
    var imgPath =
      basePath +
      "media/front/product-images/product" +
      mainProductId +
      "/Product_" +
      mainProductId +
      "_Part_" +
      sPart +
      "_Material_" +
      MatColId.split("_")[0] +
      "_Color_" +
      MatColId.split("_")[1] +
      "_View_1.png";
    var imgPath2 =
      basePath +
      "media/front/product-images/product" +
      mainProductId +
      "/Product_" +
      mainProductId +
      "_Part_" +
      sPart +
      "_Material_" +
      MatColId.split("_")[0] +
      "_Color_" +
      MatColId.split("_")[1] +
      "_View_2.png";
    jQuery("#view_1")
      .find("img[rel=" + 28 + "][isicon='no']")
      .attr("src", imgPath);
    jQuery("#view_2")
      .find("img[rel=" + 28 + "][isicon='no']")
      .attr("src", imgPath2);
  } else {
    var sPart = "28";
    var imgPath =
      basePath +
      "media/front/product-images/product" +
      mainProductId +
      "/Product_" +
      mainProductId +
      "_Part_" +
      sPart +
      "_Material_" +
      MatColId.split("_")[0] +
      "_Color_" +
      MatColId.split("_")[1] +
      "_View_1.png";
    var imgPath2 =
      basePath +
      "media/front/product-images/product" +
      mainProductId +
      "/Product_" +
      mainProductId +
      "_Part_" +
      sPart +
      "_Material_" +
      MatColId.split("_")[0] +
      "_Color_" +
      MatColId.split("_")[1] +
      "_View_2.png";

    jQuery("#view_1")
      .find("img[rel=" + sPart + "][isicon='no']")
      .attr("src", imgPath);
    jQuery("#view_2")
      .find("img[rel=" + sPart + "][isicon='no']")
      .attr("src", imgPath2);
  }

  if (
    mainProductId == "9987925889" ||
    mainProductId == "4219595649" ||
    mainProductId == "1356909903958"
  ) {
    //lamont and chelsea

    for (var view in views) {
      if (brogue1Status == true && brogue2Status == true) {
        // console.log('inside if part')
        if (mainProductId == "4219595649") {
          //console.log("in chelsea in bothhhh true")
          jQuery("#view_" + views[view]["id"])
            .find("img[rel=28][isicon=no]")
            .insertAfter(
              "#view_" + views[view]["id"] + " img[rel=18][isicon=no]"
            );
        } else {
          //console.log("in lamont in bothhhh true")
          jQuery("#view_" + views[view]["id"])
            .find("img[rel=28][isicon=no]")
            .insertAfter(
              "#view_" + views[view]["id"] + " img[rel=17][isicon=no]"
            );
        }
      } else {
        // console.log("in else of both true")
        if (mainProductId == "9987925889" || mainProductId == "1356909903958") {
          jQuery("#view_" + views[view]["id"])
            .find("img[rel=17][isicon=no]")
            .insertAfter(
              "#view_" + views[view]["id"] + " img[rel=18][isicon=no]"
            );
        } else if (mainProductId == "4219595649") {
          //console.log('inside else part')
        }
      }
    }
  } //end of lamont and chelsea

  if (mainProductId == "4219340353") {
    //classon

    img1_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r1_gold.png";
    img2_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r2_gold.png";
    img3_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r3_gold.png";
    img4_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r4_gold.png";

    img1_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r1_gold.png";
    img2_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r2_gold.png";
    img3_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r3_gold.png";
    img4_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r4_gold.png";

    img1_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r1_silver.png";
    img2_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r2_silver.png";
    img3_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r3_silver.png";
    img4_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r4_silver.png";

    img1_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r1_silver.png";
    img2_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r2_silver.png";
    img3_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r3_silver.png";
    img4_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r4_silver.png";

    blank_img =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/blank.png";
    strapimg1_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r1_gold.png";
    strapimg2_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r2_gold.png";
    strapimg4_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r4_gold.png";
    strapimg1_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r1_gold.png";
    strapimg2_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r2_gold.png";
    strapimg4_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r4_gold.png";

    strapimg1_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r1_silver.png";
    strapimg2_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r2_silver.png";
    strapimg4_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r4_silver.png";

    strapimg1_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r1_silver.png";
    strapimg2_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r2_silver.png";
    strapimg4_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r4_silver.png";

    if (isRivetgold) {
      if (brogue1Status == true && brogue2Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg2_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
        }
      } else if (brogue2Status == true && brogue1Status == false) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg1_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg1_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
        }
      } else if (brogue2Status == false && brogue1Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg4_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
        }
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else if (isRivetsilver) {
      if (brogue1Status == true && brogue2Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg2_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg2_view2_silver
          );
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2_silver);
        }
      } else if (brogue2Status == true && brogue1Status == false) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg1_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg1_view2_silver
          );
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2_silver);
        }
      } else if (brogue2Status == false && brogue1Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg4_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg4_view2_silver
          );
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2_silver);
        }
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    }
  } else if (
    mainProductId == "460991377" ||
    mainProductId == "9987925889" ||
    mainProductId == "552167276574" ||
    mainProductId == "1267259905" ||
    mainProductId == "7743501889" ||
    mainProductId == "1465578305" ||
    mainProductId == "1362437832790" ||
    mainProductId == "1358334558294" ||
    mainProductId == "6567881729" ||
    mainProductId == "4219595649" ||
    mainProductId == "1464803201" ||
    mainProductId == "1357577519190" ||
    mainProductId == "1356909903958" ||
    mainProductId == "1362437865558" ||
    mainProductId == "460990265" ||
    mainProductId == "1358365491286" ||
    mainProductId == decorations.conicHolborn.id ||
    mainProductId == "1358467629142" ||
    mainProductId == decorations.regent.id ||
    mainProductId == decorations.burton.id ||
    mainProductId == decorations.astoria.id ||
    mainProductId == decorations.aldgate.id ||
    mainProductId == decorations.conicAldgate.id ||
    mainProductId == decorations.florence.id
  ) {
    //gatsby / lamont / harlow / morgan / madeline / chelsea / limehouse / lenox /holborn/marry/florence
    const productDecorations = Object.values(decorations).find((dec) => dec.id === mainProductId);
    const decorationsSourceId = productDecorations?.decorationsSource ?? mainProductId;
    img1_view1 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r1_gold.png";
    img2_view1 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r2_gold.png";
    img3_view1 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r3_gold.png";
    img4_view1 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r4_gold.png";

    img1_view2 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r1_gold.png";
    img2_view2 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r2_gold.png";
    img3_view2 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r3_gold.png";
    img4_view2 =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r4_gold.png";

    img1_view1_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r1_silver.png";
    img2_view1_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r2_silver.png";
    img3_view1_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r3_silver.png";
    img4_view1_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view1/r4_silver.png";

    img1_view2_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r1_silver.png";
    img2_view2_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r2_silver.png";
    img3_view2_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r3_silver.png";
    img4_view2_silver =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/view2/r4_silver.png";

    blank_img =
      basePath +
      "media/decorations-images/" +
      decorationsSourceId +
      "/rivets/blank.png";
    if (isRivetgold) {
      if (brogue1Status == true && brogue2Status == true) {
        //console.log("both true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
      } else if (brogue1Status == true && brogue2Status == false) {
        // console.log("1 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
      } else if (brogue1Status == false && brogue2Status == true) {
        //console.log("2 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
      } else if (brogue1Status == false && brogue2Status == false) {
        // console.log("2 false")
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else if (isRivetsilver) {
      if (brogue1Status == true && brogue2Status == true) {
        //console.log("both true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2_silver);
      } else if (brogue1Status == true && brogue2Status == false) {
        // console.log("1 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2_silver);
      } else if (brogue1Status == false && brogue2Status == true) {
        // console.log("2 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2_silver);
      } else if (brogue1Status == false && brogue2Status == false) {
        //console.log("2 false")
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    }
  }
}

function addBrogueImage2Lamont(obj) {
  //return false;
  var chk;
  brogue1Status = chk = jQuery(obj).prop("checked");

  var MatColId = getBrogueactColorId();
  var views = productViews["views"];
  var next;

  actPartsColorGroup["20"] = MatColId;

  var img1_view1,
    img2_view1,
    img3_view1,
    img4_view1,
    blank_img,
    img1_view2,
    img2_view2,
    img3_view2,
    img4_view2;
  var strapimg1_view1_silver,
    strapimg2_view1_silver,
    strapimg4_view1_silver,
    strapimg1_view2_silver,
    strapimg2_view2_silver,
    strapimg4_view2_silver,
    strapimg1_view1,
    strapimg1_view2,
    strapimg2_view1,
    strapimg2_view2,
    strapimg4_view1,
    strapimg4_view2;

  jQuery(
    "#part_20 .scaprt-codes [color-id=" + MatColId.split("_")[1] + "]"
  ).trigger("click");

  // var MatColId = getBrogueactColorId();
  var views = productViews["views"];
  var next;

  //actPartsColorGroup["20"] = MatColId;

  var img1_view1,
    img2_view1,
    img3_view1,
    img4_view1,
    blank_img,
    img1_view2,
    img2_view2,
    img3_view2,
    img4_view2;

  //jQuery("#part_20 .scaprt-codes [color-id=" + MatColId.split("_")[1] + "]").trigger("click");
  var brogueImg1_view1,
    brogueImg1_view2,
    img1_view1_silver,
    img2_view1_silver,
    img3_view1_silver,
    img4_view1_silver,
    img1_view2_silver,
    img2_view2_silver,
    img3_view2_silver,
    img4_view2_silver;
  var isRivetgold = jQuery("input[name='rivetgold']").prop("checked");
  var isRivetsilver = jQuery("input[name='rivetsilver']").prop("checked");
  var strapBrogueImage;
  if (
    mainProductId == "9987925889" ||
    mainProductId == "4219595649" ||
    mainProductId == "1356909903958"
  ) {
    //lamont and chelsea
    // console.log("inside lamont ")
    for (var view in views) {
      if (brogue1Status == true && brogue2Status == true) {
        // console.log("in lamont in bothhhh true")

        if (mainProductId == "4219595649") {
          jQuery("#view_" + views[view]["id"])
            .find("img[rel=28][isicon=no]")
            .insertAfter(
              "#view_" + views[view]["id"] + " img[rel=18][isicon=no]"
            );
        } else {
          jQuery("#view_" + views[view]["id"])
            .find("img[rel=28][isicon=no]")
            .insertAfter(
              "#view_" + views[view]["id"] + " img[rel=17][isicon=no]"
            );
        }
      } else {
        //console.log("in else of both true")
        if (mainProductId == "9987925889" || mainProductId == "1356909903958") {
          jQuery("#view_" + views[view]["id"])
            .find("img[rel=17][isicon=no]")
            .insertAfter(
              "#view_" + views[view]["id"] + " img[rel=18][isicon=no]"
            );
        } else if (mainProductId == "4219595649") {
        }
      }
    }
  }

  if (chk) {
    jQuery("input[name='brouge2']").next().text('');
    for (var view in views) {
      if (mainProductId == "4219340353") {
        //classon
        strapBrogueImage =
          basePath +
          "media/decorations-images/" +
          mainProductId +
          "/strapBrogue/brogue2_view_0" +
          views[view]["id"] +
          ".png";
        brogueImg1_view1 =
          basePath +
          "media/decorations-images/" +
          mainProductId +
          "/brogue2_view_0" +
          views[view]["id"] +
          ".png";
        if (strapStatus == true) {
          jQuery("#view_" + views[view]["id"])
            .find("[decoration=brogue1Lamont]")
            .attr("src", strapBrogueImage);
          //console.log(jQuery("#view_" + views[view]["id"]).find('[decoration=brogue1Lamont]').attr('src',strapBrogueImage))
        } else {
          jQuery("#view_" + views[view]["id"])
            .find("[decoration=brogue1Lamont]")
            .attr("src", brogueImg1_view1);
          //console.log(jQuery("#view_" + views[view]["id"]).find('[decoration=brogue1Lamont]').attr('src',brogueImg1_view1))
        }
      } else {
        brogueImg1_view1 =
          basePath +
          "media/decorations-images/" +
          mainProductId +
          "/brogue2_view_0" +
          views[view]["id"] +
          ".png";

        jQuery("#view_" + views[view]["id"])
          .find("[decoration=brogue1Lamont]")
          .attr("src", brogueImg1_view1);
        //console.log(jQuery("#view_" + views[view]["id"]).find('[decoration=brogue1Lamont]').attr('src',brogueImg1_view1))
      }
    }
  } else {
    jQuery("input[name='brouge2']").next().text('1');
    for (var view in views) {
      brogueImg1_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/blank.png";

      jQuery("#view_" + views[view]["id"])
        .find("[decoration=brogue1Lamont]")
        .attr("src", brogueImg1_view1);
      // console.log(jQuery("#view_" + views[view]["id"]).find('[decoration=brogue1Lamont]').attr('src',brogueImg1_view1))
    }
  }

  if (mainProductId == "4219340353") {
    //classon

    img1_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r1_gold.png";
    img2_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r2_gold.png";
    img3_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r3_gold.png";
    img4_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r4_gold.png";

    img1_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r1_gold.png";
    img2_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r2_gold.png";
    img3_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r3_gold.png";
    img4_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r4_gold.png";

    img1_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r1_silver.png";
    img2_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r2_silver.png";
    img3_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r3_silver.png";
    img4_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r4_silver.png";

    img1_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r1_silver.png";
    img2_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r2_silver.png";
    img3_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r3_silver.png";
    img4_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r4_silver.png";

    blank_img =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/blank.png";
    strapimg1_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r1_gold.png";
    strapimg2_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r2_gold.png";
    strapimg4_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r4_gold.png";
    strapimg1_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r1_gold.png";
    strapimg2_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r2_gold.png";
    strapimg4_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r4_gold.png";

    strapimg1_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r1_silver.png";
    strapimg2_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r2_silver.png";
    strapimg4_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view1/r4_silver.png";

    strapimg1_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r1_silver.png";
    strapimg2_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r2_silver.png";
    strapimg4_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/straprivets/view2/r4_silver.png";

    if (isRivetgold) {
      if (brogue1Status == true && brogue2Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg2_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
        }
      } else if (brogue2Status == true && brogue1Status == false) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg1_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg1_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
        }
      } else if (brogue2Status == false && brogue1Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg4_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
        }
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else if (isRivetsilver) {
      if (brogue1Status == true && brogue2Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg2_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg2_view2_silver
          );
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2_silver);
        }
      } else if (brogue2Status == true && brogue1Status == false) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg1_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg1_view2_silver
          );
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2_silver);
        }
      } else if (brogue2Status == false && brogue1Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg1_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg1_view2_silver
          );
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2_silver);
        }
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    }
  } else if (
    mainProductId == "460991377" ||
    mainProductId == "9978267073" ||
    mainProductId == "1466429441" ||
    mainProductId == "9987925889" ||
    mainProductId == "552167276574" ||
    mainProductId == "1267259905" ||
    mainProductId == "7743501889" ||
    mainProductId == "1465578305" ||
    mainProductId == "4219595649" ||
    mainProductId == "1356909903958"
  ) {
    //gatsby / lamont / harlow / hudson / chelsea

    img1_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r1_gold.png";
    img2_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r2_gold.png";
    img3_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r3_gold.png";
    img4_view1 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r4_gold.png";

    img1_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r1_gold.png";
    img2_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r2_gold.png";
    img3_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r3_gold.png";
    img4_view2 =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r4_gold.png";

    img1_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r1_silver.png";
    img2_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r2_silver.png";
    img3_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r3_silver.png";
    img4_view1_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view1/r4_silver.png";

    img1_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r1_silver.png";
    img2_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r2_silver.png";
    img3_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r3_silver.png";
    img4_view2_silver =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/view2/r4_silver.png";

    blank_img =
      basePath +
      "media/decorations-images/" +
      mainProductId +
      "/rivets/blank.png";
    if (isRivetgold) {
      if (brogue1Status == true && brogue2Status == true) {
        //console.log("both true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
      } else if (brogue1Status == true && brogue2Status == false) {
        // console.log("1 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
      } else if (brogue1Status == false && brogue2Status == true) {
        //console.log("2 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
      } else if (brogue1Status == false && brogue2Status == false) {
        // console.log("2 false")
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else if (isRivetsilver) {
      if (brogue1Status == true && brogue2Status == true) {
        //console.log("both true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2_silver);
      } else if (brogue1Status == true && brogue2Status == false) {
        //console.log("1 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2_silver);
      } else if (brogue1Status == false && brogue2Status == true) {
        //console.log("2 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1_silver);
        jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2_silver);
      } else if (brogue1Status == false && brogue2Status == false) {
        //console.log("2 false")
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    }
  }
}

function addEyeletImage(Obj) {
  var chk = jQuery(Obj).prop("checked");
  var views = productViews["views"];
  for (var view in views) {
    if (chk) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=19][isicon=no]")
        .show();
      jQuery("#part_19").find(".thumb_color_img").show();
      var actColorEl = jQuery("li.actColor", ".product-typer");
      showColor(actColorEl);
    } else {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=19][isicon=no]")
        .hide();
      jQuery("#part_19").find(".thumb_color_img").hide();
    }
  }
}

function addRearTab(obj) {
  var chk = jQuery(obj).prop("checked");
  var views = productViews["views"];
  for (var view in views) {
    if (chk) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=32][isicon=no]")
        .show();
    } else {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=32][isicon=no]")
        .hide();
    }
  }
}

function addStrapImage(Obj) {
  var chk = jQuery(Obj).prop("checked");
  var views = productViews["views"];
  var strapBrogueImage1;
  var img1_view1,
    img2_view1,
    img3_view1,
    img4_view1,
    blank_img,
    img1_view2,
    img2_view2,
    img3_view2,
    img4_view2;
  var img1_view1_silver,
    img2_view1_silver,
    img3_view1_silver,
    img4_view1_silver,
    img1_view2_silver,
    img2_view2_silver,
    img3_view2_silver,
    img4_view2_silver;

  var strapimg1_view1_silver,
    strapimg2_view1_silver,
    strapimg4_view1_silver,
    strapimg1_view2_silver,
    strapimg2_view2_silver,
    strapimg4_view2_silver;
  var strapimg1_view1,
    strapimg1_view2,
    strapimg2_view1,
    strapimg2_view2,
    strapimg4_view1,
    strapimg4_view2;
  var rivetGoldStatus = jQuery("input[name='rivetgold']").prop("checked");
  var rivetSilverStatus = jQuery("input[name='rivetsilver']").prop("checked");

  strapStatus = chk;
  if (chk) {
    jQuery("#part_33").show();
    strapStatus = true;
    jQuery("#view_1").find("img[rel=35][isicon=no]").show();
    jQuery("#view_2").find("img[rel=35][isicon=no]").show();
    jQuery("#view_1").find("img[rel=33][isicon=no]").show();
    jQuery("#view_2").find("img[rel=33][isicon=no]").show();

    for (var view in views) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=36][isicon=no]")
        .show();
    }

    if (mainProductId == "4219340353") {
      //classon

      var blank_img =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/blank.png";

      strapimg1_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r1_gold.png";
      strapimg2_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r2_gold.png";
      strapimg4_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r4_gold.png";
      strapimg1_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r1_gold.png";
      strapimg2_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r2_gold.png";
      strapimg4_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r4_gold.png";

      strapimg1_view1_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r1_silver.png";
      strapimg2_view1_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r2_silver.png";
      strapimg4_view1_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r4_silver.png";

      strapimg1_view2_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r1_silver.png";
      strapimg2_view2_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r2_silver.png";
      strapimg4_view2_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r4_silver.png";
      if (brogue1Status == true) {
        for (view in views) {
          strapBrogueImage1 =
            basePath +
            "media/decorations-images/" +
            mainProductId +
            "/strapBrogue/brogue2_view_0" +
            views[view]["id"] +
            ".png";
          jQuery("#view_" + views[view]["id"])
            .find("[decoration=brogue1Lamont]")
            .attr("src", strapBrogueImage1);
        }
      }

      if (brogue1Status == true && brogue2Status == false) {
        if (rivetGoldStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg4_view2);
        } else if (rivetSilverStatus) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg4_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg4_view2_silver
          );
        }
      } else if (brogue2Status == true && brogue1Status == false) {
        if (rivetGoldStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg1_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg1_view2);
        } else if (rivetSilverStatus) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg1_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg1_view2_silver
          );
        }
      } else if (brogue1Status == true && brogue2Status == true) {
        if (rivetGoldStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg2_view2);
        } else if (rivetSilverStatus) {
          jQuery("#view_1 [decoration=rivet]").attr(
            "src",
            strapimg2_view1_silver
          );
          jQuery("#view_2 [decoration=rivet]").attr(
            "src",
            strapimg2_view2_silver
          );
        }
      } else {
      }
    }
  } else {
    jQuery("#part_33").hide();
    for (var view in views) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=36][isicon=no]")
        .hide();
    }
    strapStatus = false;
    jQuery("#view_1").find("img[rel=35][isicon=no]").hide();
    jQuery("#view_2").find("img[rel=35][isicon=no]").hide();
    jQuery("#view_1").find("img[rel=33][isicon=no]").hide();
    jQuery("#view_2").find("img[rel=33][isicon=no]").hide();
    if (mainProductId == "4219340353") {
      //classon
      img1_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r1_gold.png";
      img2_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r2_gold.png";
      img4_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r4_gold.png";

      img1_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r1_gold.png";
      img2_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r2_gold.png";
      img4_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r4_gold.png";

      img1_view1_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r1_silver.png";
      img2_view1_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r2_silver.png";
      img4_view1_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r4_silver.png";

      img1_view2_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r1_silver.png";
      img2_view2_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r2_silver.png";
      img4_view2_silver =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r4_silver.png";

      if (brogue1Status == true) {
        for (view in views) {
          strapBrogueImage1 =
            basePath +
            "media/decorations-images/" +
            mainProductId +
            "/brogue2_view_0" +
            views[view]["id"] +
            ".png";
          jQuery("#view_" + views[view]["id"])
            .find("[decoration=brogue1Lamont]")
            .attr("src", strapBrogueImage1);
        }
      }

      if (brogue1Status == true && brogue2Status == false) {
        if (rivetGoldStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
        } else if (rivetSilverStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2_silver);
        }
      } else if (brogue2Status == true && brogue1Status == false) {
        if (rivetGoldStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
        } else if (rivetSilverStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2_silver);
        }
      } else if (brogue1Status == true && brogue2Status == true) {
        if (rivetGoldStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
        } else if (rivetSilverStatus) {
          jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1_silver);
          jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2_silver);
        }
      } else {
      }
    }
  }
}

function getMforStrapId() {
  if (mainProductId == "4219340353") {
    //classon
    var mate2 = actPartsColorGroup["18"];
    var attrData = actPartsColorGroup["18"].split("_");

    var mattitle = jQuery("#part_18")
      .find(".selct-material  a[mat-id='" + attrData[0] + "']")
      .attr("titlel");
    var colortitle = jQuery("#part_18")
      .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
      .attr("titlel");

    var strapMatId = jQuery("#part_36")
      .find(".selct-material  a[titlel='" + mattitle + "']")
      .attr("mat-id");
    var strapColId = jQuery("#part_36")
      .find(".scaprt-codes  a[titlel='" + colortitle + "']")
      .attr("titlel");
    //var strapwmatid = jQuery("#part_36").find(".selct-material  a[titlel='" + mattitle + "']").attr("mat-id");
    return (
      strapMatId +
      "_" +
      jQuery("#part_36")
        .find(
          ".scaprt-codes [parentid=" +
            strapMatId +
            "][titlel='" +
            colortitle +
            "']"
        )
        .attr("color-id")
    );
  }
}

function addZipperImage(Obj) {
  var chk = jQuery(Obj).prop("checked");

  if (chk) {
    jQuery(".views [rel=27]").show();
  } else {
    jQuery(".views [rel=27]").hide();
  }
}

function addFringeImage(obj) {
  var chk = jQuery(obj).prop("checked");
  var views = productViews["views"];
  for (var view in views) {
    if (chk) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=26][isicon=no]")
        .show();
      if (
        mainProductId == "4221337537" ||
        mainProductId == "460972461" ||
        mainProductId == "560913252382"
      ) {
        //oddity
        jQuery(".addRemove", "#part_26").closest("li").hide();
        jQuery("#part_26").show();
      }
    } else {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=26][isicon=no]")
        .hide();
      if (
        mainProductId == "4221337537" ||
        mainProductId == "460972461" ||
        mainProductId == "560913252382"
      ) {
        //oddity
        jQuery("#part_26").hide();
      }
    }
  }
}

function addPerforationImage2(Obj) {
  //jQuery("[name=perforation]").prop("checked",false).trigger("change");
  const productDecorations = Object.values(decorations).find((dec) => dec.id === mainProductId);
  const decorationsSourceId = productDecorations?.decorationsSource ?? mainProductId;

  var img =
    basePath + "media/decorations-images/" + decorationsSourceId + "/perforation/";
  var isPer = jQuery(Obj).prop("checked");
  perforation2status = isPer;

  if (isPer) {
    if (mainProductId == "1358334558294" || mainProductId == "1362437865558") {
      //viennal
      if (brogue2Status) {
        jQuery("#view_1 [decoration=perforation2]").attr("src", img + "05.png");
        jQuery("#view_2 [decoration=perforation2]").attr("src", img + "06.png");
      } else {
        jQuery("#view_1 [decoration=perforation2]").attr("src", img + "03.png");
        jQuery("#view_2 [decoration=perforation2]").attr("src", img + "04.png");
      }
    } else {
      jQuery("#view_1 [decoration=perforation2]").attr("src", img + "03.png");
      jQuery("#view_2 [decoration=perforation2]").attr("src", img + "04.png");
      //jQuery("[name=perforation]").prop("checked",false).trigger("change");
    }
    jQuery(Obj).parent().find("span").text("");
  } else {
    jQuery("#view_1 [decoration=perforation2]").attr("src", blankImg);
    jQuery("#view_2 [decoration=perforation2]").attr("src", blankImg);

    if (
      mainProductId == "1362437832790" ||
      mainProductId == "1358334558294" ||
      mainProductId == "1362437865558" ||
      mainProductId == "460990265" ||
      mainProductId == "1358365491286" ||
      mainProductId == decorations.conicHolborn.id ||
      mainProductId == "1357580927062" ||
      mainProductId == "6566222337" ||
      mainProductId == "1358467629142" ||
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id
    ) {
      //morgan / vienna /lenox /holborn/baron//duke/marry/regent//jane
      jQuery(Obj).parent().find("span").text("");
    }else if(mainProductId == decorations.astoria.id){
      jQuery(Obj).parent().find("span").text("1");
    } else {
      jQuery(Obj).parent().find("span").text("2");
    }
  }

  // jQuery("[name=perforation]").prop("checked",false).trigger("change");
}

function addPerforationImage(Obj) {
  //jQuery("[name=perforation2]").prop("checked",false).trigger("change");
  const productDecorations = Object.values(decorations).find((dec) => dec.id === mainProductId);
  const decorationsSourceId = productDecorations?.decorationsSource ?? mainProductId;

  var img =
    basePath + "media/decorations-images/" + decorationsSourceId + "/perforation/";
  var isPer = jQuery(Obj).prop("checked");

  if (isPer) {
    jQuery("#view_1 [decoration=perforation]").attr("src", img + "01.png");
    jQuery("#view_2 [decoration=perforation]").attr("src", img + "02.png");
    //jQuery("[name=perforation2]").prop("checked",false).trigger("change");

    jQuery(Obj).parent().find("span").text("");
  } else {
    jQuery("#view_1 [decoration=perforation]").attr("src", blankImg);
    jQuery("#view_2 [decoration=perforation]").attr("src", blankImg);

    if (mainProductId == "6050500865") {
      jQuery(Obj).parent().find("span").text("");
    } else if (
      mainProductId == "5419162049" ||
      mainProductId == "1467857665" ||
      mainProductId == "9977652737"
    ) {
      jQuery(Obj).parent().find("span").text(""); //560914563102
    } else if (mainProductId == "560915906590") {
      jQuery(Obj).parent().find("span").text("");
    } else if (mainProductId == "560914563102") {
      jQuery(Obj).parent().find("span").text("");
    } else if (
      mainProductId == "1362437832790" ||
      mainProductId == "1358334558294" ||
      mainProductId == "1362437865558" ||
      mainProductId == "4219595649" ||
      mainProductId == "460990265" ||
      mainProductId == "1358365491286" ||
      mainProductId == decorations.conicHolborn.id ||
      mainProductId == "1357580927062" ||
      mainProductId == "6566222337" ||
      mainProductId == "1358467629142" ||
      mainProductId == decorations.regent.id ||
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id ||
      mainProductId == decorations.burton.id ||
      mainProductId == decorations.astoria.id ||
      mainProductId == decorations.joplinPumps.id ||
      mainProductId == decorations.joplin.id
    ) {
      //morgan / vienna /chelsea/lenox/holborn//baron//duke//marry//jane//burton//kent
      jQuery(Obj).parent().find("span").text("");
    } else {
      //1467857665
      jQuery(Obj).parent().find("span").text("1");
    }
  }

  //jQuery("[name=perforation2]").prop("checked",false).trigger("change");
}

//metal brouge
function addRivetImageGold(Obj) {
  //var img = basePath + "media/decorations-images/" + mainProductId + "/rivet/";

  var isRivetgold;
  RivetgoldStatus = isRivetgold = jQuery("input[name='rivetgold']").prop(
    "checked"
  );

  jQuery("input[name='rivetsilver']").prop("checked", false);

  var colorId;
  var matId;
  var part;

  var img1, img2;
  var img1_view1,
    img2_view1,
    img3_view1,
    img4_view1,
    blank_img,
    img1_view2,
    img2_view2,
    img3_view2,
    img4_view2;
  var strapimg1_view1,
    strapimg2_view1,
    strapimg4_view1,
    strapimg1_view2,
    strapimg2_view2,
    strapimg4_view2;
  jQuery("#view_1 [decoration=rivet]").attr("src", blankImg);
  jQuery("#view_2 [decoration=rivet]").attr("src", blankImg);

  if (isRivetgold) {
    colorId = jQuery("input[name='rivetgold']").attr("colorId");

    matId = jQuery("input[name='rivetgold']").attr("matId");
    part = jQuery("input[name='rivetgold']").attr("part");

    actPartsColorGroup[part] = matId + "_" + colorId;

    if (mainProductId == "4219340353") {
      //classon
      img1_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r1_gold.png";
      img2_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r2_gold.png";
      img3_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r3_gold.png";
      img4_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r4_gold.png";

      img1_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r1_gold.png";
      img2_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r2_gold.png";
      img3_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r3_gold.png";
      img4_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r4_gold.png";

      blank_img =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/blank.png";
      strapimg1_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r1_gold.png";
      strapimg2_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r2_gold.png";
      strapimg4_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r4_gold.png";
      strapimg1_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r1_gold.png";
      strapimg2_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r2_gold.png";
      strapimg4_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r4_gold.png";

      if (brogue2Status == true && brogue1Status == false) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg1_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg1_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
        }
      } else if (brogue2Status == false && brogue1Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg4_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
        }
      } else if (brogue1Status == true && brogue2Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg2_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
        }
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else if (
      mainProductId == "460991377" ||
      mainProductId == "9987925889" ||
      mainProductId == "552167276574" ||
      mainProductId == "1267259905" ||
      mainProductId == "7743501889" ||
      mainProductId == "1465578305" ||
      mainProductId == "1362437832790" ||
      mainProductId == "1358334558294" ||
      mainProductId == "1362437865558" ||
      mainProductId == "6567881729" ||
      mainProductId == "4219595649" ||
      mainProductId == "1464803201" ||
      mainProductId == "1357577519190" ||
      mainProductId == "1356909903958" ||
      mainProductId == "460990265" ||
      mainProductId == "1358365491286" ||
      mainProductId == decorations.conicHolborn.id ||
      mainProductId == "1357580927062" ||
      mainProductId == "6566222337" ||
      mainProductId == "1358467629142" ||
      mainProductId == decorations.regent.id ||
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id ||
      mainProductId == decorations.burton.id ||
      mainProductId == decorations.astoria.id ||
      mainProductId == decorations.aldgate.id ||
      mainProductId == decorations.conicAldgate.id ||
      mainProductId == decorations.florence.id ||
      mainProductId == decorations.joplin.id ||
      mainProductId == decorations.joplinPumps.id
    ) {
      //gatsby & lamont /harlow / hudson / morgan / vienna / madeline / chelsea/ limehouse/ lenox /holborn/baron//duke/marry//jane//kent
      const productDecorations = Object.values(decorations).find((dec) => dec.id === mainProductId);
      const decorationsSourceId = productDecorations?.decorationsSource ?? mainProductId;
      img1_view1 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view1/r1_gold.png";
      img2_view1 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view1/r2_gold.png";
      img3_view1 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view1/r3_gold.png";
      img4_view1 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view1/r4_gold.png";

      img1_view2 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view2/r1_gold.png";
      img2_view2 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view2/r2_gold.png";
      img3_view2 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view2/r3_gold.png";
      img4_view2 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view2/r4_gold.png";

      blank_img =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/blank.png";
      //console.log("1 = " + img1_view1 + "2 = " + img2_view1 + "3 = " + img3_view1 + " 4 = " + img4_view1 )

      if (brogue1Status == true && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
      } else if (brogue1Status == false && brogue2Status == true) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
      } else if (brogue1Status == true && brogue2Status == true) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else {
      img1 =
        basePath +
        "media/front/product-images/product" +
        mainProductId +
        "/Product_" +
        mainProductId +
        "_Part_" +
        part +
        "_Material_" +
        matId +
        "_Color_" +
        colorId +
        "_View_1.png";
      img2 =
        basePath +
        "media/front/product-images/product" +
        mainProductId +
        "/Product_" +
        mainProductId +
        "_Part_" +
        part +
        "_Material_" +
        matId +
        "_Color_" +
        colorId +
        "_View_2.png";

      jQuery("#view_1 [decoration=rivet]").attr("src", img1);
      jQuery("#view_2 [decoration=rivet]").attr("src", img2);
      jQuery(".views [rel=21]").hide();
      //jQuery("#part_21").show();
    }
  }
}

function addRivetImageSilver(Obj) {
  //var img = basePath + "media/decorations-images/" + mainProductId + "/rivet/";
  var colorId;
  var matId;
  var part;

  var img1, img2;
  var isRivetsilver;
  var img1_view1,
    img2_view1,
    img3_view1,
    img4_view1,
    blank_img,
    img1_view2,
    img2_view2,
    img3_view2,
    img4_view2;
  var strapimg1_view1,
    strapimg2_view1,
    strapimg4_view1,
    strapimg1_view2,
    strapimg2_view2,
    strapimg4_view2;
  RivetsilverStatus = isRivetsilver = jQuery("input[name='rivetsilver']").prop(
    "checked"
  );

  jQuery("#view_1 [decoration=rivet]").attr("src", blankImg);
  jQuery("#view_2 [decoration=rivet]").attr("src", blankImg);

  jQuery("input[name='rivetgold']").prop("checked", false);
  if (isRivetsilver) {
    colorId = jQuery("input[name='rivetsilver']").attr("colorId");
    matId = jQuery("input[name='rivetsilver']").attr("matId");
    part = jQuery("input[name='rivetsilver']").attr("part");

    actPartsColorGroup[part] = matId + "_" + colorId;

    if (mainProductId == "4219340353") {
      //classon

      img1_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r1_silver.png";
      img2_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r2_silver.png";
      img4_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view1/r4_silver.png";

      img1_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r1_silver.png";
      img2_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r2_silver.png";
      img4_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/view2/r4_silver.png";

      blank_img =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/blank.png";
      strapimg1_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r1_silver.png";
      strapimg2_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r2_silver.png";
      strapimg4_view1 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view1/r4_silver.png";
      strapimg1_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r1_silver.png";
      strapimg2_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r2_silver.png";
      strapimg4_view2 =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/straprivets/view2/r4_silver.png";

      if (brogue2Status == true && brogue1Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
      } else if (brogue2Status == false && brogue1Status == true) {
        // console.log('inside b2 true')
        if (strapStatus == true) {
          //console.log('inside strap true')
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg4_view2);
        } else {
          //console.log('inside strap false or else')
          jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
        }
      } else if (brogue1Status == true && brogue2Status == true) {
        if (strapStatus == true) {
          jQuery("#view_1 [decoration=rivet]").attr("src", strapimg2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", strapimg2_view2);
        } else {
          jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
          jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
        }
      } else if (brogue1Status == false && brogue2Status == false) {
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else if (
      mainProductId == "460991377" ||
      mainProductId == "9987925889" ||
      mainProductId == "552167276574" ||
      mainProductId == "1267259905" ||
      mainProductId == "7743501889" ||
      mainProductId == "1465578305" ||
      mainProductId == "1362437832790" ||
      mainProductId == "1358334558294" ||
      mainProductId == "1362437865558" ||
      mainProductId == "6567881729" ||
      mainProductId == "4219595649" ||
      mainProductId == "1464803201" ||
      mainProductId == "1357577519190" ||
      mainProductId == "460990265" ||
      mainProductId == "1358365491286" ||
      mainProductId == decorations.conicHolborn.id ||
      mainProductId == "1357580927062" ||
      mainProductId == "6566222337" ||
      mainProductId == "1358467629142" ||
      mainProductId == decorations.regent.id ||
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id ||
      mainProductId == decorations.burton.id ||
      mainProductId == decorations.astoria.id ||
      mainProductId == decorations.aldgate.id ||
      mainProductId == decorations.conicAldgate.id ||
      mainProductId == decorations.florence.id ||
      mainProductId == decorations.joplin.id ||
      mainProductId == decorations.joplinPumps.id
    ) {
      //gatsby & lamont /harlow /hudson / vienna / madeline / chelsea /limehouse/lenox/holborn/baton//duke//marry//jane//burton
      const productDecorations = Object.values(decorations).find((dec) => dec.id === mainProductId);
      const decorationsSourceId = productDecorations?.decorationsSource ?? mainProductId;
      img1_view1 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view1/r1_silver.png";
      img2_view1 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view1/r2_silver.png";
      img3_view1 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view1/r3_silver.png";
      img4_view1 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view1/r4_silver.png";

      img1_view2 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view2/r1_silver.png";
      img2_view2 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view2/r2_silver.png";
      img3_view2 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view2/r3_silver.png";
      img4_view2 =
        basePath +
        "media/decorations-images/" +
        decorationsSourceId +
        "/rivets/view2/r4_silver.png";

      blank_img =
        basePath +
        "media/decorations-images/" +
        mainProductId +
        "/rivets/blank.png";

      if (brogue1Status == true && brogue2Status == false) {
        //console.log("1 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img1_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1_view2);
      } else if (brogue1Status == false && brogue2Status == true) {
        //console.log("2 true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img4_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img4_view2);
      } else if (brogue1Status == true && brogue2Status == true) {
        //console.log("both true")
        jQuery("#view_1 [decoration=rivet]").attr("src", img2_view1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img2_view2);
      } else if (brogue1Status == false && brogue2Status == false) {
        // console.log("2 false")
        jQuery("#view_1 [decoration=rivet]").attr("src", blank_img);
        jQuery("#view_2 [decoration=rivet]").attr("src", blank_img);
      }
    } else {
      img1 =
        basePath +
        "media/front/product-images/product" +
        mainProductId +
        "/Product_" +
        mainProductId +
        "_Part_" +
        part +
        "_Material_" +
        matId +
        "_Color_" +
        colorId +
        "_View_1.png";
      img2 =
        basePath +
        "media/front/product-images/product" +
        mainProductId +
        "/Product_" +
        mainProductId +
        "_Part_" +
        part +
        "_Material_" +
        matId +
        "_Color_" +
        colorId +
        "_View_2.png";

      jQuery("#view_1 [decoration=rivet]").attr("src", img1);
      jQuery("#view_2 [decoration=rivet]").attr("src", img2);
      jQuery(".views [rel=21]").hide();
      //jQuery("#part_21").show();
    }
  }

  /* if (isRivetsilver)
    {
       
        jQuery("#view_1 [decoration=rivet]").attr("src", img1);
        jQuery("#view_2 [decoration=rivet]").attr("src", img1);
        jQuery(".views [rel=21]").show();
      //jQuery("#part_21").show();
      

    } 
  
  
     else {
      jQuery("#rivetColor input").prop("checked",false)
       
      jQuery("#view_1 [decoration=rivet]").attr("src", blankImg);
        jQuery("#view_2 [decoration=rivet]").attr("src", blankImg);
      jQuery(".views [rel=21]").hide();
       jQuery("#part_21").hide();
    }*/
}

//metal brouge
function addPipingImage(Obj) {
  //var img = basePath + "media/decorations-images/" + mainProductId + "/rivet/";
  var isPipe = jQuery(Obj).prop("checked");

  if (isPipe) {
    jQuery(".views [rel=23]").show();
    jQuery("#part_23").show();
  } else {
    /*jQuery("#view_1 [decoration=rivet]").attr("src", blankImg);
        jQuery("#view_2 [decoration=rivet]").attr("src", blankImg);*/
    jQuery(".views [rel=23]").hide();
    jQuery("#part_23").hide();
  }
}

function checkDecorations(Obj) {
  var isDeco = jQuery(Obj).prop("checked");

  if (isDeco) {
  } else {
    jQuery("#decorations input").prop("checked", false);
  }
}

function getToecapMatcolId() {
  var mate38 = actPartsColorGroup["38"];
  //console.log('mat 38 = ' + mate38);
  return mate38;
}

function getBrogueactColorId() {
  if (
    mainProductId == "1267259905" ||
    mainProductId == "7743501889" ||
    mainProductId == "1357580927062" ||
    mainProductId == "6566222337" ||
    mainProductId == decorations.jane.id ||
    mainProductId == decorations.janePumps.id ||
    mainProductId == decorations.kent.id ||
    mainProductId == decorations.conicKent.id ||
    mainProductId == decorations.astoria.id
  ) {
    //baron//duke//jane//kent

    var mate2 = actPartsColorGroup["29"];
    var attrData = actPartsColorGroup["29"].split("_");
    var mattitle = jQuery("#part_29")
      .find(".selct-material  a[mat-id='" + attrData[0] + "']")
      .attr("titlel");
    var colortitle = jQuery("#part_29")
      .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
      .attr("titlel");
    var broguwmatid = jQuery("#part_20")
      .find(".selct-material  a[titlel='" + mattitle + "']")
      .attr("mat-id");
    return (
      broguwmatid +
      "_" +
      jQuery("#part_20")
        .find(
          ".scaprt-codes [parentid=" +
            broguwmatid +
            "][titlel='" +
            colortitle +
            "']"
        )
        .attr("color-id")
    );
  } else if (
    mainProductId == "2197325185" ||
    mainProductId == "9987925889" ||
    mainProductId == "4219595649" ||
    mainProductId == "4219340353" ||
    mainProductId == "1356909903958" ||
    mainProductId == decorations.regent.id ||
    mainProductId == decorations.burton.id ||
    mainProductId == "1464803201" ||
    mainProductId == "1357577519190"
  ) {
    //limehouse

    var mate2 = actPartsColorGroup["18"];
    var attrData = actPartsColorGroup["18"].split("_");
    var mattitle = jQuery("#part_18")
      .find(".selct-material  a[mat-id='" + attrData[0] + "']")
      .attr("titlel");
    var colortitle = jQuery("#part_18")
      .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
      .attr("titlel");
    var broguwmatid = jQuery("#part_20")
      .find(".selct-material  a[titlel='" + mattitle + "']")
      .attr("mat-id");
    return (
      broguwmatid +
      "_" +
      jQuery("#part_20")
        .find(
          ".scaprt-codes [parentid=" +
            broguwmatid +
            "][titlel='" +
            colortitle +
            "']"
        )
        .attr("color-id")
    );
  } else {
    var mate2 = actPartsColorGroup["17"];
    var attrData = actPartsColorGroup["17"].split("_");
    var mattitle = jQuery("#part_17")
      .find(".selct-material  a[mat-id='" + attrData[0] + "']")
      .attr("titlel");
    var colortitle = jQuery("#part_17")
      .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
      .attr("titlel");
    var broguwmatid = jQuery("#part_20")
      .find(".selct-material  a[titlel='" + mattitle + "']")
      .attr("mat-id");
    return (
      broguwmatid +
      "_" +
      jQuery("#part_20")
        .find(
          ".scaprt-codes [parentid=" +
            broguwmatid +
            "][titlel='" +
            colortitle +
            "']"
        )
        .attr("color-id")
    );
  }
}

function getCapToeActColorId() {
  var mate2 = actPartsColorGroup["29"];
  var attrData = actPartsColorGroup["29"].split("_");
  var mattitle = jQuery("#part_29")
    .find(".selct-material  a[mat-id='" + attrData[0] + "']")
    .attr("titlel");
  var colortitle = jQuery("#part_29")
    .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
    .attr("titlel");
  var toeCapMatId = jQuery("#part_38")
    .find(".selct-material  a[titlel='" + mattitle + "']")
    .attr("mat-id");
  return (
    toeCapMatId +
    "_" +
    jQuery("#part_38")
      .find(
        ".scaprt-codes [parentid=" +
          toeCapMatId +
          "][titlel='" +
          colortitle +
          "']"
      )
      .attr("color-id")
  );
}

function getBrogue2actColorId() {
  if (
    mainProductId == "1464803201" ||
    mainProductId == "1357577519190" ||
    mainProductId == "1362437832790" ||
    mainProductId == "460990265" ||
    mainProductId == "1358365491286" ||
    mainProductId == decorations.conicHolborn.id ||
    mainProductId == "1358467629142" ||
    mainProductId == decorations.regent.id ||
    mainProductId == decorations.burton.id ||
    mainProductId == decorations.aldgate.id ||
    mainProductId == decorations.conicAldgate.id ||
    mainProductId == decorations.florence.id
  ) {
    //limehouse//morgan/lenox/holborn/marry/regent//burton//aldgate//florence

    var mate2 = actPartsColorGroup["29"];
    var attrData = actPartsColorGroup["29"].split("_");
    var mattitle = jQuery("#part_29")
      .find(".selct-material  a[mat-id='" + attrData[0] + "']")
      .attr("titlel");
    var colortitle = jQuery("#part_29")
      .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
      .attr("titlel");
    var broguwmatid = jQuery("#part_28")
      .find(".selct-material  a[titlel='" + mattitle + "']")
      .attr("mat-id");
    // console.log('brogue 3 bromat id== ' + broguwmatid)
    return (
      broguwmatid +
      "_" +
      jQuery("#part_28")
        .find(
          ".scaprt-codes [parentid=" +
            broguwmatid +
            "][titlel='" +
            colortitle +
            "']"
        )
        .attr("color-id")
    );
  } else if (
    mainProductId == "6567881729" ||
    mainProductId == "9987925889" ||
    mainProductId == "4219595649" ||
    mainProductId == "1356909903958"
  ) {
    var mate2 = actPartsColorGroup["18"];
    var attrData = actPartsColorGroup["18"].split("_");
    var mattitle = jQuery("#part_18")
      .find(".selct-material  a[mat-id='" + attrData[0] + "']")
      .attr("titlel");
    var colortitle = jQuery("#part_18")
      .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
      .attr("titlel");
    var broguwmatid = jQuery("#part_28")
      .find(".selct-material  a[titlel='" + mattitle + "']")
      .attr("mat-id");

    return (
      broguwmatid +
      "_" +
      jQuery("#part_28")
        .find(
          ".scaprt-codes [parentid=" +
            broguwmatid +
            "][titlel='" +
            colortitle +
            "']"
        )
        .attr("color-id")
    );
  } else if (mainProductId == "2197325185" || mainProductId == "4219340353") {
    //classon

    var mate2 = actPartsColorGroup["18"];
    var attrData = actPartsColorGroup["18"].split("_");
    var mattitle = jQuery("#part_18")
      .find(".selct-material  a[mat-id='" + attrData[0] + "']")
      .attr("titlel");
    var colortitle = jQuery("#part_18")
      .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
      .attr("titlel");
    var broguwmatid = jQuery("#part_20")
      .find(".selct-material  a[titlel='" + mattitle + "']")
      .attr("mat-id");
    // console.log("broguwmatid = "+broguwmatid+" mattitle = "+mattitle+" colortitle = "+colortitle);
    return (
      broguwmatid +
      "_" +
      jQuery("#part_20")
        .find(
          ".scaprt-codes [parentid=" +
            broguwmatid +
            "][titlel='" +
            colortitle +
            "']"
        )
        .attr("color-id")
    );
  } else {
    var mate2 = actPartsColorGroup["17"];
    var attrData = actPartsColorGroup["17"].split("_");
    var mattitle = jQuery("#part_17")
      .find(".selct-material  a[mat-id='" + attrData[0] + "']")
      .attr("titlel");
    var colortitle = jQuery("#part_17")
      .find(".scaprt-codes  [color-id=" + attrData[1] + "]")
      .attr("titlel");
    var broguwmatid = jQuery("#part_28")
      .find(".selct-material  a[titlel='" + mattitle + "']")
      .attr("mat-id");
    return (
      broguwmatid +
      "_" +
      jQuery("#part_28")
        .find(
          ".scaprt-codes [parentid=" +
            broguwmatid +
            "][titlel='" +
            colortitle +
            "']"
        )
        .attr("color-id")
    );
  }
}

jQuery(document).mouseup(function (e) {
  var container = jQuery(".tool-right-navigation ");
  if (
    !container.is(e.target) && // if the target of the click isn't the container...
    container.has(e.target).length === 0
  ) {
    // nor a descendant of the container
    /* jQuery("#attribute_1").find("ul").slideUp();
        jQuery("#attribute_1").find(".active").removeClass('active');*/
  }

  var shareContainer = jQuery(".modal-dialog");

  if (
    !shareContainer.is(e.target) && // if the target of the click isn't the container...
    shareContainer.has(e.target).length === 0
  ) {
    // nor a descendant of the container
    if (!isShare) {
      jQuery("#customize-tool .page-wrapper").css("height", "100%");
    } else {
      isShare = false;
    }
  } else {
  }
});

function getCustomizedData() {
  var tempArray = {},
    customization = {};
  var attrId, mateId, colId;
  var decorationData;
  var tempOrder = {};

  //Customization data
  jQuery("#attribute_1 > li").each(function (i, ele) {
    if (jQuery(this).attr("id")) {
      attrId = jQuery(this).attr("id").split("_")[1];
      mateId = jQuery(this).find(".climgs img:first").attr("patternid");
      colId = jQuery(this).find(".climgs img:last").attr("colorid");

      if (attrId == "29") {
        // Material 3
        if (jQuery("#part_29").is(":hidden")) {
          // if material 3 is hidden no need to save it
          return;
        }
      }

      //console.log("attrName= "+jQuery(this).find('.attr_list_name').text()+" mateId = "+mateId+" colId = "+colId+" attr")

      /* if(jQuery(this).find('.attr_list_name').text()==''){
           continue;
          }*/
      tempArray["attrId"] = attrId;

      tempArray["attrName"] = jQuery(this).find(".attr_list_name").text(); // matName;//
      tempArray["colId"] = colId;
      tempArray["colorName"] = jQuery(
        ".hideColor a[color-id=" + colId + "]"
      ).attr("titlel");
      tempArray["mateId"] = mateId;
      tempArray["mateName"] = jQuery(
        ".selct-material a[mat-id=" + mateId + "]"
      ).attr("titlel");

      //add lace color data
      if (attrId == "13") {
        tempArray["lace1"] = jQuery(this)
          .find(".climgs img:first")
          .attr("colorname");
        tempArray["lace2"] = jQuery(this)
          .find(".climgs img:last")
          .attr("colorname");

        tempArray["lace1ColId"] = jQuery(this)
          .find(".climgs img:first")
          .attr("colorid");
        tempArray["lace2ColId"] = jQuery(this)
          .find(".climgs img:last")
          .attr("colorid");

        tempArray["lace1MatId"] = jQuery(
          "#part_13 .selct-material li:first"
        ).attr("mat-id"); //39//jQuery(this).find('.climgs img:first').attr('patternid');
        tempArray["lace2MatId"] = jQuery(
          "#part_13 .selct-material li:last"
        ).attr("mat-id"); //"176";//jQuery(this).find('.climgs img:last').attr('patternid');
      }

      if (mainProductId == "4219340353" || mainProductId == "4219595649") {
        //classon /chelsea
        var isRearTab = jQuery('input[name="reartab"]').prop("checked");

        if (attrId == "36") {
          customization[i] = "";
          tempArray = {};
        }
      }

      //end

      customization[i] = tempArray;

      tempArray = {};
    }
  });

  if (mainProductId != "7632957377" || mainProductId != "550440370206") {
    //
    if (
      mainProductId == "1362437832790" ||
      mainProductId == "1358334558294" ||
      mainProductId == "1362437865558" ||
      mainProductId == "460990265"
    ) {
      //morgan/vienna//lenox

      //brouge
      tempOrder = customization[5];

      customization[5] = customization[6];
      customization[6] = tempOrder;

      tempOrder = {};
      tempOrder = customization[8];
      customization[8] = customization[9];
      customization[9] = tempOrder;
    } else if (mainProductId == "1358365491286" || mainProductId == decorations.conicHolborn.id) {
      //holborn

      //brouge
      tempOrder = customization[5];

      customization[5] = customization[6];
      customization[6] = tempOrder;

      tempOrder = {};
      tempOrder = customization[8];
      customization[8] = customization[9];
      customization[9] = tempOrder;

      tempOrder = {};
      tempOrder = customization[8];
      customization[8] = customization[10];
      customization[10] = tempOrder;
    } else if (mainProductId == "6567881729") {
      //madeline
      //brouge
      tempOrder = customization[2];

      customization[2] = customization[3];
      customization[3] = tempOrder;

      tempOrder = {};
      tempOrder = customization[7];
      customization[7] = customization[8];
      customization[8] = tempOrder;
    } else if (
      mainProductId == "1464803201" ||
      mainProductId == "1357577519190" ||
      mainProductId == decorations.kent.id ||
      mainProductId == decorations.conicKent.id
    ) {
      //limehouse

      //brouge
      tempOrder = customization[3];

      customization[3] = customization[6];
      customization[6] = tempOrder;

      tempOrder = customization[4];
      customization[4] = customization[6];
      customization[6] = tempOrder;

      tempOrder = {};
      tempOrder = customization[5];
      customization[5] = customization[6];
      customization[6] = tempOrder;
    } else if (mainProductId == "4219340353") {
      //classon

      tempOrder = customization[2];
      customization[2] = customization[7];
      customization[7] = tempOrder;

      tempOrder = customization[4];
      customization[4] = customization[8];
      customization[8] = tempOrder;

      tempOrder = customization[3];
      customization[3] = customization[6];
      customization[6] = tempOrder;
    } else {
      //brouge
      tempOrder = customization[3];

      customization[3] = customization[5];
      customization[5] = tempOrder;

      tempOrder = {};
      tempOrder = customization[7];
      customization[7] = customization[9];
      customization[9] = tempOrder;

      //end oredre ceck
    }
  }

  if (
    mainProductId == "1357580927062" ||
    mainProductId == "6566222337" ||
    mainProductId == decorations.jane.id ||
    mainProductId == decorations.janePumps.id ||
    mainProductId == decorations.kent.id ||
    mainProductId == decorations.conicKent.id
  ) {
    //baron//duke//jane//kent
    //brouge
    tempOrder = customization[3];

    customization[3] = customization[5];
    customization[5] = tempOrder;

    tempOrder = {};
    tempOrder = customization[4];
    customization[4] = customization[7];
    customization[7] = tempOrder;
  }

  /*//product final images
     var prodFinalImages = {};
     
     jQuery(".viewImg").each(function (i, ele) {
     
     var img = jQuery(this).attr("src").split("?")[0];
     
     prodFinalImages[i] = img;
     });*/

  //product info
  var prodInfo = {};
  var prodName = jQuery("#prodName").text();
  var prodPrice = jQuery("#prodPrice").text();

  prodInfo["name"] = prodName;
  prodInfo["price"] = prodPrice;
  prodInfo["pid"] = mainProductId;
  prodInfo["size"] = jQuery("#sizes option:selected").text();
  prodInfo["customer_id"] = sessionStorage.getItem("customer_id");

  decorationData = getDecorationData();

  customization["decoData"] = decorationData;

  //make sure toe Cap is unchecked in cart
  if(mainProductId == decorations.janePumps.id){
    if(decorationData.toecap == false){
      customization[6].colorName =  undefined;
      customization[6].mateName =  "No";
    }else{
      customization[6].colorName =  "Yes";
    }
  }
  
  return {
    customization: customization,
    prodFinalImages: previewImagesData,
    prodInfo: prodInfo,
    decorationData: decorationData,
  };
}

function loadProductViews() {
  var views = productViews["views"];
  var next;

  jQuery("#views").html("");

  //update info
  jQuery("#prodName").html(currProInfo["name"]);
  jQuery("#prodCat").html(currProInfo["cat"]);
  jQuery("#prodPrice").html(currProInfo["price"]);
  //end

  console.log(views);

  for (var view in views) {
    if (views[view]["id"] == "3") {
      next = "1";
    } else {
      next = parseInt(views[view]["id"]) + 1;
    }

    jQuery("#views").append(
      '<div id="view_' +
        views[view]["id"] +
        '" next="' +
        next +
        '" class="views" ></div>'
    );
    // jQuery("#view_" + views[view]["id"]).append('<img isicon="no"  rel="0"  src="' + basePath + 'media/front/product-images/product' + mainProductId + '/Product_' + mainProductId + '_Innerlining_View_' + views[view]["id"] + '.png" >')

    //view images
    for (var img in views[view]["viewimages"]) {
      if (sessionStorage.getItem("customizeThrough") == "customizeBtn") {
        jQuery("#view_" + views[view]["id"]).append(
          '<img isicon="no" rel="' +
            views[view]["viewimages"][img]["rel"] +
            '" src="' +
            views[view]["viewicons"][img]["actual_image"] +
            '"  style="position:absolute;">'
        );
      } else {
        jQuery("#view_" + views[view]["id"]).append(
          '<img isicon="no" rel="' +
            views[view]["viewimages"][img]["rel"] +
            '" src="' +
            basePath +
            views[view]["viewimages"][img]["src"] +
            '"  style="position:absolute;">'
        );
      }
    }

    //append deco images
    jQuery("#view_" + views[view]["id"]).append(
      '<img  isicon="no"  rel="0" decoration="perforation" src="' +
        blankImg +
        '" >'
    ); //onmouseover="iconHoverIn(this)" onmouseout="iconHoverOut(this)"
    jQuery("#view_" + views[view]["id"]).append(
      '<img  isicon="no"  rel="0" decoration="perforation2" src="' +
        blankImg +
        '" >'
    ); //onmouseover="iconHoverIn(this)" onmouseout="iconHoverOut(this)"
    jQuery("#view_" + views[view]["id"]).append(
      '<img  isicon="no"  rel="0" decoration="rivet" src="' + blankImg + '" >'
    ); //onmouseover="iconHoverIn(this)" onmouseout="iconHoverOut(this)"
    jQuery("#view_" + views[view]["id"]).append(
      '<img  isicon="no"  rel="0" decoration="fringe" src="' + blankImg + '">'
    ); //onmouseover="iconHoverIn(this)" onmouseout="iconHoverOut(this)"
    jQuery("#view_" + views[view]["id"]).append(
      '<img  isicon="no"  rel="0" decoration="piping" src="' + blankImg + '">'
    );

    //append hover images
    for (var img in views[view]["viewicons"]) {
      //console.log("id == = " + views[view]["id"] +  " icon img src of hover default = " + views[view]["viewicons"][img]["isicon"] + " img src of hover default = " + views[view]["viewicons"][img]["src"] + " rel src " + views[view]["viewicons"][img]["rel"] + " default img = " + views[view]["viewicons"][img]["src"] + " hover img = " + views[view]["viewicons"][img]["hover_src"])
      jQuery("#view_" + views[view]["id"]).append(
        '<img width="52" height="52" onmouseover="iconHoverIn(this)" onmouseout="iconHoverOut(this)" isicon="' +
          views[view]["viewicons"][img]["isicon"] +
          '"  onclick="onHoverIconClk(this)" rel="' +
          views[view]["viewicons"][img]["rel"] +
          '" default_img="' +
          views[view]["viewicons"][img]["src"] +
          '" hover_img="' +
          views[view]["viewicons"][img]["hover_src"] +
          '" src="' +
          views[view]["viewicons"][img]["src"] +
          '" style="left:' +
          views[view]["viewicons"][img]["x"] +
          "px;top:" +
          views[view]["viewicons"][img]["y"] +
          'px;position:absolute;cursor:pointer;display:none">'
      ); //onmouseover="iconHoverIn(this)" onmouseout="iconHoverOut(this)"
    }

    //change oreder of eyelet
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=19][isicon='no']")
      .detach()
      .insertAfter("#view_" + views[view]["id"] + " img[rel=17][isicon='no']");

    jQuery("#view_" + views[view]["id"])
      .find("img[rel=19][isicon=no]")
      .insertAfter("#view_" + views[view]["id"] + " img[rel=18][isicon=no]");
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=13][isicon='no']")
      .detach()
      .insertAfter("#view_" + views[view]["id"] + " img[rel=18][isicon='no']");

    //regent
    if (
      mainProductId == decorations.regent.id ||
      mainProductId == decorations.burton.id ||
      mainProductId == decorations.astoria.id
    ) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=19][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=29][isicon=no]");
    }

    //for oddity
    if (
      mainProductId == "4221337537" ||
      mainProductId == "560913252382" ||
      mainProductId == "460972461"
    ) {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=19][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=17][isicon=no]");
    }

    //chnage order of rivet
    jQuery("#view_" + views[view]["id"])
      .find("img[rel=27][isicon=no]")
      .insertAfter(
        "#view_" + views[view]["id"] + " img[decoration='rivet'][isicon=no]"
      );

    //check brouge 2 for hudson
    //for oddity
    if (mainProductId == "1267259905" || mainProductId == "7743501889") {
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=28][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=17][isicon=no]");
    }
    if (mainProductId == "1362437832790") {
      //morgan
    }
    if (mainProductId == "1358467629142") {
      //mary
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=0][isicon=no]:first")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=28][isicon=no]");
    }

    if (mainProductId == "460990265") {
      //lenox//
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=10][isicon=no]")
        .insertBefore("#view_" + views[view]["id"] + " img[rel=28][isicon=no]");
    }
    if (mainProductId == "6566222337") {
      //lenox//
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=10][isicon=no]")
        .insertBefore("#view_" + views[view]["id"] + " img[rel=17][isicon=no]");
    }
    if (mainProductId == "1358365491286" || mainProductId == decorations.conicHolborn.id ) {
      //holborn
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=10][isicon=no]")
        .insertBefore("#view_" + views[view]["id"] + " img[rel=17][isicon=no]");
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=37][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=10][isicon=no]");
    }

    if (mainProductId == decorations.florence.id) {
      //florence
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=28][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=18][isicon=no]");
    }

    if (mainProductId == "1358334558294" || mainProductId == "1362437865558") {
      //Viennal
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=17][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=18][isicon=no]");
    }
    if (mainProductId == "4219340353") {
      //classon
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=33][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=35][isicon=no]");
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=27][isicon=no]")
        .insertBefore("#view_" + views[view]["id"] + " img[rel=35][isicon=no]");
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=36][isicon=no]")
        .insertBefore("#view_" + views[view]["id"] + " img[rel=35][isicon=no]");
    }
    if (mainProductId == "1464803201" || mainProductId == "1357577519190") {
      //limehouse

      jQuery("#view_" + views[view]["id"])
        .find("img[rel=10][isicon=no]")
        .insertBefore("#view_" + views[view]["id"] + " img[rel=29][isicon=no]");
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=28][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=29][isicon=no]");
    }

    if (
      mainProductId == "460991377" ||
      mainProductId == "9978267073" ||
      mainProductId == "1466429441"
    ) {
      //gatsby and gatsby dublicate 1

      jQuery("#view_" + views[view]["id"])
        .find("img[rel=17][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=18][isicon=no]");
      jQuery("#view_" + views[view]["id"])
        .find("img[rel=0][decoration=perforation2]")
        .insertBefore("#view_" + views[view]["id"] + " img[rel=28][isicon=no]");
    }

    if (
      mainProductId == "9987925889" ||
      mainProductId == "4219595649" ||
      mainProductId == "4219340353" ||
      mainProductId == "1356909903958"
    ) {
      //lamont and chelsea//classon

      //console.log("idss of views = " + "#view_" + views[view]["id"])
      if ("#view_" + views[view]["id"] !== "#view_3") {
        jQuery("#view_" + views[view]["id"]).append(
          '<img  isicon="no"  rel="60" decoration="brogue1Lamont" src="' +
            blankImg +
            '" >'
        );
      }
      if (mainProductId == "9987925889" || mainProductId == "1356909903958") {
        //lamont
        jQuery("#view_" + views[view]["id"])
          .find("img[rel=17][isicon=no]")
          .insertAfter(
            "#view_" + views[view]["id"] + " img[rel=18][isicon=no]"
          );
        jQuery("#view_" + views[view]["id"])
          .find("img[rel=60][isicon=no]")
          .insertAfter(
            "#view_" + views[view]["id"] + " img[rel=31][isicon=no]"
          );
      } else if (mainProductId == "4219595649") {
        //chelsea

        jQuery("#view_" + views[view]["id"])
          .find("img[rel=60][isicon=no]")
          .insertAfter(
            "#view_" + views[view]["id"] + " img[rel=31][isicon=no]"
          );
      } else if (mainProductId == "4219340353") {
        //classon
        jQuery("#view_" + views[view]["id"])
          .find("img[rel=60][isicon=no]")
          .insertBefore(
            "#view_" + views[view]["id"] + " img[rel=35][isicon=no]"
          );
        jQuery("#view_" + views[view]["id"])
          .find("img[rel=60][isicon=no]")
          .insertBefore(
            "#view_" + views[view]["id"] + " img[rel=27][isicon=no]"
          );
        jQuery("#view_" + views[view]["id"])
          .find('img[decoration="rivet"]')
          .insertAfter(
            jQuery("#view_" + views[view]["id"]).find("img[rel=60][isicon=no]")
          );
      } else {
      }
    }

    if (mainProductId == "6567881729") {
      //madeline

      jQuery("#view_" + views[view]["id"])
        .find('img[decoration="rivet"]')
        .insertBefore(
          jQuery("#view_" + views[view]["id"]).find("img[rel=35][isicon=no]")
        );
    }

    if (mainProductId == "7632957377") {
      //saratoga

      jQuery("#view_" + views[view]["id"])
        .find("img[rel=17][isicon=no]")
        .insertAfter("#view_" + views[view]["id"] + " img[rel=18][isicon=no]");
    }
  }

  //chnage order of rivet
  jQuery("#view_2")
    .find("img[rel=23][isicon=no]")
    .insertAfter("#view_2 img[rel=17][isicon=no]");

  hideAllViews();
  visibleView();
  hidePatternimg();

  //addClass to views images
  jQuery(".views img[isicon=no]").addClass("colorImage");
  jQuery(".views img[isicon=yes]").addClass("iconImage");

  if (!loaderFlag && !keepLoaderFlag) {
    jQuery(".loading").hide();
    jQuery(".loading1").hide();
    jQuery("header").css("opacity", "1");
    jQuery(".tool-sec").css("opacity", "1");
    jQuery(".tool-img").css("opacity", "1");

    jQuery(".shoe-data-preloader").show();
  }

  window.scrollTo(0, 0);

  loadDefaultColors();
}

function loadDefaultColors() {
  if (!loaderFlag && !keepLoaderFlag) {
    jQuery(".loading").hide();
    jQuery(".loading1").hide();
    jQuery(".shoe-data-preloader").show();
  }

  if (sessionStorage.getItem("customizeThrough") == "customizeBtn") {
  } else {
    //trigger to first color
    jQuery(".scaprt-codes li:visible:first a").trigger("click");
  }

  if (editFlag) {
    //edit

    editFlag = false;
    loaderFlag = true;
    jQuery(".loading").show();
    jQuery("header").css("opacity", "0");
    jQuery(".tool-sec").css("opacity", "0");

    setDefaultActiveColEdit();
  } else {
    loaderFlag = true;

    jQuery(".loading").show();
    jQuery("header").css("opacity", "0");
    jQuery(".tool-sec").css("opacity", "0");

    if (
      mainProductId == decorations.jane.id ||
      mainProductId == decorations.janePumps.id ||
      mainProductId == decorations.regent.id ||
      mainProductId == decorations.burton.id ||
      mainProductId == decorations.astoria.id ||
      mainProductId == decorations.aldgate.id ||
      mainProductId == decorations.conicAldgate.id
    ) {
      setDefaultActiveCol();
    } else {
      //from the custom product list page of client
      if (sessionStorage.getItem("customizeThrough") == "customizeBtn") {
        // this function is called when we click on customize button of shoe
        setDefaultActiveColCustom();
      } else {
        // this function is called when we click on shoe displayed on product list page.
        setDefaultActiveCol();
      }
    }
  }

  //change material order
  sortMatOrder("17");
  sortMatOrder("18");
  sortMatOrder("26");
  sortMatOrder("32");
  checkIfDecoImage();
  updateColorOrder();
}

function onHoverIconClk(actObj) {
  var rel = jQuery(actObj).attr("rel");

  jQuery("#part_" + rel + " .attr_list_name").trigger("click");
}

function hidePatternimg() {
  jQuery("#attribute_1").find(".thumb_pattern_img").hide();

  jQuery("#part_17").find(".thumb_pattern_img").show();
  jQuery("#part_18").find(".thumb_pattern_img").show();
  jQuery("#part_13").find(".thumb_pattern_img").show();
  jQuery("#part_29").find(".thumb_pattern_img").show();
  jQuery("#part_32").find(".thumb_pattern_img").show();
  //jQuery("#part_35").find(".thumb_pattern_img").show();

  jQuery("#part_13")
    .find(".thumb_pattern_img")
    .attr(
      "src",
      "https://juliaboshop.com/media/front/product-color-images/1499151375.png"
    );
}

function createProductNew() {
  var qnt = 1;
  var prod_id = mainProductId;
  if (prod_id != "-1") {
    //fetch the product details

    var shoeSize = jQuery("#sizes option:selected").text();
    var prodImgView1 = previewImagesData.previewImages.image1.src;
    var prodImgView2 = previewImagesData.previewImages.image2.src;
    var prodImgView3 = previewImagesData.previewImages.image3.src;

    var frmData = {
      product_id: prod_id,
      vendor: "Julia Bo Site User",
      product_type: "Shoes",
      shoeSize: shoeSize,
      published: true,
      attachment1: prodImgView1,
      attachment2: prodImgView2,
      attachment3: prodImgView3,
      toolData: previewImagesData,
    };
    var post_url =
      jQuery("#basePath").val() + siteToolUrl + "/create-product-on-shopify";

    jQuery.ajax({
      url: post_url,
      dataType: "json",
      type: "POST",
      data: frmData,
      crossDomain: true,
      success: function (data, textStatus, jqXHR) {
        Shopify.addItem(data.product.variants[0].id, qnt, data.product.id);
      },
    });
  }
}

function buyDesign(actObj) {
  jQuery(".loading1").show();
  jQuery(".loading1").css("position", "fixed");
  jQuery("header").css("opacity", "0.3");
  jQuery(".tool-sec").css("opacity", "0.3");

  var data = {};

  var qnt = 1;
  var prod_id = jQuery(actObj).attr("pid");

  if (prod_id != "-1") {
    //fetch the product details

    var shoeSize = jQuery(actObj).attr("size");
    var prodImgView1 = jQuery(actObj).attr("img1");
    var prodImgView2 = jQuery(actObj).attr("img2");
    var prodImgView3 = jQuery(actObj).attr("img3");

    data["image1"] = prodImgView1;
    data["image2"] = prodImgView2;
    data["image3"] = prodImgView3;
    var price = jQuery("#prodPrice").text();

    var frmData = {
      product_id: prod_id,
      vendor: "Julia Bo Site User",
      product_type: price,
      shoeSize: shoeSize,
      published: true,
      attachment1: prodImgView1,
      attachment2: prodImgView2,
      attachment3: prodImgView3,
      toolData: data,
    }; //
    var post_url =
      jQuery("#basePath").val() + siteToolUrl + "/create-product-on-shopify";
    jQuery.ajax({
      url: post_url,
      dataType: "json",
      type: "POST",
      data: frmData,
      crossDomain: true,
      success: function (data, textStatus, jqXHR) {
        Shopify.addItem(data.product.variants[0].id, qnt, data.product.id);
      },
    });
  }
}

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------
Shopify.addItem = function (variant_id, qty, product_id, isRetry = false) {
  setTimeout(function() {
    const quantity = qty || 1;
    const payload = {items: [{
        id: variant_id,
        quantity,
      }]}
  
    fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
      body: JSON.stringify(payload)
    })
    .then(response => {
      console.log("item added to cart")
      response.json().then((cart) => {
        console.log(cart);
        if(cart?.items?.length < 1) {
          Shopify.addItem(variant_id, quantity, product_id, true);
          return;
        }
        window.location.href = `${Shopify?.routes?.root ?? ''}cart`;  
      })
    })
    .catch((error) => {
      if(!isRetry){
          console.log("Waiting for retry");
          setTimeout(function() {
            console.log("Retrying");
            Shopify.addItem(variant_id, quantity, product_id, true);
          }, 2000);
          return;
        }
      console.error(error);
      console.error(textStatus)
    });
  },200)
  
};

jQuery(window).load(function () {
  return false;
  jQuery(document).trigger("mouseup");

  setTimeout(function () {
    jQuery(".loading").hide();
    jQuery("header").css("opacity", "1");
    jQuery(".tool-sec").css("opacity", "1");
    jQuery(".tool-img").css("opacity", "1");
  }, 1000);
});
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

function handleDecoration() {
  for (var deco in decorations) {
    if (decorations[deco]["id"] == mainProductId) {
      if (decorations[deco]["perforation"] == "0") {
        jQuery("input[name='perforation']")
          .parents(".holder")
          .parent()
          .parent()
          .hide();
      }

      //brogue
      if (decorations[deco]["broguing"] == "0") {
        jQuery("input[name='brogue']")
          .parents(".holder")
          .parent()
          .parent()
          .hide();
      }

      //brogue
      if (decorations[deco]["broguing2"] == "0") {
        jQuery("input[name='brogue2']")
          .parents(".holder")
          .parent()
          .parent()
          .hide();
      }

      //rivet
      if (decorations[deco]["rivet"] == "0") {
        jQuery("input[name='rivet']")
          .parents(".holder")
          .parent()
          .parent()
          .hide();
        jQuery("#rivetColorHolder").hide();
      } else {
        jQuery(".views [rel=21]").hide();
        jQuery("#part_21").hide();
      }

      //piping
      if (decorations[deco]["piping"] == "0") {
        jQuery("input[name='piping']")
          .parents(".holder")
          .parent()
          .parent()
          .hide();
      } else {
        jQuery(".views [rel=23]").hide();
        jQuery("#part_23").hide();
      }

      //fringe
      if (decorations[deco]["fringe"] == "0") {
        jQuery("input[name='fringe']")
          .parents(".holder")
          .parent()
          .parent()
          .hide();
      } else {
        jQuery(".views [rel=26]").hide();
        jQuery("#part_26").hide();
      }
    }
  }
}

function getDecorationData() {
  var data = {};

  for (var deco in decorations) {
    if (decorations[deco]["id"] == mainProductId) {
      if (decorations[deco]["perforation"] != "0") {
        data["perforation_option1"] = jQuery("input[name='perforation']").prop(
          "checked"
        );
        data[ mainProductId == decorations.astoria.id ? "brogue2" : "perforation_option2"] = jQuery("input[name='perforation2']").prop(
          "checked"
        );

        //done
      }

      //brogue
      if (decorations[deco]["broguing"] != "0") {
        data["brogue"] = jQuery("input[name='brouge']").prop("checked");
        //done
      }

      //brogue 2
      if (decorations[deco]["broguing2"] != "0") {
        data[mainProductId == decorations.astoria.id ? "perforation_option2" : "brogue2"] = jQuery("input[name='brouge2']").prop("checked");
        //done
      }

      //rivet
      if (decorations[deco]["rivet"] != "0") {
        if( mainProductId != decorations.astoria.id || jQuery("input[name='brouge']").prop("checked")) {
          data["rivetgold"] = jQuery("input[name='rivetgold']").prop("checked");
          data["rivetsilver"] = jQuery("input[name='rivetsilver']").prop(
            "checked"
            );
          }else {
            data["rivetgold"] = false;
            data["rivetsilver"] = false;
          }

        //done
      }

      //piping
      if (decorations[deco]["piping"] != "0") {
        data["piping"] = jQuery("input[name='piping']").prop("checked");
        //done
      }

      //fringe
      if (decorations[deco]["fringe"] != "0") {
        data["fringe"] = jQuery("input[name='fringe']").prop("checked");
        //done
      } else if (jQuery("input[name=fringe]").get(0)) {
        data["fringe"] = jQuery("input[name=fringe]").prop("checked");
      }

      //eyelet

      if (jQuery("input[name=eyelet]").get(0)) {
        data["eyelet"] = jQuery("input[name=eyelet]").prop("checked");
      }

      //zipper

      if (jQuery("input[name=zipper]").get(0)) {
        data["zipper"] = jQuery("input[name=zipper]").prop("checked");
      }

      //strap

      if (jQuery("input[name=strap]").get(0)) {
        data["strap"] = jQuery("input[name=strap]").prop("checked");
        data["buckle"] = jQuery("input[name=strap]").prop("checked");
      }

      //reartab

      if (jQuery("input[name=reartab]").get(0)) {
        data["reartab"] = jQuery("input[name=reartab]").prop("checked");
      }

      //toecap

      if (jQuery("input[name=toecap]").get(0)) {
        data["toecap"] = jQuery("input[name=toecap]").prop("checked");
      }

      //buckle

      if (
        mainProductId == "1357580927062" ||
        mainProductId == "6566222337" ||
        mainProductId == "1358467629142" ||
        mainProductId == decorations.jane.id ||
        mainProductId == decorations.janePumps.id ||
        mainProductId == decorations.joplin.id ||
        mainProductId == decorations.joplinPumps.id
      ) {
        //baron//duke//mary//jane//joplin
        if (jQuery("a[titlel=buckle]").get(0)) {
          data["buckle"] = true;
        }
      }
    }
  }

  return data;
}

function getColorImg(partId, colorId, matId) {
  //  console.log("partId = " + partId + " col id = " + colorId + " mat id = " + matId)

  jQuery("#part_" + partId + " a").trigger("click");

  jQuery("#part_" + partId + " a[mat-id=" + matId + "]").trigger("click");

  jQuery("#part_" + partId + " a[color-id=" + colorId + "]").trigger("click");

  var img = jQuery("#part_" + partId)
    .find("[color-id=" + colorId + "] img")
    .attr("src");

  jQuery("#part_" + partId)
    .find(".thumb_color_img")
    .attr("src", img);
  jQuery("#part_" + partId)
    .find(".thumb_color_img")
    .attr("colorid", colorId);
}

function showSizeInfo() {
  openModal("sizeInfo");
}

function showShippingInfo() {
  openModal("shippingInfo");
}

function showReturnPolicy() {
  openModal("returnPolicy");
}

function openModal(id) {
  // VERY IMPORTANT: Must user $j, otherwise, if I use jQuery it won't work in Shopify
  closeModals();
  // Set timeout because close and open overlaps
  setTimeout(() => $j("#" + id).modal("show"), 500);
}

function closeModals() {
  // VERY IMPORTANT: Must user $j, otherwise, if I use jQuery it won't work in Shopify
  $j(".modal").modal("hide");
}

var isShare;
function shareDesign(actObj) {
  isShare = true;
  designImageId = jQuery(actObj).prev().prev().attr("design_image_id");

  var x = jQuery("#myCustomerAccount").css("height");
  //var y = parseInt(x, 10);

  jQuery("#customize-tool .page-wrapper").css("height", x);

  setTimeout(function () {
    jQuery("#ShareAcc").modal("show");
  });
}

var design_image_id = 0;
function editCustomizedShoes(actObj) {
  //alert('editcustomized shoes')

  var prod_id = jQuery(actObj).next().attr("pid");

  design_image_id = jQuery(actObj).attr("design_image_id");
  var customizeData = getCustomizationDataofProd(prod_id);

  editFlag = true;

  //

  jQuery("#shoes-container").hide();
  jQuery("#shoes-list").show();
  //jQuery("meta[name='viewport']").hide();

  jQuery("#customize-tool").removeClass("customize-tool-main");
  jQuery("#myCustomerAccount").hide();

  jQuery(".product-holder li[product_id=" + prod_id + "]").trigger("click");

  ///

  /*for(var cust in customizeData)
  {
     var attrId = customizeData[cust].attrId;
     var colId = customizeData[cust].colId;
     var matId = customizeData[cust].mateId;
    
     console.log("d = "+customizeData[cust].attrId+" colid = ");
    
     actPartsColorGroup[attrId]=matId+"_"+colId;
     jQuery("[color-id="+colId+"]").parent().addClass("actColor"); 
     getColorImg(attrId,colId);
   
  }*/
}

function getCustomizationDataofProd(prod_id) {
  //alert('hiiiii')
  for (var data in allMyAccountData["arr_design_data"]) {
    if (
      allMyAccountData["arr_design_data"][data].product_id == prod_id &&
      allMyAccountData["arr_design_data"][data].design_image_id ==
        design_image_id
    ) {
      return allMyAccountData["arr_design_data"][data].custom_design_json;
    }
  }
}

function sortMatOrder(matId) {
  jQuery("#part_" + matId + " .inter-design-way .selct-material")
    .find("li[titlelm='croc print leather']")
    .insertAfter(
      "#part_" + matId + " .inter-design-way li[titlelm='velvet leather']"
    );
  jQuery("#part_" + matId + " .inter-design-way .selct-material")
    .find("li[titlelm='patent leather']")
    .insertAfter(
      "#part_" + matId + " .inter-design-way li[titlelm='croc print leather']"
    );
  jQuery("#part_" + matId + " .inter-design-way .selct-material")
    .find("li[titlelm='aged leather']")
    .insertAfter(
      "#part_" + matId + " .inter-design-way li[titlelm='patent leather']"
    );
  jQuery("#part_" + matId + " .inter-design-way .selct-material")
    .find("li[titlelm='nubuk leather']")
    .insertAfter(
      "#part_" + matId + " .inter-design-way li[titlelm='aged leather']"
    );
  jQuery("#part_" + matId + " .inter-design-way .selct-material")
    .find("li[titlelm='fabrics']")
    .insertAfter(
      "#part_" + matId + " .inter-design-way li[titlelm='nubuk leather']"
    );
  jQuery("#part_" + matId + " .inter-design-way .selct-material")
    .find("li[titlelm='fabric']")
    .insertAfter(
      "#part_" + matId + " .inter-design-way li[titlelm='nubuk leather']"
    );
}

function activeInput(actObj) {
  var flg = jQuery(actObj).find("input").prop("checked");

  if (!flg) {
    jQuery(actObj).find("input").prop("checked", true);
  }
}

function setLace1Active() {
  var matId, colorId;

  matId = jQuery("#part_13 .selct-material a:first").attr("mat-id");
  colorId = jQuery("#part_13 .thumb_pattern_img").attr("colorid");

  if (colorId) {
    var imgPath1 =
      basePath +
      "media/front/product-images/product" +
      mainProductId +
      "/Product_" +
      mainProductId +
      "_Part_13_Material_" +
      matId +
      "_Color_" +
      colorId +
      "_View_1.png";
    var imgPath2 =
      basePath +
      "media/front/product-images/product" +
      mainProductId +
      "/Product_" +
      mainProductId +
      "_Part_13_Material_" +
      matId +
      "_Color_" +
      colorId +
      "_View_2.png";

    jQuery("#view_1 [rel=13][isicon='no']").attr("src", imgPath1);
    jQuery("#view_2 [rel=13][isicon='no']").attr("src", imgPath2);
  }
}

function setDefaultActiveLace1() {
  /// trigger to lace 1

  if (
    jQuery("#part_13 [titlelm='laces 1']").children().length > 0 &&
    !jQuery("#part_13 [titlelm='laces 1'] a").hasClass("actMaterial")
  ) {
    jQuery("#part_13 [titlelm='laces 1'] a").trigger("click");

    setLace1Active();
  }
}

function getMaterialDescription(name) {
  for (var mat in matrialDescrip["matrialDescrip"]) {
    // console.log("name 222 == == " + name);
    if (matrialDescrip["matrialDescrip"][mat]["name"] == name) {
      return matrialDescrip["matrialDescrip"][mat]["descrip"];
    }
  }
}
